webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(22);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _elementUi = __webpack_require__(854);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _vueResource = __webpack_require__(1036);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueRouter = __webpack_require__(1037);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vuebars = __webpack_require__(1039);
	
	var _vuebars2 = _interopRequireDefault(_vuebars);
	
	var _vueEventCalendar = __webpack_require__(928);
	
	var _vueEventCalendar2 = _interopRequireDefault(_vueEventCalendar);
	
	var _routes = __webpack_require__(478);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(479);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vueAnimateNumber = __webpack_require__(926);
	
	var _vueAnimateNumber2 = _interopRequireDefault(_vueAnimateNumber);
	
	var _vueGmaps = __webpack_require__(929);
	
	var _vueGmaps2 = _interopRequireDefault(_vueGmaps);
	
	var _vuelayers = __webpack_require__(1046);
	
	var _vuelayers2 = _interopRequireDefault(_vuelayers);
	
	var _vCharts = __webpack_require__(925);
	
	var _vCharts2 = _interopRequireDefault(_vCharts);
	
	var _App = __webpack_require__(930);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(869);
	
	__webpack_require__(871);
	
	__webpack_require__(872);
	
	__webpack_require__(870);
	
	__webpack_require__(880);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.http.options.emulateJSON = true;
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_elementUi2.default);
	_vue2.default.use(_vuebars2.default);
	_vue2.default.use(_vueEventCalendar2.default, { locale: 'en' });
	_vue2.default.use(_vueAnimateNumber2.default);
	_vue2.default.use(_vueGmaps2.default, {
	  key: 'AIzaSyCpr35b_ZSoP8nbz0VnBjVz6ABb7iurRCU',
	  libraries: ['places'],
	  version: '3'
	});
	_vue2.default.use(_vuelayers2.default);
	_vue2.default.use(_vCharts2.default);
	
	var router = new _vueRouter2.default({
	  routes: _routes2.default,
	  mode: 'hash',
	  linkActiveClass: 'open active',
	  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	    return savedPosition || { x: 0, y: 0 };
	  }
	});
	
	if (window.localStorage) {
	  if (_store2.default.state.token !== window.localStorage.getItem('token')) {
	    _store2.default.commit('SET_TOKEN', window.localStorage.getItem('token'));
	  }
	}
	
	new _vue2.default({
	  el: '#app',
	  router: router,
	  store: _store2.default,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});
	
	__webpack_require__(542);
	
	__webpack_require__(452);
	__webpack_require__(453);
	__webpack_require__(454);

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dashboard = __webpack_require__(931);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Index = __webpack_require__(955);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _ = __webpack_require__(952);
	
	var _2 = _interopRequireDefault(_);
	
	var _Index3 = __webpack_require__(978);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _Buttons = __webpack_require__(970);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _General = __webpack_require__(972);
	
	var _General2 = _interopRequireDefault(_General);
	
	var _Icons = __webpack_require__(973);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	var _Modals = __webpack_require__(974);
	
	var _Modals2 = _interopRequireDefault(_Modals);
	
	var _Sliders = __webpack_require__(975);
	
	var _Sliders2 = _interopRequireDefault(_Sliders);
	
	var _Timeline = __webpack_require__(976);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _FormRadio = __webpack_require__(959);
	
	var _FormRadio2 = _interopRequireDefault(_FormRadio);
	
	var _FormCheckbox = __webpack_require__(957);
	
	var _FormCheckbox2 = _interopRequireDefault(_FormCheckbox);
	
	var _FormInput = __webpack_require__(958);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormSelect = __webpack_require__(960);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _FormCascader = __webpack_require__(956);
	
	var _FormCascader2 = _interopRequireDefault(_FormCascader);
	
	var _FormSwitch = __webpack_require__(962);
	
	var _FormSwitch2 = _interopRequireDefault(_FormSwitch);
	
	var _VueBar = __webpack_require__(948);
	
	var _VueBar2 = _interopRequireDefault(_VueBar);
	
	var _ChartJs = __webpack_require__(945);
	
	var _ChartJs2 = _interopRequireDefault(_ChartJs);
	
	var _ChartBar = __webpack_require__(944);
	
	var _ChartBar2 = _interopRequireDefault(_ChartBar);
	
	var _ChartPie = __webpack_require__(947);
	
	var _ChartPie2 = _interopRequireDefault(_ChartPie);
	
	var _FormSlider = __webpack_require__(961);
	
	var _FormSlider2 = _interopRequireDefault(_FormSlider);
	
	var _FormTimePicker = __webpack_require__(963);
	
	var _FormTimePicker2 = _interopRequireDefault(_FormTimePicker);
	
	var _Mail = __webpack_require__(939);
	
	var _Mail2 = _interopRequireDefault(_Mail);
	
	var _DashboardSecond = __webpack_require__(954);
	
	var _DashboardSecond2 = _interopRequireDefault(_DashboardSecond);
	
	var _Chat = __webpack_require__(937);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _Calendar = __webpack_require__(936);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _ToDo = __webpack_require__(943);
	
	var _ToDo2 = _interopRequireDefault(_ToDo);
	
	var _BlogList = __webpack_require__(934);
	
	var _BlogList2 = _interopRequireDefault(_BlogList);
	
	var _BlogDetails = __webpack_require__(933);
	
	var _BlogDetails2 = _interopRequireDefault(_BlogDetails);
	
	var _BlogMansory = __webpack_require__(935);
	
	var _BlogMansory2 = _interopRequireDefault(_BlogMansory);
	
	var _ShopHome = __webpack_require__(941);
	
	var _ShopHome2 = _interopRequireDefault(_ShopHome);
	
	var _ShopItem = __webpack_require__(942);
	
	var _ShopItem2 = _interopRequireDefault(_ShopItem);
	
	var _BlankPage = __webpack_require__(949);
	
	var _BlankPage2 = _interopRequireDefault(_BlankPage);
	
	var _Invoice = __webpack_require__(950);
	
	var _Invoice2 = _interopRequireDefault(_Invoice);
	
	var _Profile = __webpack_require__(951);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _Login = __webpack_require__(932);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _3 = __webpack_require__(953);
	
	var _4 = _interopRequireDefault(_3);
	
	var _SimpleTable = __webpack_require__(966);
	
	var _SimpleTable2 = _interopRequireDefault(_SimpleTable);
	
	var _SelectTable = __webpack_require__(965);
	
	var _SelectTable2 = _interopRequireDefault(_SelectTable);
	
	var _ExpandableTable = __webpack_require__(964);
	
	var _ExpandableTable2 = _interopRequireDefault(_ExpandableTable);
	
	var _Editor = __webpack_require__(971);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _Upload = __webpack_require__(977);
	
	var _Upload2 = _interopRequireDefault(_Upload);
	
	var _Gmap = __webpack_require__(938);
	
	var _Gmap2 = _interopRequireDefault(_Gmap);
	
	var _ChartMap = __webpack_require__(946);
	
	var _ChartMap2 = _interopRequireDefault(_ChartMap);
	
	var _OpenLayer = __webpack_require__(940);
	
	var _OpenLayer2 = _interopRequireDefault(_OpenLayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = [{
	  path: '/',
	  component: _Dashboard2.default,
	  meta: { requiresAuth: true },
	  beforeEnter: function beforeEnter(to, from, next) {
	    document.body.className += 'skin-dark sidebar-mini';
	    next();
	  },
	  activate: function activate() {
	    this.$nextTick(function () {
	      alert('test');
	    });
	  },
	  children: [{
	    path: '',
	    name: 'dashboard',
	    component: _Index2.default
	  }, {
	    path: '/login',
	    name: 'login',
	    component: _Login2.default
	  }, {
	    path: '/dashboard',
	    name: 'dashboard-first',
	    component: _Index2.default
	  }, {
	    path: '/dashboard-second',
	    name: 'dashboard-second',
	    component: _DashboardSecond2.default
	  }, {
	    path: '/chat',
	    name: 'chat',
	    component: _Chat2.default
	  }, {
	    path: '/calendar',
	    name: 'calendar',
	    component: _Calendar2.default
	  }, {
	    path: '/todo',
	    name: 'todo',
	    component: _ToDo2.default
	  }, {
	    path: '/blog-list',
	    name: 'blog-list',
	    component: _BlogList2.default
	  }, {
	    path: '/blog-details',
	    name: 'blog-details',
	    component: _BlogDetails2.default
	  }, {
	    path: '/blog-mansory',
	    name: 'blog-mansory',
	    component: _BlogMansory2.default
	  }, {
	    path: '/shop-home',
	    name: 'shop-home',
	    component: _ShopHome2.default
	  }, {
	    path: '/shop-item',
	    name: 'shop-item',
	    component: _ShopItem2.default
	  }, {
	    path: '/invoice',
	    name: 'invoice',
	    component: _Invoice2.default
	  }, {
	    path: '/widgets',
	    name: 'widgets',
	    component: _Index4.default
	  }, {
	    path: '/mail',
	    name: 'mail',
	    component: _Mail2.default
	  }, {
	    path: '/blank-page',
	    name: 'blank-page',
	    component: _BlankPage2.default
	  }, {
	    path: '/profile',
	    name: 'profile',
	    component: _Profile2.default
	  }, {
	    path: '/404',
	    name: '404-eror',
	    component: _2.default
	  }, {
	    path: '/500',
	    name: '500',
	    component: _4.default
	  }, {
	    path: '/simple-table',
	    name: 'simple-table',
	    component: _SimpleTable2.default
	  }, {
	    path: '/select-table',
	    name: 'select-table',
	    component: _SelectTable2.default
	  }, {
	    path: '/expandable-table',
	    name: 'expandable-table',
	    component: _ExpandableTable2.default
	  }, {
	    path: '/ui/buttons',
	    name: 'ui-buttons',
	    component: _Buttons2.default
	  }, {
	    path: '/ui/ui-editor',
	    name: 'ui-editor',
	    component: _Editor2.default
	  }, {
	    path: '/ui/general',
	    name: 'ui-general',
	    component: _General2.default
	  }, {
	    path: '/ui/icons',
	    name: 'ui-icons',
	    component: _Icons2.default
	  }, {
	    path: '/ui/modals',
	    name: 'ui-modals',
	    component: _Modals2.default
	  }, {
	    path: '/ui/sliders',
	    name: 'ui-sliders',
	    component: _Sliders2.default
	  }, {
	    path: '/ui/timeline',
	    name: 'ui-timeline',
	    component: _Timeline2.default
	  }, {
	    path: '/form/radio',
	    name: 'form-radio',
	    component: _FormRadio2.default
	  }, {
	    path: '/form/checkbox',
	    name: 'form-checkbox',
	    component: _FormCheckbox2.default
	  }, {
	    path: '/form/input',
	    name: 'form-input',
	    component: _FormInput2.default
	  }, {
	    path: '/form/select',
	    name: 'form-select',
	    component: _FormSelect2.default
	  }, {
	    path: '/ui/ui-upload',
	    name: 'ui-upload',
	    component: _Upload2.default
	  }, {
	    path: '/form/cascader',
	    name: 'form-cascader',
	    component: _FormCascader2.default
	  }, {
	    path: '/chart-pie',
	    name: 'chart-pie',
	    component: _ChartPie2.default
	  }, {
	    path: '/form/switch',
	    name: 'form-switch',
	    component: _FormSwitch2.default
	  }, {
	    path: '/form/slider',
	    name: 'form-slider',
	    component: _FormSlider2.default
	  }, {
	    path: '/form/timepicker',
	    name: 'form-timepicker',
	    component: _FormTimePicker2.default
	  }, {
	    path: '/chart/vuebar',
	    name: 'chart-vuebar',
	    component: _VueBar2.default
	  }, {
	    path: '/chart/chartjs',
	    name: 'chartjs',
	    component: _ChartJs2.default
	  }, {
	    path: '/chart-bar',
	    name: 'chart-bar',
	    component: _ChartBar2.default
	  }, {
	    path: '/gmap',
	    name: 'gmap',
	    component: _Gmap2.default
	  }, {
	    path: '/open-layer',
	    name: 'open-layer',
	    component: _OpenLayer2.default
	  }, {
	    path: '/chart/chart-map',
	    name: 'chart-map',
	    component: _ChartMap2.default
	  }, {
	    path: '*',
	    name: '404',
	    component: _2.default
	  }]
	}];
	
	exports.default = routes;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(22);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(1226);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  token: null
	};
	
	var mutations = {
	  SET_TOKEN: function SET_TOKEN(state, token) {
	    state.token = token;
	  },
	  REMOVE_TOKEN: function REMOVE_TOKEN(state) {
	    state.token = null;
	  }
	};
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  mutations: mutations
	});

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'App'
	};

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Sidebar = __webpack_require__(982);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Header = __webpack_require__(981);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(980);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ControlSidebar = __webpack_require__(979);
	
	var _ControlSidebar2 = _interopRequireDefault(_ControlSidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Dashboard',
	  components: {
	    'app-sidebar': _Sidebar2.default,
	    'app-header': _Header2.default,
	    'app-footer': _Footer2.default,
	    'control-sidebar': _ControlSidebar2.default
	  }
	};

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      dialogVisible: false
	    };
	  },
	  methods: {
	    handleClose: function handleClose(done) {
	      this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
	        confirmButtonText: 'OK',
	        cancelButtonText: 'Cancel',
	        type: 'warning'
	      });
	    }
	  }
	};

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'BlogDetails'
	};

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'BlogList'
	};

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'BlogMansory'
	};

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Calendar',
	  data: function data() {
	    return {
	      demoEvents: [{
	        date: '2017/12/15',
	        title: 'FooFighter',
	        desc: 'Conser Music'
	      }, {
	        date: '2017/11/12',
	        desc: 'Conser Music',
	        title: 'Bar'
	      }, {
	        date: '2017/10/3',
	        desc: 'Conser Music',
	        title: 'Bar'
	      }]
	    };
	  }
	};

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Chat'
	};

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      msg: 'Search places and address using Google Maps API',
	      vm: {
	        searchPlace: '',
	        location: {}
	      }
	    };
	  }
	};

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Mail',
	  data: function data() {
	    return {
	      input: '',
	      num1: 1
	    };
	  }
	};

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      msg: 'Search places and address using Google Maps API',
	      vm: {
	        searchPlace: '',
	        location: {}
	      }
	    };
	  }
	};

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ShopHome'
	};

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ShopItem'
	};

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sweetalert = __webpack_require__(361);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _TodoList = __webpack_require__(969);
	
	var _TodoList2 = _interopRequireDefault(_TodoList);
	
	var _CreateTodo = __webpack_require__(967);
	
	var _CreateTodo2 = _interopRequireDefault(_CreateTodo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ToDo',
	  components: {
	    TodoList: _TodoList2.default,
	    CreateTodo: _CreateTodo2.default
	  },
	  data: function data() {
	    return {
	      todos: [{
	        title: 'Bug Fixed V 1.0.4',
	        project: 'Are we meeting today? Project has been already finished and I have results to show you.',
	        done: true
	      }, {
	        title: 'Udate Notification',
	        project: 'Used to show feedback after an activity. The difference with Notification is that the latter is often used to show a system level passive notification',
	        done: true
	      }, {
	        title: 'Radio Function',
	        project: 'Radio should not have too many options. Otherwise, use the Select component instead',
	        done: false
	      }, {
	        title: 'Table fix',
	        project: 'Display multiple data with similar format. You can sort, filter, compare your data in a table.',
	        done: false
	      }]
	    };
	  },
	  methods: {
	    createTodo: function createTodo(newTodo) {
	      this.todos.push(newTodo);
	      (0, _sweetalert2.default)('Success!', 'To-Do created!', 'success');
	    }
	  }
	};

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  created: function created() {
	    this.chartData = {
	      columns: ['One', 'Samsung', 'Apple'],
	      rows: [{ 'One': '1', 'Samsung': 123, 'Apple': 300 }, { 'One': '2', 'Samsung': 1223, 'Apple': 600 }, { 'One': '3', 'Samsung': 2123, 'Apple': 9000 }, { 'One': '4', 'Samsung': 4123, 'Apple': 1200 }, { 'One': '5', 'Samsung': 3123, 'Apple': 1500 }, { 'One': '6', 'Samsung': 7123, 'Apple': 2000 }]
	    };
	    this.chartSettings = {
	      legendName: {
	        'Samsung': 'Samsung'
	      }
	    };
	  }
	};

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  created: function created() {
	    this.chartData = {
	      columns: ['One', 'Two', 'three', 'four', 'five'],
	      rows: [{ 'One': '1月1日', 'Two': 1523, 'three': 1523, 'four': 0.12, 'five': 100 }, { 'One': '1月2日', 'Two': 1223, 'three': 1523, 'four': 0.345, 'five': 100 }, { 'One': '1月3日', 'Two': 2123, 'three': 1523, 'four': 0.7, 'five': 100 }, { 'One': '1月4日', 'Two': 4123, 'three': 1523, 'four': 0.31, 'five': 100 }, { 'One': '1月5日', 'Two': 3123, 'three': 1523, 'four': 0.12, 'five': 100 }, { 'One': '1月6日', 'Two': 7123, 'three': 1523, 'four': 0.65, 'five': 100 }]
	    };
	    this.chartSettings = {
	      stack: { '售价': ['Two', 'three'] },
	      area: true
	    };
	  }
	};

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  created: function created() {
	    this.chartData = {
	      columns: ['grow', 'GDP']
	    };
	    this.chartSettings = {
	      position: 'world',
	      label: false,
	      itemStyle: {
	        normal: {
	          borderColor: '#fff'
	        }
	      },
	      zoom: 0.8
	    };
	  }
	};

/***/ }),

/***/ 497:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  created: function created() {
	    this.chartData = {
	      columns: ['Apple', 'Samsung', 'Others'],
	      rows: [{ 'Apple': '1月1号', 'Samsung': 123, 'Others': 3 }, { 'Apple': '1月2号', 'Samsung': 1223, 'Others': 6 }, { 'Apple': '1月3号', 'Samsung': 2123, 'Others': 90 }, { 'Apple': '1月4号', 'Samsung': 4123, 'Others': 12 }, { 'Apple': '1月5号', 'Samsung': 3123, 'Others': 15 }, { 'Apple': '1月6号', 'Samsung': 7123, 'Others': 20 }]
	    };
	    this.chartSettings = {
	      dimension: 'Samsung',
	      metrics: 'Others'
	    };
	  }
	};

/***/ }),

/***/ 498:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'FormSwitch',
	  data: function data() {
	    return {
	      value1: true,
	      value2: true,
	      value3: false,
	      value4: false,
	      value5: '100'
	    };
	  }
	};

/***/ }),

/***/ 499:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'BlankPage'
	};

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Invoice'
	};

/***/ }),

/***/ 501:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Profile'
	};

/***/ }),

/***/ 502:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'NotFound'
	};

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'NotFoundSecond'
	};

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DashboardSecond'
	};

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'dashboard-first'
	};

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'FormInput',
	  data: function data() {
	    return {
	      options: [{
	        value: 'guide',
	        label: 'Guide',
	        children: [{
	          value: 'disciplines',
	          label: 'Disciplines',
	          children: [{
	            value: 'consistency',
	            label: 'Consistency'
	          }, {
	            value: 'feedback',
	            label: 'Feedback'
	          }, {
	            value: 'efficiency',
	            label: 'Efficiency'
	          }, {
	            value: 'controllability',
	            label: 'Controllability'
	          }]
	        }, {
	          value: 'navigation',
	          label: 'Navigation',
	          children: [{
	            value: 'side nav',
	            label: 'Side Navigation'
	          }, {
	            value: 'top nav',
	            label: 'Top Navigation'
	          }]
	        }]
	      }, {
	        value: 'component',
	        label: 'Component',
	        children: [{
	          value: 'basic',
	          label: 'Basic',
	          children: [{
	            value: 'layout',
	            label: 'Layout'
	          }, {
	            value: 'color',
	            label: 'Color'
	          }, {
	            value: 'typography',
	            label: 'Typography'
	          }, {
	            value: 'icon',
	            label: 'Icon'
	          }, {
	            value: 'button',
	            label: 'Button'
	          }]
	        }, {
	          value: 'form',
	          label: 'Form',
	          children: [{
	            value: 'radio',
	            label: 'Radio'
	          }, {
	            value: 'checkbox',
	            label: 'Checkbox'
	          }, {
	            value: 'input',
	            label: 'Input'
	          }, {
	            value: 'input-number',
	            label: 'InputNumber'
	          }, {
	            value: 'select',
	            label: 'Select'
	          }, {
	            value: 'cascader',
	            label: 'Cascader'
	          }, {
	            value: 'switch',
	            label: 'Switch'
	          }, {
	            value: 'slider',
	            label: 'Slider'
	          }, {
	            value: 'time-picker',
	            label: 'TimePicker'
	          }, {
	            value: 'date-picker',
	            label: 'DatePicker'
	          }, {
	            value: 'datetime-picker',
	            label: 'DateTimePicker'
	          }, {
	            value: 'upload',
	            label: 'Upload'
	          }, {
	            value: 'rate',
	            label: 'Rate'
	          }, {
	            value: 'form',
	            label: 'Form'
	          }]
	        }, {
	          value: 'data',
	          label: 'Data',
	          children: [{
	            value: 'table',
	            label: 'Table'
	          }, {
	            value: 'tag',
	            label: 'Tag'
	          }, {
	            value: 'progress',
	            label: 'Progress'
	          }, {
	            value: 'tree',
	            label: 'Tree'
	          }, {
	            value: 'pagination',
	            label: 'Pagination'
	          }, {
	            value: 'badge',
	            label: 'Badge'
	          }]
	        }, {
	          value: 'notice',
	          label: 'Notice',
	          children: [{
	            value: 'alert',
	            label: 'Alert'
	          }, {
	            value: 'loading',
	            label: 'Loading'
	          }, {
	            value: 'message',
	            label: 'Message'
	          }, {
	            value: 'message-box',
	            label: 'MessageBox'
	          }, {
	            value: 'notification',
	            label: 'Notification'
	          }]
	        }, {
	          value: 'navigation',
	          label: 'Navigation',
	          children: [{
	            value: 'menu',
	            label: 'NavMenu'
	          }, {
	            value: 'tabs',
	            label: 'Tabs'
	          }, {
	            value: 'breadcrumb',
	            label: 'Breadcrumb'
	          }, {
	            value: 'dropdown',
	            label: 'Dropdown'
	          }, {
	            value: 'steps',
	            label: 'Steps'
	          }]
	        }, {
	          value: 'others',
	          label: 'Others',
	          children: [{
	            value: 'dialog',
	            label: 'Dialog'
	          }, {
	            value: 'tooltip',
	            label: 'Tooltip'
	          }, {
	            value: 'popover',
	            label: 'Popover'
	          }, {
	            value: 'card',
	            label: 'Card'
	          }, {
	            value: 'carousel',
	            label: 'Carousel'
	          }, {
	            value: 'collapse',
	            label: 'Collapse'
	          }]
	        }]
	      }, {
	        value: 'resource',
	        label: 'Resource',
	        children: [{
	          value: 'axure',
	          label: 'Axure Components'
	        }, {
	          value: 'sketch',
	          label: 'Sketch Templates'
	        }, {
	          value: 'docs',
	          label: 'Design Documentation'
	        }]
	      }],
	      selectedOptions: [],
	      selectedOptions3: ['component', 'data', 'tag'],
	      selectedOptions2: []
	    };
	  },
	
	  methods: {
	    handleChange: function handleChange(value) {
	      console.log(value);
	    }
	  }
	};

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'FormCheckbox',
	  data: function data() {
	    return {
	      checked: true,
	      checked1: false,
	      checked2: true
	    };
	  }
	};

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'FormInput',
	  data: function data() {
	    return {
	      input: '',
	      num1: 1
	    };
	  }
	};

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'FormRadio',
	  data: function data() {
	    return {
	      radio: '1',
	      radio3: 'New York',
	      radio4: 'New York',
	      radio5: 'New York'
	    };
	  }
	};

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'FormSelect',
	  data: function data() {
	    return {
	      options: [{
	        value: 'Option1',
	        label: 'Option1'
	      }, {
	        value: 'Option2',
	        label: 'Option2'
	      }, {
	        value: 'Option3',
	        label: 'Option3'
	      }, {
	        value: 'Option4',
	        label: 'Option4'
	      }, {
	        value: 'Option5',
	        label: 'Option5'
	      }],
	      options2: [{
	        value: 'Enable',
	        label: 'Enable'
	      }, {
	        value: 'Disable',
	        label: 'Disable',
	        disabled: true
	      }, {
	        value: 'Enable',
	        label: 'Enable'
	      }, {
	        value: 'Enable',
	        label: 'Enable'
	      }, {
	        value: 'Enable',
	        label: 'Enable'
	      }],
	      options3: [{
	        label: 'Popular cities',
	        options: [{
	          value: 'Yogyakarta',
	          label: 'Yogyakarta'
	        }, {
	          value: 'Depok',
	          label: 'Depok'
	        }]
	      }, {
	        label: 'City name',
	        options: [{
	          value: 'Sleman',
	          label: 'Sleman'
	        }, {
	          value: 'Bantul',
	          label: 'Bantul'
	        }, {
	          value: 'Gunung Kidul',
	          label: 'Gunung Kidul'
	        }, {
	          value: 'Jogja',
	          label: 'Jogja'
	        }]
	      }],
	      value2: '',
	      value: '',
	      value7: '',
	      options4: [],
	      value9: [],
	      list: [],
	      loading: false,
	      states: ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming']
	    };
	  },
	  mounted: function mounted() {
	    this.list = this.states.map(function (item) {
	      return { value: item, label: item };
	    });
	  },
	
	  methods: {
	    remoteMethod: function remoteMethod(query) {
	      var _this = this;
	
	      if (query !== '') {
	        this.loading = true;
	        setTimeout(function () {
	          _this.loading = false;
	          _this.options4 = _this.list.filter(function (item) {
	            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
	          });
	        }, 200);
	      } else {
	        this.options4 = [];
	      }
	    }
	  }
	};

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'FormSlider',
	  data: function data() {
	    return {
	      value1: 0,
	      value2: 50,
	      value3: 36,
	      value4: 48,
	      value5: 42,
	      value6: 0,
	      value7: 0,
	      value8: 0,
	      value9: [4, 8],
	      value10: 0
	    };
	  },
	
	  methods: {
	    formatTooltip: function formatTooltip(val) {
	      return val / 100;
	    }
	  }
	};

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'FormSwitch',
	  data: function data() {
	    return {
	      value1: true,
	      value2: true,
	      value3: false,
	      value4: false,
	      value5: '100'
	    };
	  }
	};

/***/ }),

/***/ 513:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'FormTimePicker',
	  data: function data() {
	    return {
	      value1: '',
	      value2: new Date(2016, 9, 10, 18, 40),
	      value3: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
	      startTime: '',
	      endTime: ''
	    };
	  }
	};

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'SelectTable',
	  data: function data() {
	    return {
	      tableData3: [{
	        date: '2016-05-03',
	        name: 'Tom',
	        state: 'California',
	        city: 'Los Angeles',
	        address: 'No. 189, Grove St, Los Angeles',
	        zip: 'CA 90036'
	      }, {
	        date: '2016-05-02',
	        name: 'Tom',
	        state: 'California',
	        city: 'Los Angeles',
	        address: 'No. 189, Grove St, Los Angeles',
	        zip: 'CA 90036'
	      }, {
	        date: '2016-05-04',
	        name: 'Tom',
	        state: 'California',
	        city: 'Los Angeles',
	        address: 'No. 189, Grove St, Los Angeles',
	        zip: 'CA 90036'
	      }, {
	        date: '2016-05-01',
	        name: 'Tom',
	        state: 'California',
	        city: 'Los Angeles',
	        address: 'No. 189, Grove St, Los Angeles',
	        zip: 'CA 90036'
	      }, {
	        date: '2016-05-08',
	        name: 'Tom',
	        state: 'California',
	        city: 'Los Angeles',
	        address: 'No. 189, Grove St, Los Angeles',
	        zip: 'CA 90036'
	      }, {
	        date: '2016-05-06',
	        name: 'Tom',
	        state: 'California',
	        city: 'Los Angeles',
	        address: 'No. 189, Grove St, Los Angeles',
	        zip: 'CA 90036'
	      }, {
	        date: '2016-05-07',
	        name: 'Tom',
	        state: 'California',
	        city: 'Los Angeles',
	        address: 'No. 189, Grove St, Los Angeles',
	        zip: 'CA 90036'
	      }],
	      tableData: [{
	        date: '2016-05-03',
	        name: 'Agus',
	        address: 'Los Angeles'
	      }, {
	        date: '2016-05-02',
	        name: 'Yudha',
	        address: 'New York'
	      }, {
	        date: '2016-05-04',
	        name: 'Ucil',
	        address: 'Texas'
	      }, {
	        date: '2016-05-01',
	        name: 'Jhonny',
	        address: 'Alaska'
	      }]
	    };
	  }
	};

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'SelectTable',
	  data: function data() {
	    return {
	      tableData: [{
	        date: '2016-05-03',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-02',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-04',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-04',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-04',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-01',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }],
	      tableData3: [{
	        date: '2016-05-03',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-02',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-04',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-01',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-08',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-06',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-07',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }],
	      currentRow: null,
	      multipleSelection: []
	    };
	  },
	
	  methods: {
	    setCurrent: function setCurrent(row) {
	      this.$refs.singleTable.setCurrentRow(row);
	    },
	    handleCurrentChange: function handleCurrentChange(val) {
	      this.currentRow = val;
	    },
	
	    toggleSelection: function toggleSelection(rows) {
	      var _this = this;
	
	      if (rows) {
	        rows.forEach(function (row) {
	          _this.$refs.multipleTable.toggleRowSelection(row);
	        });
	      } else {
	        this.$refs.multipleTable.clearSelection();
	      }
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    }
	  }
	};

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'SimpleTable',
	  data: function data() {
	    return {
	      tableData: [{
	        date: '2016-05-03',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-02',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-04',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-04',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-04',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }, {
	        date: '2016-05-01',
	        name: 'Tom',
	        address: 'No. 189, Grove St, Los Angeles'
	      }]
	    };
	  }
	};

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      titleText: '',
	      projectText: '',
	      isCreating: false
	    };
	  },
	  methods: {
	    openForm: function openForm() {
	      this.isCreating = true;
	    },
	    closeForm: function closeForm() {
	      this.isCreating = false;
	    },
	    sendForm: function sendForm() {
	      if (this.titleText.length > 0 && this.projectText.length > 0) {
	        var title = this.titleText;
	        var project = this.projectText;
	        this.$emit('create-todo', {
	          title: title,
	          project: project,
	          done: false
	        });
	        this.titleText = '';
	        this.projectText = '';
	        this.isCreating = false;
	      }
	    }
	  }
	};

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['todo'],
	  data: function data() {
	    return {
	      isEditing: false
	    };
	  },
	  methods: {
	    completeTodo: function completeTodo(todo) {
	      this.$emit('complete-todo', todo);
	    },
	    deleteTodo: function deleteTodo(todo) {
	      this.$emit('delete-todo', todo);
	    },
	    showForm: function showForm() {
	      this.isEditing = true;
	    },
	    hideForm: function hideForm() {
	      this.isEditing = false;
	    }
	  }
	};

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sweetalert = __webpack_require__(361);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _Todo = __webpack_require__(968);
	
	var _Todo2 = _interopRequireDefault(_Todo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['todos'],
	  components: {
	    Todo: _Todo2.default
	  },
	  methods: {
	    deleteTodo: function deleteTodo(todo) {
	      var _this = this;
	
	      (0, _sweetalert2.default)({
	        title: 'Are you sure?',
	        text: 'This To-Do will be permanently deleted!',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: 'Yes, delete it!',
	        closeOnConfirm: false
	      }, function () {
	        var todoIndex = _this.todos.indexOf(todo);
	        _this.todos.splice(todoIndex, 1);
	        (0, _sweetalert2.default)('Deleted!', 'Your To-Do has been deleted.', 'success');
	      });
	    },
	    completeTodo: function completeTodo(todo) {
	      var todoIndex = this.todos.indexOf(todo);
	      this.todos[todoIndex].done = true;
	      (0, _sweetalert2.default)('Success!', 'To-Do completed!', 'success');
	    }
	  }
	};

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'UIButtons'
	};

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue2Editor = __webpack_require__(1038);
	
	exports.default = {
	  components: {
	    VueEditor: _vue2Editor.VueEditor
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 522:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'GeneralPage'
	};

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Icons',
	  data: function data() {
	    return {
	      activeName: 'first'
	    };
	  },
	  methods: {
	    handleClick: function handleClick(tab, event) {
	      console.log(tab, event);
	    }
	  }
	};

/***/ }),

/***/ 524:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      gridData: [{
	        date: '2016-05-02',
	        name: 'John Smith',
	        address: 'No.1518,  Jinshajiang Road, Putuo District'
	      }, {
	        date: '2016-05-04',
	        name: 'John Smith',
	        address: 'No.1518,  Jinshajiang Road, Putuo District'
	      }, {
	        date: '2016-05-01',
	        name: 'John Smith',
	        address: 'No.1518,  Jinshajiang Road, Putuo District'
	      }, {
	        date: '2016-05-03',
	        name: 'John Smith',
	        address: 'No.1518,  Jinshajiang Road, Putuo District'
	      }],
	      dialogTableVisible: false,
	      dialogFormVisible: false,
	      form: {
	        name: '',
	        region: '',
	        date1: '',
	        date2: '',
	        delivery: false,
	        type: [],
	        resource: '',
	        desc: ''
	      },
	      formLabelWidth: '120px'
	    };
	  }
	};

/***/ }),

/***/ 525:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'BlankPage'
	};

/***/ }),

/***/ 526:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'BlankPage'
	};

/***/ }),

/***/ 527:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      fileList: [{ name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }, { name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }], fileList2: [{ name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }, { name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }]
	    };
	  },
	  methods: {
	    handleRemove: function handleRemove(file, fileList) {
	      console.log(file, fileList);
	    },
	    handlePreview: function handlePreview(file) {
	      console.log(file);
	    }
	  }
	};

/***/ }),

/***/ 528:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'WidgetsIndex'
	};

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ControlSidebar',
	  mounted: function mounted() {
	    $(document).ready(function ($) {
	      $('.navbar-stacked').slimScroll({
	        position: 'right',
	        size: '3px',
	        height: '95vh'
	      });
	    });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),

/***/ 530:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DashboardFooter'
	};

/***/ }),

/***/ 531:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DashboardHeader',
	  mounted: function mounted() {}
	};

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueAvatar = __webpack_require__(927);
	
	var _vueAvatar2 = _interopRequireDefault(_vueAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DashboardSidebar',
	  mounted: function mounted() {
	    $(document).ready(function ($) {
	      $('.main-sidebar > div').slimScroll({
	        width: '230px',
	        position: 'left',
	        size: '5px',
	        height: '95vh'
	      });
	    });
	  },
	  components: {
	    Avatar: _vueAvatar2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),

/***/ 869:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 870:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 871:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 872:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 873:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 874:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 875:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 876:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 877:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 878:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 879:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 880:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(877)
	
	/* script */
	__vue_exports__ = __webpack_require__(480)
	
	/* template */
	var __vue_template__ = __webpack_require__(1014)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(481)
	
	/* template */
	var __vue_template__ = __webpack_require__(1002)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(482)
	
	/* template */
	var __vue_template__ = __webpack_require__(1032)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(483)
	
	/* template */
	var __vue_template__ = __webpack_require__(985)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(484)
	
	/* template */
	var __vue_template__ = __webpack_require__(1019)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(485)
	
	/* template */
	var __vue_template__ = __webpack_require__(1031)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(486)
	
	/* template */
	var __vue_template__ = __webpack_require__(1026)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(487)
	
	/* template */
	var __vue_template__ = __webpack_require__(1028)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(488)
	
	/* template */
	var __vue_template__ = __webpack_require__(1004)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(489)
	
	/* template */
	var __vue_template__ = __webpack_require__(1006)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(490)
	
	/* template */
	var __vue_template__ = __webpack_require__(999)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(491)
	
	/* template */
	var __vue_template__ = __webpack_require__(1015)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(492)
	
	/* template */
	var __vue_template__ = __webpack_require__(1020)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(493)
	
	/* template */
	var __vue_template__ = __webpack_require__(1021)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(494)
	
	/* template */
	var __vue_template__ = __webpack_require__(989)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(495)
	
	/* template */
	var __vue_template__ = __webpack_require__(1010)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(496)
	
	/* template */
	var __vue_template__ = __webpack_require__(991)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(497)
	
	/* template */
	var __vue_template__ = __webpack_require__(1001)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(498)
	
	/* template */
	var __vue_template__ = __webpack_require__(1029)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(499)
	
	/* template */
	var __vue_template__ = __webpack_require__(1008)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(500)
	
	/* template */
	var __vue_template__ = __webpack_require__(1009)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(501)
	
	/* template */
	var __vue_template__ = __webpack_require__(986)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(502)
	
	/* template */
	var __vue_template__ = __webpack_require__(994)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(503)
	
	/* template */
	var __vue_template__ = __webpack_require__(1018)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(875)
	
	/* script */
	__vue_exports__ = __webpack_require__(504)
	
	/* template */
	var __vue_template__ = __webpack_require__(998)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(505)
	
	/* template */
	var __vue_template__ = __webpack_require__(1024)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(506)
	
	/* template */
	var __vue_template__ = __webpack_require__(1011)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(507)
	
	/* template */
	var __vue_template__ = __webpack_require__(1013)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(508)
	
	/* template */
	var __vue_template__ = __webpack_require__(984)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(509)
	
	/* template */
	var __vue_template__ = __webpack_require__(1016)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(510)
	
	/* template */
	var __vue_template__ = __webpack_require__(995)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(511)
	
	/* template */
	var __vue_template__ = __webpack_require__(1003)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(512)
	
	/* template */
	var __vue_template__ = __webpack_require__(1035)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(513)
	
	/* template */
	var __vue_template__ = __webpack_require__(993)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(514)
	
	/* template */
	var __vue_template__ = __webpack_require__(1012)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(515)
	
	/* template */
	var __vue_template__ = __webpack_require__(1022)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(516)
	
	/* template */
	var __vue_template__ = __webpack_require__(988)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(517)
	
	/* template */
	var __vue_template__ = __webpack_require__(1017)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(518)
	
	/* template */
	var __vue_template__ = __webpack_require__(983)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 969:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(519)
	
	/* template */
	var __vue_template__ = __webpack_require__(990)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(876)
	
	/* script */
	__vue_exports__ = __webpack_require__(520)
	
	/* template */
	var __vue_template__ = __webpack_require__(1005)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(521)
	
	/* template */
	var __vue_template__ = __webpack_require__(1000)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(873)
	
	/* script */
	__vue_exports__ = __webpack_require__(522)
	
	/* template */
	var __vue_template__ = __webpack_require__(992)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(874)
	
	/* script */
	__vue_exports__ = __webpack_require__(523)
	
	/* template */
	var __vue_template__ = __webpack_require__(997)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(524)
	
	/* template */
	var __vue_template__ = __webpack_require__(1007)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(525)
	
	/* template */
	var __vue_template__ = __webpack_require__(1025)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(526)
	
	/* template */
	var __vue_template__ = __webpack_require__(987)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(878)
	
	/* script */
	__vue_exports__ = __webpack_require__(527)
	
	/* template */
	var __vue_template__ = __webpack_require__(1030)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(528)
	
	/* template */
	var __vue_template__ = __webpack_require__(1023)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(879)
	
	/* script */
	__vue_exports__ = __webpack_require__(529)
	
	/* template */
	var __vue_template__ = __webpack_require__(1034)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(530)
	
	/* template */
	var __vue_template__ = __webpack_require__(1033)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(531)
	
	/* template */
	var __vue_template__ = __webpack_require__(1027)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(532)
	
	/* template */
	var __vue_template__ = __webpack_require__(996)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 983:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "todo-content"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isEditing),
	      expression: "!isEditing"
	    }]
	  }, [_c('h2', [_vm._v(_vm._s(_vm.todo.title))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.todo.project) + " ")]), _vm._v(" "), _c('div', {
	    staticClass: "task-action"
	  }, [_c('span', {
	    on: {
	      "click": _vm.showForm
	    }
	  }, [_c('i', {
	    staticClass: "ti-pencil"
	  })]), _vm._v(" "), _c('span', {
	    on: {
	      "click": function($event) {
	        _vm.deleteTodo(_vm.todo)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "ti-trash"
	  })])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isEditing),
	      expression: "isEditing"
	    }],
	    staticClass: "content-todo-devin"
	  }, [_c('div', [_c('div', [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('p', [_c('el-input', {
	    attrs: {
	      "placeholder": "Please input",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.todo.title),
	      callback: function($$v) {
	        _vm.$set(_vm.todo, "title", $$v)
	      },
	      expression: "todo.title"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "field"
	  }, [_c('label', [_vm._v("Project")]), _vm._v(" "), _c('p', [_c('el-input', {
	    attrs: {
	      "type": "textarea",
	      "rows": 4,
	      "placeholder": "Please input"
	    },
	    model: {
	      value: (_vm.todo.project),
	      callback: function($$v) {
	        _vm.$set(_vm.todo, "project", $$v)
	      },
	      expression: "todo.project"
	    }
	  })], 1)]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "danger"
	    },
	    on: {
	      "click": _vm.hideForm
	    }
	  }, [_vm._v("Close")])], 1)])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isEditing && _vm.todo.done),
	      expression: "!isEditing &&todo.done"
	    }],
	    staticClass: "todo-completed",
	    attrs: {
	      "disabled": ""
	    }
	  }, [_vm._v(" Completed ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isEditing && !_vm.todo.done),
	      expression: "!isEditing && !todo.done"
	    }],
	    staticClass: "todo-pending",
	    on: {
	      "click": function($event) {
	        _vm.completeTodo(_vm.todo)
	      }
	    }
	  }, [_vm._v(" Pending ")])])
	},staticRenderFns: []}

/***/ }),

/***/ 984:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-center"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Forms Input"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Forms ")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Input")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h4', [_vm._v("Basic")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "Please input"
	    },
	    model: {
	      value: (_vm.input),
	      callback: function($$v) {
	        _vm.input = $$v
	      },
	      expression: "input"
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Disabled")]), _vm._v(" "), _c('p', [_vm._v("Disable the Input with the "), _c('code', [_vm._v("disabled")]), _vm._v(" attribute.")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "Please input",
	      "disabled": true
	    },
	    model: {
	      value: (_vm.input1),
	      callback: function($$v) {
	        _vm.input1 = $$v
	      },
	      expression: "input1"
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Input with Icon")]), _vm._v(" "), _c('p', [_vm._v("You can add an icon at the end of Input by setting the "), _c('code', [_vm._v("icon")]), _vm._v(" attribute and use "), _c('code', [_vm._v("on-icon-click")]), _vm._v(" hook to complete some work after clicking the icon.")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": "Pick a date",
	      "icon": "search",
	      "on-icon-click": _vm.handleIconClick
	    },
	    model: {
	      value: (_vm.input2),
	      callback: function($$v) {
	        _vm.input2 = $$v
	      },
	      expression: "input2"
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Text Area")]), _vm._v(" "), _c('p', [_vm._v("Resizable for entering multiple lines of text information. Add attribute "), _c('code', [_vm._v("type=\"textarea\"")]), _vm._v(" to change "), _c('code', [_vm._v("input")]), _vm._v(" into native "), _c('code', [_vm._v("textarea")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Control the height by setting the "), _c('code', [_vm._v("rows")]), _vm._v(" prop.")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "type": "textarea",
	      "rows": 4,
	      "placeholder": "Please input"
	    },
	    model: {
	      value: (_vm.textarea),
	      callback: function($$v) {
	        _vm.textarea = $$v
	      },
	      expression: "textarea"
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Mixed input")]), _vm._v(" "), _c('p', [_vm._v("Prepend or append an element, generally a label or a button.")]), _vm._v(" "), _c('div', [_c('el-input', {
	    attrs: {
	      "placeholder": "Please input"
	    },
	    model: {
	      value: (_vm.input3),
	      callback: function($$v) {
	        _vm.input3 = $$v
	      },
	      expression: "input3"
	    }
	  }, [_c('template', {
	    slot: "prepend"
	  }, [_vm._v("Http://")])], 2)], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "15px"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Please input"
	    },
	    model: {
	      value: (_vm.input4),
	      callback: function($$v) {
	        _vm.input4 = $$v
	      },
	      expression: "input4"
	    }
	  }, [_c('template', {
	    slot: "append"
	  }, [_vm._v(".com")])], 2)], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "15px"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Please input"
	    },
	    model: {
	      value: (_vm.input5),
	      callback: function($$v) {
	        _vm.input5 = $$v
	      },
	      expression: "input5"
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "slot": "prepend",
	      "placeholder": "Select"
	    },
	    slot: "prepend",
	    model: {
	      value: (_vm.select),
	      callback: function($$v) {
	        _vm.select = $$v
	      },
	      expression: "select"
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "Restaurant",
	      "value": "1"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Order No.",
	      "value": "2"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Tel",
	      "value": "3"
	    }
	  })], 1), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "slot": "append",
	      "icon": "search"
	    },
	    slot: "append"
	  })], 1)], 1), _vm._v(" "), _c('hr')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h4', [_vm._v("Input Number")]), _vm._v(" "), _c('p'), _c('p', [_vm._v("Bind a variable to "), _c('code', [_vm._v("v-model")]), _vm._v(" in "), _c('code', [_vm._v("<el-input-number>")]), _vm._v(" element and you are set.")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('el-input-number', {
	    attrs: {
	      "min": 1,
	      "max": 10
	    },
	    on: {
	      "change": _vm.handleChange
	    },
	    model: {
	      value: (_vm.num1),
	      callback: function($$v) {
	        _vm.num1 = $$v
	      },
	      expression: "num1"
	    }
	  }), _vm._v(" "), _c('el-input-number', {
	    attrs: {
	      "step": 2
	    },
	    model: {
	      value: (_vm.num3),
	      callback: function($$v) {
	        _vm.num3 = $$v
	      },
	      expression: "num3"
	    }
	  })], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 985:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Blog Details"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Blog Detail Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box",
	    staticStyle: {
	      "padding": "30px"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('div', {
	    staticClass: "blog-list-nest"
	  }, [_c('div', {
	    staticClass: "vendor"
	  }, [_c('img', {
	    staticClass: "img-responsive-media",
	    attrs: {
	      "src": "https://source.unsplash.com/collection/190727/1600x900",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "blog-list-content"
	  }, [_c('h2', [_vm._v("Favright")]), _vm._v(" "), _c('ul', {
	    staticClass: "list-inline blog-devin-tag"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-pencil"
	  }), _vm._v(" 2 Days Ago")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-comment-alt"
	  }), _vm._v(" 2 Comments")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-rss-alt"
	  }), _vm._v(" 14 Shares")])])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam condimentum sollicitudin mi, vitae vehicula justo venenatis at. Morbi tempor fermentum velit non pretium. Phasellus at lacus turpis. Curabitur dapibus pulvinar velit eu rutrum. Nulla adipiscing sapien orci, ac iaculis justo euismod vitae. Fusce tincidunt accumsan erat, a molestie eros auctor a. Suspendisse vel nibh vulputate, porttitor neque in, pellentesque lectus. Pellentesque aliquet diam sed placerat scelerisque. Suspendisse eleifend sem urna, eget viverra nunc interdum quis. Nam porta nunc turpis. Pellentesque ut adipiscing mi, eu facilisis turpis.")]), _vm._v(" "), _c('p', [_vm._v("Nunc ac erat semper, ultrices lorem eu, pretium urna. Etiam nibh nibh, laoreet id pharetra sit amet, interdum at sapien. Fusce venenatis velit in diam auctor tempus. Duis feugiat consectetur urna vel suscipit. In in lorem placerat, tempus velit ac, aliquam diam. Cras vestibulum velit posuere, elementum enim sed, imperdiet nisl. Etiam scelerisque purus tempus, fringilla dolor at, sodales nibh. Morbi molestie porta nunc, ut tincidunt ante euismod vitae. Mauris vehicula augue augue, ut placerat sapien porta vel. Curabitur laoreet odio et nibh hendrerit consequat. Quisque aliquet orci est, condimentum dignissim felis tempus eget. Morbi ac bibendum velit, eget aliquam nisi. Integer posuere consequat purus non mollis. Integer posuere vitae massa a posuere. Vivamus at lectus at elit aliquam pulvinar porta nec turpis.")]), _vm._v(" "), _c('p', [_vm._v("Vestibulum eu scelerisque ante, eget molestie tellus. Aenean eget sagittis massa. Fusce et ligula ultricies, venenatis leo et, posuere orci. Aenean euismod augue id orci consequat, eget lobortis ante blandit. Nulla tempus viverra mattis. Maecenas volutpat ut massa pellentesque tristique. Morbi erat enim, dapibus ornare laoreet non, auctor sit amet lorem. Integer nec lorem a risus tristique viverra. Quisque aliquam nisl eu ante pretium, vel volutpat leo tempus. Nam velit arcu, tincidunt eget viverra vitae, auctor ac neque.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
	    staticClass: "pull-left"
	  }, [_c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Music")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Video")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Typhography")])], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "clear": "both"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "comment-nest"
	  }, [_c('h1', [_vm._v("Leave a Comment:")]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "type": "textarea",
	      "rows": 5,
	      "placeholder": "Please input"
	    },
	    model: {
	      value: (_vm.textarea),
	      callback: function($$v) {
	        _vm.textarea = $$v
	      },
	      expression: "textarea"
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', [_vm._v("Submit")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', {
	    staticClass: "media-list"
	  }, [_c('li', {
	    staticClass: "media"
	  }, [_c('a', {
	    staticClass: "pull-left",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-circle",
	    staticStyle: {
	      "width": "64px",
	      "height": "64px"
	    },
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/thumb/women/21.jpg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('div', {
	    staticClass: "social-profile"
	  }, [_c('h3', [_c('a', {
	    staticClass: "link-comment",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Destya Susilowati")]), _vm._v(" "), _c('span', [_c('i', {
	    staticClass: "entypo-globe"
	  }), _vm._v(" 1 hours ago")]), _vm._v(" "), _c('span', [_c('a', {
	    staticClass: "link-comment",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fontawesome-share"
	  }), _vm._v(" Reply")])])])]), _vm._v(" "), _c('p', [_vm._v("Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    staticClass: "pull-left",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-circle",
	    staticStyle: {
	      "width": "64px",
	      "height": "64px"
	    },
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/thumb/men/40.jpg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('div', {
	    staticClass: "social-profile"
	  }, [_c('h3', [_c('a', {
	    staticClass: "link-comment",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Awangizm")]), _vm._v(" "), _c('span', [_c('i', {
	    staticClass: "entypo-globe"
	  }), _vm._v(" 1 hours ago")]), _vm._v(" "), _c('span', [_c('a', {
	    staticClass: "link-comment",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fontawesome-share"
	  }), _vm._v(" Reply")])])])]), _vm._v(" "), _c('p', [_vm._v("Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    staticClass: "pull-left",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-circle",
	    staticStyle: {
	      "width": "64px",
	      "height": "64px"
	    },
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/thumb/women/21.jpg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('div', {
	    staticClass: "social-profile"
	  }, [_c('h3', [_c('a', {
	    staticClass: "link-comment",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Symponia")]), _vm._v(" "), _c('span', [_c('i', {
	    staticClass: "entypo-globe"
	  }), _vm._v(" 1 hours ago")]), _vm._v(" "), _c('span', [_c('a', {
	    staticClass: "link-comment",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fontawesome-share"
	  }), _vm._v(" Reply")])])])]), _vm._v(" "), _c('p', [_vm._v("Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.")])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    staticClass: "pull-left",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-circle",
	    staticStyle: {
	      "width": "64px",
	      "height": "64px"
	    },
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/thumb/men/55.jpg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('div', {
	    staticClass: "social-profile"
	  }, [_c('h3', [_c('a', {
	    staticClass: "link-comment",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Agus Berontazk")]), _vm._v(" "), _c('span', [_c('i', {
	    staticClass: "entypo-globe"
	  }), _vm._v(" 12 minute ago")]), _vm._v(" "), _c('span', [_c('a', {
	    staticClass: "link-comment",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fontawesome-share"
	  }), _vm._v(" Reply")])])])]), _vm._v(" "), _c('p', [_vm._v("Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.")])])])])])])], 1), _vm._v(" "), _c('ul', {
	    staticClass: "pager success"
	  }, [_c('li', {
	    staticClass: "previous"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("← Older")])]), _vm._v(" "), _c('li', {
	    staticClass: "next disabled"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Newer →")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('div', {
	    staticClass: "panel panel-default"
	  }, [_c('img', {
	    staticClass: "media-object img-circle blog-profile",
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/thumb/men/10.jpg"
	    }
	  }), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin": "0"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "panel-body"
	  }, [_c('p', {
	    staticClass: "lead text-center"
	  }, [_vm._v("Dave Mattew")]), _vm._v(" "), _c('p', {
	    staticClass: "tex-center social-blog-profile"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "entypo-facebook-circled"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "tweet-link",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "entypo-twitter-circled"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "gplus-textcolor",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "entypo-instagrem"
	  })])]), _vm._v(" "), _c('p', {
	    staticClass: "social-follower text-center"
	  }, [_vm._v("A graphics designer, a web developer, a boyfriend, a friend, a son")])])]), _vm._v(" "), _c('div', {
	    staticClass: "blog-side-nest"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("JOIN NEWSLETTER")]), _vm._v(" "), _c('p', {
	    staticClass: "text-center"
	  }, [_vm._v("Sign up for our daily Newslatter")]), _vm._v(" "), _c('form', {
	    attrs: {
	      "role": "form"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-8"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "placeholder": "Enter email"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-4 col-full-width-left"
	  }, [_c('button', {
	    staticClass: "btn btn-info btn-block",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Sign up")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "blog-side-nest"
	  }, [_c('h4', {
	    staticClass: "text-left"
	  }, [_vm._v("POPULAR POST")]), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin": "0"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    staticClass: "pull-left",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-responsive-media",
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/men/17.jpg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h5', {
	    staticClass: "media-heading"
	  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
	    staticClass: "link-comment recentpost-link",
	    staticStyle: {
	      "margin": "-10px 0 10px"
	    },
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("88 Views")])])]), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    staticClass: "pull-left",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-responsive-media",
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/men/21.jpg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h5', {
	    staticClass: "media-heading"
	  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
	    staticClass: "link-comment recentpost-link",
	    staticStyle: {
	      "margin": "-10px 0 10px"
	    },
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("90 Views")])])]), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    staticClass: "pull-left",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-responsive-media",
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/men/20.jpg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h5', {
	    staticClass: "media-heading"
	  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
	    staticClass: "link-comment recentpost-link",
	    staticStyle: {
	      "margin": "-10px 0 10px"
	    },
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("42 Views")])])]), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    staticClass: "pull-left",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-responsive-media",
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/men/19.jpg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h5', {
	    staticClass: "media-heading"
	  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
	    staticClass: "link-comment recentpost-link",
	    staticStyle: {
	      "margin": "-10px 0 10px"
	    },
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("111 Views")])])]), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    staticClass: "pull-left",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-responsive-media",
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/men/18.jpg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h5', {
	    staticClass: "media-heading"
	  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
	    staticClass: "link-comment recentpost-link",
	    staticStyle: {
	      "margin": "-10px 0 10px"
	    },
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("123 Views")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "blog-side-nest"
	  }, [_c('h4', {
	    staticClass: "text-left"
	  }, [_vm._v("TAG")]), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin": "0"
	    }
	  }), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Admin")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Fleet")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Music")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Video")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Typhography")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Computer")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Web Design")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Movie")])], 1)])])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 986:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Profile Page"), _c('small', [_vm._v("It's all start from here "), _c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Profile")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "min-height": "400px"
	    }
	  }, [_c('div', {
	    staticClass: "movie-card"
	  }, [_c('div', {
	    staticClass: "container-movie"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "cover-profile",
	    attrs: {
	      "src": "http://api.randomuser.me/portraits/men/32.jpg",
	      "alt": "cover"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "hero"
	  }, [_c('div', {
	    staticClass: "details-profile"
	  }, [_c('div', {
	    staticClass: "title1"
	  }, [_vm._v("Dave Mattew "), _c('span', [_vm._v("Web Designer")])]), _vm._v(" "), _c('div', {
	    staticClass: "title2"
	  }, [_vm._v("The Battle of the Five Armies")])])]), _vm._v(" "), _c('div', {
	    staticClass: "description-profile"
	  }, [_c('div', {
	    staticClass: "column1 text-center"
	  }, [_c('span', {
	    staticClass: "tag"
	  }, [_vm._v("html5")]), _vm._v(" "), _c('span', {
	    staticClass: "tag"
	  }, [_vm._v("php")]), _vm._v(" "), _c('span', {
	    staticClass: "tag"
	  }, [_vm._v("javascript")]), _c('span', {
	    staticClass: "tag"
	  }, [_vm._v("css")]), _c('span', {
	    staticClass: "tag"
	  }, [_vm._v("photoshop")])]), _vm._v(" "), _c('div', {
	    staticClass: "column2"
	  }, [_c('p', [_vm._v("Bilbo Baggins is swept into a quest to reclaim the lost Dwarf Kingdom of Erebor from the fearsome dragon Smaug. Approached out of the blue by the wizard Gandalf the Grey, Bilbo finds himself joining a company ")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-sm-4 emphasis"
	  }, [_c('h2', [_c('strong', [_vm._v("20,7K")])]), _vm._v(" "), _c('p', [_c('small', [_vm._v("Followers")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success "
	  }, [_c('span', {
	    staticClass: "fa fa-plus-circle"
	  }), _vm._v("  Follow")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-sm-4 emphasis"
	  }, [_c('h2', [_c('strong', [_vm._v("245")])]), _vm._v(" "), _c('p', [_c('small', [_vm._v("Following")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info "
	  }, [_c('span', {
	    staticClass: "fa fa-user"
	  }), _vm._v("  View Profile")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 emphasis"
	  }, [_c('h2', [_c('strong', [_vm._v("43")])]), _vm._v(" "), _c('p', [_c('small', [_vm._v("Likes")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default"
	  }, [_c('span', {
	    staticClass: "fa fa-user"
	  }), _vm._v("  Likes")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-sm-12 text-center"
	  }, [_c('ul', {
	    staticClass: "list-group"
	  }, [_c('li', {
	    staticClass: "list-group-item text-center"
	  }, [_c('span', {
	    staticClass: "pull-left"
	  }, [_c('strong', [_vm._v("Ratings")])]), _vm._v(" "), _c('div', {
	    staticClass: "ratings"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star-o"
	  })])])]), _vm._v(" "), _c('li', {
	    staticClass: "list-group-item text-right"
	  }, [_c('span', {
	    staticClass: "pull-left"
	  }, [_c('strong', [_vm._v("Joined")])]), _vm._v("2.13.2014")]), _vm._v(" "), _c('li', {
	    staticClass: "list-group-item text-right"
	  }, [_c('span', {
	    staticClass: "pull-left"
	  }, [_c('strong', [_vm._v("Last seen")])]), _vm._v("Yesterday")]), _vm._v(" "), _c('li', {
	    staticClass: "list-group-item text-right"
	  }, [_c('span', {
	    staticClass: "pull-left"
	  }, [_c('strong', [_vm._v("Nickname")])]), _vm._v("themesmile")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-sm-12 profile-name"
	  }, [_c('h2', [_vm._v("Dave Mattew\n                                    "), _c('span', {
	    staticClass: "pull-right social-profile"
	  }, [_c('i', {
	    staticClass: "entypo-facebook-circled"
	  }), _vm._v(" "), _c('i', {
	    staticClass: "entypo-twitter-circled"
	  }), _vm._v(" "), _c('i', {
	    staticClass: "entypo-linkedin-circled"
	  }), _vm._v(" "), _c('i', {
	    staticClass: "entypo-github-circled"
	  }), _vm._v(" "), _c('i', {
	    staticClass: "entypo-gplus-circled"
	  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('dl', {
	    staticClass: "dl-horizontal-profile"
	  }, [_c('dt', [_vm._v("User Id")]), _vm._v(" "), _c('dd', [_vm._v("eko.sulis")]), _vm._v(" "), _c('dt', [_vm._v("Name")]), _vm._v(" "), _c('dd', [_vm._v("Eko Sulistyo")]), _vm._v(" "), _c('dt', [_vm._v("Email")]), _vm._v(" "), _c('dd', [_vm._v("eko.sulistyo@yahoo.com")]), _vm._v(" "), _c('dt', [_vm._v("Phone")]), _vm._v(" "), _c('dd', [_vm._v("081 725 xxx")]), _vm._v(" "), _c('dt', [_vm._v("Active Periode")]), _vm._v(" "), _c('dd', [_vm._v("02 Dec 2014")]), _vm._v(" "), _c('dt', [_vm._v("Last Update")]), _vm._v(" "), _c('dd', [_vm._v("02 Apr 2014")]), _vm._v(" "), _c('dt', [_vm._v("About")]), _vm._v(" "), _c('dd', [_vm._v("Web Designer / UI")]), _vm._v(" "), _c('dt', [_vm._v("Hobbies")]), _vm._v(" "), _c('dd', [_vm._v("Read, out with friends, listen to music, draw and learn new things")]), _vm._v(" "), _c('dt', [_vm._v("Skills")]), _vm._v(" "), _c('dd', [_c('span', {
	    staticClass: "tags"
	  }, [_vm._v("html5")]), _vm._v(" "), _c('span', {
	    staticClass: "tags"
	  }, [_vm._v("css3")]), _vm._v(" "), _c('span', {
	    staticClass: "tags"
	  }, [_vm._v("jquery")]), _vm._v(" "), _c('span', {
	    staticClass: "tags"
	  }, [_vm._v("bootstrap3")])])])])])])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 987:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Blank Page"), _c('small', [_vm._v("It's all start from here "), _c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Blank Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Timeline Page")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "min-height": "400px"
	    }
	  }, [_c('div', {
	    staticClass: "container-timeline"
	  }, [_c('div', {
	    staticClass: "header-timeline"
	  }, [_c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "height": "64",
	      "width": "64"
	    }
	  }, [_c('defs', [_c('linearGradient', {
	    attrs: {
	      "id": "verlauf",
	      "x1": "0%",
	      "y1": "0%",
	      "x2": "100%",
	      "y2": "100%"
	    }
	  }, [_c('stop', {
	    attrs: {
	      "offset": "0%",
	      "stop-color": "orange"
	    }
	  }), _vm._v(" "), _c('stop', {
	    attrs: {
	      "offset": "100%",
	      "stop-color": "chocolate"
	    }
	  })], 1)], 1), _vm._v(" "), _c('path', {
	    attrs: {
	      "fill": "url(#verlauf)",
	      "d": "M63.04 39.74C58.764 56.885 41.4 67.318 24.256 63.043 7.12 58.768-3.313 41.404.962 24.262 5.234 7.117 22.597-3.318 39.737.957 56.88 5.23 67.313 22.597 63.04 39.74z"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "fill": "#FFF",
	      "d": "M46.11 27.44c.636-4.257-2.606-6.546-7.04-8.073l1.44-5.768-3.512-.876-1.4 5.616c-.923-.23-1.87-.447-2.813-.662l1.41-5.653-3.51-.875-1.438 5.766c-.764-.174-1.514-.346-2.242-.527l.004-.02-4.843-1.208-.934 3.75s2.605.597 2.55.634c1.422.355 1.68 1.296 1.636 2.042l-1.64 6.57c.1.026.226.062.366.118l-.37-.092-2.297 9.205c-.175.43-.616 1.08-1.61.833.035.05-2.552-.637-2.552-.637l-1.743 4.02 4.57 1.138c.85.213 1.682.436 2.502.646l-1.453 5.834 3.507.875 1.44-5.773c.958.26 1.888.5 2.798.726l-1.434 5.745 3.51.875 1.454-5.823c5.987 1.133 10.49.676 12.384-4.74 1.527-4.36-.076-6.874-3.226-8.514 2.294-.53 4.022-2.038 4.483-5.155zm-8.023 11.25c-1.085 4.36-8.426 2.003-10.806 1.412l1.93-7.73c2.38.595 10.01 1.77 8.877 6.318zm1.086-11.312c-.99 3.966-7.1 1.95-9.082 1.457l1.75-7.01c1.98.494 8.364 1.416 7.333 5.553z"
	    }
	  })]), _vm._v(" "), _c('h1', [_vm._v("History of bitcoin")]), _vm._v(" "), _c('h2', [_vm._v("A timeline that shows bitcoin History from the idea all the way to present day.")])]), _vm._v(" "), _c('div', {
	    staticClass: "item-timeline"
	  }, [_c('div', {
	    attrs: {
	      "id": "timeline"
	    }
	  }, [_c('div', [_c('section', {
	    staticClass: "year"
	  }, [_c('h3', [_vm._v("2007")]), _vm._v(" "), _c('section', [_c('ul', [_c('li', [_vm._v("Satoshi Nakamoto began working on the Bitcoin concept.")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "year"
	  }, [_c('h3', [_vm._v("2008")]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("August")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Neal Kin, Vladimir Oksman, and Charles Bry file an application for an encryption patent application.")]), _vm._v(" "), _c('li', [_vm._v("Bitcoin.org was registered at "), _c('a', {
	    attrs: {
	      "href": "https://anonymousspeech.com/"
	    }
	  }, [_vm._v("anonymousspeech.com")]), _vm._v(".")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("October")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Nakamoto describes the Bitcoin currency and solves the problem of double spending.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("November")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("The Bitcoin project is registered on "), _c('a', {
	    attrs: {
	      "href": "https://sourceforge.net/"
	    }
	  }, [_vm._v("SourceForge.net")]), _vm._v(".")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "year"
	  }, [_c('h3', [_vm._v("2009")]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("January")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Block 0 is established.")]), _vm._v(" "), _c('li', [_vm._v("Version 0.1 of Bitcoin is released.")]), _vm._v(" "), _c('li', [_vm._v("The first Bitcoin transaction.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("October")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("An exchange rate is established.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("December")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Version 0.2 is released.")]), _vm._v(" "), _c('li', [_vm._v("The difficulty increases.")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "year"
	  }, [_c('h3', [_vm._v("2010")]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("February")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("The Bitcoin Market is established as a Bitcoin currency exchange.")]), _vm._v(" "), _c('li', [_vm._v("Encryption patent is published.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("May")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("The first real-world transaction using 10,000 BTC spent on pizza.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("July")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Version 0.3 released.")]), _vm._v(" "), _c('li', [_vm._v("In five days, the price grew 1000%, rising from "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$0.008")]), _vm._v(" to "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$0.08")]), _vm._v(" for 1 bitcoin.")]), _vm._v(" "), _c('li', [_vm._v("The MtGox Bitcoin currency exchange market is established.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("August")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Exploit generates 184 billion Bitcoins.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("October")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Financial task force issues warning.")]), _vm._v(" "), _c('li', [_vm._v("The first public version of an OpenCL miner is released.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("November")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Market cap exceeds $1 million USD.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("December")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Bitcoind compiled for Nokia N900.")]), _vm._v(" "), _c('li', [_vm._v("First mobile Bitcoin transaction.")]), _vm._v(" "), _c('li', [_vm._v("Difficulty increases.")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "year"
	  }, [_c('h3', [_vm._v("2011")]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("January")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Silk Road opens for business.")]), _vm._v(" "), _c('li', [_vm._v("25% of total Bitcoins generated.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("February")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Bitcoin reaches parity with US dollar.")]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://weusecoins.com/"
	    }
	  }, [_vm._v("WeUseCoins.com")]), _vm._v(" is created.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("March")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Second largest decrease in difficulty.")]), _vm._v(" "), _c('li', [_vm._v("Britcoin opens for trading.")]), _vm._v(" "), _c('li', [_vm._v("Bitcoin Brasil opens.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("April")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Bitcoin passes parity with Euro.")]), _vm._v(" "), _c('li', [_vm._v("Difficulty surpasses 100,000.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("June")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Bitcoin Market drops PayPal.")]), _vm._v(" "), _c('li', [_vm._v("The largest percentage price decrease to-date became known as the Great Bubble of 2011. Top of bubble at "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$31.")])]), _vm._v(" "), _c('li', [_vm._v("WikiLeaks starts accepting Bitcoin.")]), _vm._v(" "), _c('li', [_vm._v("Major breach of security at MtGox.")]), _vm._v(" "), _c('li', [_vm._v("Difficulty passes 1 million.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("August")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Bitcoin Conference and World Expo in New York City, NY.")]), _vm._v(" "), _c('li', [_vm._v("P2Pool mines its first block.")]), _vm._v(" "), _c('li', [_vm._v("Back-to-back drop in difficulty.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("September")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Casascius coins mint physical Bitcoins.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("November")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Bitcoin & Future Technology European Conference in Prague, Czech Republic.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("December")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
	    staticClass: "price"
	  }, [_vm._v("$2")]), _vm._v(" minimum price after the first price drop.")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "year"
	  }, [_c('h3', [_vm._v("2012")]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("September")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("London 2012 Bitcoin Conference.")]), _vm._v(" "), _c('li', [_vm._v("Bitcoin Foundation begins.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("December")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Slowly rising for a year. Price at "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$13.")])])])])]), _vm._v(" "), _c('section', {
	    staticClass: "year"
	  }, [_c('h3', [_vm._v("2013")]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("February")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Version 0.8 released.")]), _vm._v(" "), _c('li', [_vm._v("Bitcoin goes up to "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$30.")])])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("March")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Bitcoin spikes to $74.90.")]), _vm._v(" "), _c('li', [_vm._v("Market cap reaches $1 billion.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("April")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Bitcoin surpasses "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$100.")])]), _vm._v(" "), _c('li', [_vm._v("Price hits an all-time high of "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$266.")])]), _vm._v(" "), _c('li', [_vm._v("Bitcoin Central is hacked.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("May")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("First Bitcoin ATM unveiled.")]), _vm._v(" "), _c('li', [_vm._v("Bitcoin Central gets hacked again.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("October")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("FBI shuts down Silk Road.")]), _vm._v(" "), _c('li', [_vm._v("Bitcoin price drops from "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$139")]), _vm._v(" to "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$109.71")]), _vm._v(" in less than three hours after Silk Road closure, recovers.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("November")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Bitcoin price surges to a new all-time record of "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$1242.")])])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("December")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Price crashed to "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$600")]), _vm._v(", rebounded to "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$1000")]), _vm._v(", crashed again to the "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$500")]), _vm._v(" range. Stabilized in between.")]), _vm._v(" "), _c('li', [_vm._v("China's Central Bank bans Bitcoin transactions.")]), _vm._v(" "), _c('li', [_vm._v("The network exceeded 10 petahash/sec.")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "year"
	  }, [_c('h3', [_vm._v("2014")]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("January")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Price spiked to "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$1000")]), _vm._v(", then settled in the "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$800–$900")]), _vm._v("range.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("March")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Version 0.9 released.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("June")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("The network exceeded 100 petahash/sec.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("December")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Microsoft began to accept bitcoin to buy Xbox games and Windows apps.")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "year"
	  }, [_c('h3', [_vm._v("2015")]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("February")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Version 0.10 released.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("July")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Version 0.11 released.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("November")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("2015 record high of "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$504.")])])])])]), _vm._v(" "), _c('section', {
	    staticClass: "year"
	  }, [_c('h3', [_vm._v("2016")]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("January")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Price at "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$1150")]), _vm._v(" per bitcoin.")]), _vm._v(" "), _c('li', [_vm._v("Price fell 30% in a week, reaching a multi-month low of "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$750.")])]), _vm._v(" "), _c('li', [_vm._v("The network exceeded 1 exahash/sec.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("February")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Version 0.12 released.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("April")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Steam started accepting bitcoin as payment.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("August")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Version 0.13 released.")])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("September")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("There are 770 bitcoin ATMs worldwide.")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "year"
	  }, [_c('h3', [_vm._v("2017")]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("March")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Version 0.14 released.")]), _vm._v(" "), _c('li', [_vm._v("The price of 1 bitcoin surpassed the spot price of an ounce of gold for the first time.")]), _vm._v(" "), _c('li', [_vm._v("The number of GitHub projects related to bitcoin passed 10,000.")]), _vm._v(" "), _c('li', [_vm._v("Price traded above "), _c('span', {
	    staticClass: "price"
	  }, [_vm._v("$1290.")])])])]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("Today")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("At the moment, one bitcoin cost: "), _c('span', {
	    staticClass: "price"
	  }, [_c('div', {
	    attrs: {
	      "id": "btcwidget"
	    }
	  }), _vm._v(".")])])])])])])])])])])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 988:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Simple Table"), _c('small', [_vm._v("It's all start from here "), _c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Table")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Simple Table")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Basic Tables")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.tableData
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "date",
	      "label": "Date",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": "Name",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "address",
	      "label": "Address"
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Striped Table")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.tableData,
	      "stripe": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "date",
	      "label": "Date",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": "Name",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "address",
	      "label": "Address"
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Table with fixed header")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.tableData,
	      "height": "250",
	      "border": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "date",
	      "label": "Date",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": "Name",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "address",
	      "label": "Address"
	    }
	  })], 1)], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 989:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_vm._m(0, false, false), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("EChart Bar")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('ve-bar', {
	    attrs: {
	      "data": _vm.chartData,
	      "settings": _vm.chartSettings
	    }
	  })], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_vm._v("EChartBar "), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Charts")])])
	}]}

/***/ }),

/***/ 990:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "todo-list"
	  }, _vm._l((_vm.todos), function(todo) {
	    return _c('todo', {
	      attrs: {
	        "todo": todo
	      },
	      on: {
	        "delete-todo": _vm.deleteTodo,
	        "complete-todo": _vm.completeTodo,
	        "update:todo": function($event) {
	          todo = $event
	        }
	      }
	    })
	  }))
	},staticRenderFns: []}

/***/ }),

/***/ 991:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_vm._m(0, false, false), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Vector Map")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('ve-map', {
	    attrs: {
	      "data": _vm.chartData,
	      "settings": _vm.chartSettings
	    }
	  })], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_vm._v("Vector Map "), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Map")])])
	}]}

/***/ }),

/***/ 992:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("General Page"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("General Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Basic layout")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "min-height": "400px"
	    }
	  }, [_c('h4', [_vm._v("Basic usage")]), _vm._v(" "), _c('p', [_vm._v("Quickly and easily create layouts with the basic 24-column. Create basic grid layout using columns.")]), _vm._v(" "), _c('p', [_vm._v("With "), _c('code', [_vm._v("row")]), _vm._v(" and "), _c('code', [_vm._v("col")]), _vm._v(", we can easily manipulate the layout using the "), _c('code', [_vm._v("span")]), _vm._v(" attribute.")]), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple-dark"
	  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple"
	  })]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple-light"
	  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple"
	  })]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple-light"
	  })]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple"
	  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple"
	  })]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple-light"
	  })]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple"
	  })]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple-light"
	  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 4
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple"
	  })]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 4
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple-light"
	  })]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 4
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple"
	  })]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 4
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple-light"
	  })]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 4
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple"
	  })]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 4
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple-light"
	  })])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Column Spacing")]), _vm._v(" "), _c('p', [_vm._v("Row provides "), _c('code', [_vm._v("gutter")]), _vm._v(" attribute to specify spacings between columns, and its default value is 0.")]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple"
	  })]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple"
	  })]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple"
	  })]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple"
	  })])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Alert")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h4', [_vm._v("Alert")]), _vm._v(" "), _c('p', [_vm._v("Alert components are non-overlay elements in the page that does not disappear automatically.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
	    attrs: {
	      "title": "success alert",
	      "type": "success",
	      "show-icon": ""
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
	    attrs: {
	      "title": "info alert",
	      "type": "info",
	      "show-icon": ""
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
	    attrs: {
	      "title": "warning alert",
	      "type": "warning",
	      "show-icon": ""
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
	    attrs: {
	      "title": "error alert",
	      "type": "error",
	      "show-icon": ""
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Customizable close button")]), _vm._v(" "), _c('p', [_vm._v("Customize the close button as texts or other symbols.")]), _vm._v(" "), _c('el-alert', {
	    attrs: {
	      "title": "unclosable alert",
	      "type": "success",
	      "closable": false
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
	    attrs: {
	      "title": "customized close-text",
	      "type": "info",
	      "close-text": "Gotcha"
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
	    attrs: {
	      "title": "alert with callback",
	      "type": "warning"
	    },
	    on: {
	      "close": _vm.hello
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("With icon and description")]), _vm._v(" "), _c('p', [_vm._v("Description includes a message with more detailed information.")]), _vm._v(" "), _c('el-alert', {
	    attrs: {
	      "title": "success alert",
	      "type": "success",
	      "description": "more text description",
	      "show-icon": ""
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
	    attrs: {
	      "title": "info alert",
	      "type": "info",
	      "description": "more text description",
	      "show-icon": ""
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
	    attrs: {
	      "title": "warning alert",
	      "type": "warning",
	      "description": "more text description",
	      "show-icon": ""
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
	    attrs: {
	      "title": "error alert",
	      "type": "error",
	      "description": "more text description",
	      "show-icon": ""
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Typography")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": "20"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('h3', [_c('strong', [_vm._v("Heading")])])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 18
	    }
	  }, [_c('h1', [_vm._v("h1. This is a very large header.")]), _vm._v(" "), _c('h2', [_vm._v("h2. This is a large header.")]), _vm._v(" "), _c('h3', [_vm._v("h3. This is a medium header.")]), _vm._v(" "), _c('h4', [_vm._v("h4. This is a moderate header.")]), _vm._v(" "), _c('h5', [_vm._v("h5. This is a small header.")]), _vm._v(" "), _c('h6', [_vm._v("h6. This is a tiny header.")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": "20"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('p', [_c('strong', [_vm._v("Blockquote")])])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 18
	    }
	  }, [_c('blockquote', [_vm._v("Those people who think they know everything are a great annoyance to those of us who do. "), _c('cite', [_vm._v("Isaac Asimov")])])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": "20"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('p', [_c('strong', [_vm._v("Code")])])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 18
	    }
	  }, [_c('code', [_vm._v("Those people who think they know everything are a great annoyance to those of us who do. ")])])], 1)], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 993:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-center"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Forms Timepicker"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Forms ")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Timepicker")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h4', [_vm._v("Fixed time picker")]), _vm._v(" "), _c('p', [_vm._v("Provide a list of fixed time for users to choose")]), _vm._v(" "), _c('el-time-select', {
	    attrs: {
	      "picker-options": {
	        start: '08:30',
	        step: '00:15',
	        end: '18:30'
	      },
	      "placeholder": "Select time"
	    },
	    model: {
	      value: (_vm.value1),
	      callback: function($$v) {
	        _vm.value1 = $$v
	      },
	      expression: "value1"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h4', {
	    staticClass: "box-title"
	  }, [_vm._v("Arbitrary time picker")]), _vm._v(" "), _c('p', [_vm._v("Can pick an arbitrary time.")]), _vm._v(" "), _c('el-time-picker', {
	    attrs: {
	      "picker-options": {
	        selectableRange: '18:30:00 - 20:30:00'
	      },
	      "placeholder": "Arbitrary time"
	    },
	    model: {
	      value: (_vm.value2),
	      callback: function($$v) {
	        _vm.value2 = $$v
	      },
	      expression: "value2"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h4', [_vm._v("Fixed time range")]), _vm._v(" "), _c('p', [_vm._v("f start time is picked at first, then the end time will change accordingly.")]), _vm._v(" "), _c('el-time-select', {
	    attrs: {
	      "placeholder": "Start time",
	      "picker-options": {
	        start: '08:30',
	        step: '00:15',
	        end: '18:30'
	      }
	    },
	    model: {
	      value: (_vm.startTime),
	      callback: function($$v) {
	        _vm.startTime = $$v
	      },
	      expression: "startTime"
	    }
	  }), _vm._v(" "), _c('el-time-select', {
	    attrs: {
	      "placeholder": "End time",
	      "picker-options": {
	        start: '08:30',
	        step: '00:15',
	        end: '18:30',
	        minTime: _vm.startTime
	      }
	    },
	    model: {
	      value: (_vm.endTime),
	      callback: function($$v) {
	        _vm.endTime = $$v
	      },
	      expression: "endTime"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h4', {
	    staticClass: "box-title"
	  }, [_vm._v("Arbitrary time range ")]), _vm._v(" "), _c('p', [_vm._v("Can pick an arbitrary time range.")]), _vm._v(" "), _c('el-time-picker', {
	    attrs: {
	      "is-range": "",
	      "placeholder": "Pick a time range"
	    },
	    model: {
	      value: (_vm.value3),
	      callback: function($$v) {
	        _vm.value3 = $$v
	      },
	      expression: "value3"
	    }
	  })], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 994:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0, false, false), _vm._v(" "), _c('main', {
	    staticClass: "wrapper-404"
	  }, [_c('div', {
	    staticClass: "error-404"
	  }, [_vm._m(1, false, false), _vm._v(" "), _c('h1', [_c('vue-typer', {
	    attrs: {
	      "text": ["Oops! Page not found", "We could not find the page you were looking for", "Meanwhile", "you may return to dashboard", "or try using the search form."],
	      "repeat": Infinity,
	      "shuffle": false,
	      "initial-action": "typing",
	      "pre-type-delay": 70,
	      "type-delay": 70,
	      "pre-erase-delay": 2000,
	      "erase-delay": 250,
	      "erase-style": "clear",
	      "erase-on-complete": false,
	      "caret-animation": "solid"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "moon"
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n                404 Error Page\n            ")]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Examples")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("404 error")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "error-number"
	  }, [_c('span', [_vm._v("4")]), _c('span', [_c('img', {
	    staticClass: "icon has-animation",
	    attrs: {
	      "src": "https://image.flaticon.com/icons/svg/179/179595.svg",
	      "alt": ""
	    }
	  })]), _c('span', [_vm._v("4")])])
	}]}

/***/ }),

/***/ 995:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-center"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Forms Select"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Forms ")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Select")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h4', [_vm._v("Basic Usage")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("v-model")]), _vm._v(" is the value of "), _c('code', [_vm._v("el-option")]), _vm._v(" that is currently selected.")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.value),
	      callback: function($$v) {
	        _vm.value = $$v
	      },
	      expression: "value"
	    }
	  }, _vm._l((_vm.options), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Disable Options")]), _vm._v(" "), _c('p', [_vm._v("Set the value of "), _c('code', [_vm._v("disabled")]), _vm._v(" in "), _c('code', [_vm._v("el-option")]), _vm._v(" to "), _c('code', [_vm._v("true")]), _vm._v(" to disable this option.")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select Disable Option"
	    },
	    model: {
	      value: (_vm.value2),
	      callback: function($$v) {
	        _vm.value2 = $$v
	      },
	      expression: "value2"
	    }
	  }, _vm._l((_vm.options2), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value,
	        "disabled": item.disabled
	      }
	    })
	  })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Grouping")]), _vm._v(" "), _c('p', [_vm._v("Use "), _c('code', [_vm._v("el-option-group")]), _vm._v(" to group the options, and its "), _c('code', [_vm._v("label")]), _vm._v(" attribute stands for the name of the group.")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.value7),
	      callback: function($$v) {
	        _vm.value7 = $$v
	      },
	      expression: "value7"
	    }
	  }, _vm._l((_vm.options3), function(group) {
	    return _c('el-option-group', {
	      key: group.label,
	      attrs: {
	        "label": group.label
	      }
	    }, _vm._l((group.options), function(item) {
	      return _c('el-option', {
	        key: item.value,
	        attrs: {
	          "label": item.label,
	          "value": item.value
	        }
	      })
	    }))
	  })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Remote Search")]), _vm._v(" "), _c('p', [_vm._v("Enter keywords and search data from server.")]), _vm._v(" "), _c('p', [_vm._v("Set the value of "), _c('code', [_vm._v("filterable")]), _vm._v(" and "), _c('code', [_vm._v("remote")]), _vm._v(" with "), _c('code', [_vm._v("true")]), _vm._v(" to enable remote search, and you should pass the "), _c('code', [_vm._v("remote-method")]), _vm._v(". "), _c('code', [_vm._v("remote-method")]), _vm._v(" is a "), _c('code', [_vm._v("Function")]), _vm._v(" that gets called when the input value changes, and its parameter is the current input value. Note that if "), _c('code', [_vm._v("el-option")]), _vm._v(" is rendered with the "), _c('code', [_vm._v("v-for")]), _vm._v(" directive, you should add the "), _c('code', [_vm._v("key")]), _vm._v(" attribute for "), _c('code', [_vm._v("el-option")]), _vm._v(". Its value needs to be unique, such as "), _c('code', [_vm._v("item.value")]), _vm._v(" in the following example.")]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "multiple": "",
	      "filterable": "",
	      "remote": "",
	      "placeholder": "Please enter a keyword",
	      "remote-method": _vm.remoteMethod,
	      "loading": _vm.loading
	    },
	    model: {
	      value: (_vm.value9),
	      callback: function($$v) {
	        _vm.value9 = $$v
	      },
	      expression: "value9"
	    }
	  }, _vm._l((_vm.options4), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }))], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 996:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('aside', {
	    staticClass: "main-sidebar"
	  }, [_c('div', [_c('section', {
	    staticClass: "sidebar"
	  }, [_vm._m(0, false, false), _vm._v(" "), _c('ul', {
	    staticClass: "sidebar-menu"
	  }, [_c('li', {
	    staticClass: "header"
	  }, [_vm._v("APPS")]), _vm._v(" "), _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(1, false, false), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/dashboard"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Dashaboard One",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Dashboard 1")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/dashboard-second"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Dashaboard Two",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Dashboard 2")], 1)], 1)])]), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/mail"
	    }
	  }, [_c('i', {
	    staticClass: "ti-email"
	  }), _vm._v(" "), _c('span', [_vm._v("Mail Apps")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/chat"
	    }
	  }, [_c('i', {
	    staticClass: "ti-comment-alt"
	  }), _vm._v(" "), _c('span', [_vm._v("Chat Apps")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/calendar"
	    }
	  }, [_c('i', {
	    staticClass: "ti-calendar"
	  }), _vm._v(" "), _c('span', [_vm._v("Calendar Apps")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/todo"
	    }
	  }, [_c('i', {
	    staticClass: "ti-write"
	  }), _vm._v(" "), _c('span', [_vm._v("ToDo Apps")])])], 1), _vm._v(" "), _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(2, false, false), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "http://devin.ndesaintheme.com"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Gradient",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Gradient Skin")], 1)]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "http://devin-dark.ndesaintheme.com"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Dark",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Dark Skin")], 1)]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "http://devin-light.ndesaintheme.com"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Light",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Light Skin")], 1)]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "http://devin-black.ndesaintheme.com"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Black",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Black Skin")], 1)])])]), _vm._v(" "), _c('li', {
	    staticClass: "header"
	  }, [_vm._v("PAGES")]), _vm._v(" "), _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(3, false, false), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/blog-list"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Blog List",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Blog List ")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/blog-mansory"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Blog Mansory",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Blog Mansory ")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/blog-details"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Blog Details",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Blog Details ")], 1)], 1)])]), _vm._v(" "), _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(4, false, false), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/shop-home"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "hop Home Page",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Shop Home ")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/shop-item"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Shop Item",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Shop Item")], 1)], 1)])]), _vm._v(" "), _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(5, false, false), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/invoice"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Invoice",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Invoice")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/profile"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Profile",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Profile")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/login"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Login",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Login")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/404"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "404",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" 404 Error")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/500"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "500",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" 500 Error")], 1)], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/blank-page"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Blank Page",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Blank Page")], 1)], 1)])]), _vm._v(" "), _c('li', {
	    staticClass: "header"
	  }, [_vm._v("GENERALS")]), _vm._v(" "), _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(6, false, false), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/form/radio"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Radio",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Radio")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/form/checkbox"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Check Box",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Checkbox")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/form/input"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Input",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Input")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/form/select"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Select",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Select")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/form/cascader"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Cascader",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Cascader")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/form/switch"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Switch",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Switch")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/form/Slider"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Slider",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Slider")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/form/timepicker"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Time Picker",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Time Picker")], 1)], 1)])]), _vm._v(" "), _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(7, false, false), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/chart/chartjs"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Chart Line",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Chart Line")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/chart-bar"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Chart Bar",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Chart Bar")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/chart-pie"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Chart Pie",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Chart Pie")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/chart/vuebar"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Radio",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Vue Bar")], 1)], 1)])]), _vm._v(" "), _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(8, false, false), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/ui/ui-editor"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Editor",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Editor")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/ui/ui-upload"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Upload",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Upload")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/UI/general"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "General",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" General")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/UI/icons"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Icons",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Icons")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/UI/buttons"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Buttons",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Buttons")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/UI/timeline"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Timeline",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Timeline")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/UI/modals"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Modals",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" Modals")], 1)], 1)])]), _vm._v(" "), _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(9, false, false), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/simple-table"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Simple Table",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Simple Tables")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/select-table"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Select Table",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Select Tables")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/expandable-table"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Expandable Table",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Expandable Tables")], 1)], 1)])]), _vm._v(" "), _c('li', {
	    staticClass: "treeview"
	  }, [_vm._m(10, false, false), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/gmap"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "GMaps API",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v(" GMaps API")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/open-layer"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "O P",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Open Layer")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/chart/chart-map"
	    }
	  }, [_c('avatar', {
	    attrs: {
	      "username": "Maps Vector",
	      "size": 20,
	      "color": "#fff"
	    }
	  }), _vm._v("Maps Vector")], 1)], 1)])]), _vm._v(" "), _c('li', {
	    staticClass: "header palette-Cyan-400 bg"
	  }, [_vm._v("DEVIN VUE 1.2")]), _vm._v(" "), _vm._m(11, false, false), _vm._v(" "), _vm._m(12, false, false), _vm._v(" "), _vm._m(13, false, false), _vm._v(" "), _vm._m(14, false, false)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user-panel"
	  }, [_c('div', {
	    staticClass: "image"
	  }, [_c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": "static/img/avatar2.png",
	      "alt": "User Image"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info"
	  }, [_c('p', [_vm._v("Good Job, Matirasa")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("You haven,t miss any task this week!")])]), _vm._v(" "), _c('div', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-panel"
	  }), _c('small', [_vm._v("Settings")])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-user"
	  }), _c('small', [_vm._v("Profile")])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-power-off"
	  }), _c('small', [_vm._v("Logout")])])])]), _vm._v(" "), _c('img', {
	    staticClass: "bg-user",
	    attrs: {
	      "src": "static/img/avatar-bg.png",
	      "alt": "User Image"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-desktop"
	  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-paint-roller"
	  }), _vm._v(" "), _c('span', [_vm._v("Skin")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-layout-accordion-list"
	  }), _vm._v(" "), _c('span', [_vm._v("Blog")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-shopping-cart-full"
	  }), _vm._v(" "), _c('span', [_vm._v("E Commerce")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-layout-media-overlay"
	  }), _vm._v(" "), _c('span', [_vm._v("Common Page")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-write"
	  }), _vm._v(" "), _c('span', [_vm._v("Forms")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-bar-chart"
	  }), _vm._v(" "), _c('span', [_vm._v("Charts")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-folder"
	  }), _vm._v(" "), _c('span', [_vm._v("UI Elements")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-layout"
	  }), _vm._v(" "), _c('span', [_vm._v("Tables")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-location-pin"
	  }), _vm._v(" "), _c('span', [_vm._v("Maps")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    attrs: {
	      "href": "http://ndesaintheme.com/devin/doc"
	    }
	  }, [_c('span', [_vm._v("Documentation")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa ti-agenda pull-right version"
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', [_vm._v("About")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa ti-info-alt pull-right version"
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', [_vm._v("Feedback")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "version fa ti-package pull-right"
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
	}]}

/***/ }),

/***/ 997:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Icons Page"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Icons Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "min-height": "400px"
	    }
	  }, [_c('el-tabs', {
	    on: {
	      "tab-click": _vm.handleClick
	    },
	    model: {
	      value: (_vm.activeName),
	      callback: function($$v) {
	        _vm.activeName = $$v
	      },
	      expression: "activeName"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "label": "Themify Icons",
	      "name": "first"
	    }
	  }, [_c('div', {
	    staticClass: "entypo-tooltip"
	  }, [_c('p', [_vm._v("WEB APP ICONS")]), _vm._v(" "), _c('ul', [_c('li', {
	    staticClass: "ti-wand"
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-save "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-save-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-direction "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-direction-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-user "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-link "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-unlink "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-trash "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-target "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-tag "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-desktop "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-tablet "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-mobile "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-email "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-star "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-spray "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-signal "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-shopping-cart "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-shopping-cart-full "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-settings "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-search "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-zoom-in "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-zoom-out "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-cut "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-ruler "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-ruler-alt-2 "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-ruler-pencil "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-ruler-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-bookmark "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-bookmark-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-reload "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-plus "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-minus "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-close "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-pin "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-pencil "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-pencil-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-paint-roller "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-paint-bucket "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-na "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-medall "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-medall-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-marker "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-marker-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-lock "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-unlock "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-location-arrow "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layers "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layers-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-key "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-image "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-heart "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-heart-broken "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-hand-stop "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-hand-open "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-hand-drag "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-flag "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-flag-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-flag-alt-2 "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-eye "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-import "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-export "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-cup "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-crown "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-comments "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-comment "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-comment-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-thought "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-clip "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-check "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-check-box "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-camera "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-announcement "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-brush "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-brush-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-palette "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-briefcase "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-bolt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-bolt-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-blackboard "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-bag "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-world "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-wheelchair "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-car "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-truck "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-timer "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-ticket "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-thumb-up "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-thumb-down "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-stats-up "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-stats-down "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-shine "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-shift-right "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-shift-left "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-shift-right-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-shift-left-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-shield "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-notepad "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-server "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-pulse "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-printer "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-power-off "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-plug "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-pie-chart "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-panel "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-package "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-music "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-music-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-mouse "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-mouse-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-money "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-microphone "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-menu "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-menu-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-map "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-map-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-location-pin "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-light-bulb "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-info "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-infinite "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-id-badge "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-hummer "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-home "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-help "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-headphone "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-harddrives "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-harddrive "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-gift "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-game "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-filter "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-files "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-file "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-zip "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-folder "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-envelope "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-dashboard "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-cloud "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-cloud-up "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-cloud-down "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-clipboard "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-calendar "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-book "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-bell "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-basketball "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-bar-chart "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-bar-chart-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-archive "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-anchor "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-alert "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-alarm-clock "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-agenda "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-write "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-wallet "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-video-clapper "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-video-camera "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-vector "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-support "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-stamp "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-slice "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-shortcode "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-receipt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-pin2 "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-pin-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-pencil-alt2 "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-eraser "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-more "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-more-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-microphone-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-magnet "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-line-double "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-line-dotted "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-line-dashed "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-ink-pen "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-info-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-help-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-headphone-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-gallery "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-face-smile "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-face-sad "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-credit-card "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-comments-smiley "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-time "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-share "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-share-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-rocket "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-new-window "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-rss "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-rss-alt "
	  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("LAYOUT ICONS")]), _vm._v(" "), _c('ul', [_c('li', {
	    staticClass: "ti-layout-width-full "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-width-default "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-width-default-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-tab "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-tab-window "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-tab-v "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-tab-min "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-slider "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-slider-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-sidebar-right "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-sidebar-none "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-sidebar-left "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-placeholder "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-menu "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-menu-v "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-menu-separated "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-menu-full "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-media-right "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-media-right-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-media-overlay "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-media-overlay-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-media-overlay-alt-2 "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-media-left "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-media-left-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-media-center "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-media-center-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-list-thumb "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-list-thumb-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-list-post "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-list-large-image "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-line-solid "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-grid4 "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-grid3 "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-grid2 "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-grid2-thumb "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-cta-right "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-cta-left "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-cta-center "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-cta-btn-right "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-cta-btn-left "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-column4 "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-column3 "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-column2 "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-accordion-separated "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-accordion-merged "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-accordion-list "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-widgetized "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-widget "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-widget-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-view-list "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-view-list-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-view-grid "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-upload "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-download "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-loop "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-sidebar-2 "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-grid4-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-grid3-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-grid2-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-column4-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-column3-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-layout-column2-alt "
	  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("BRAND ICONS")]), _vm._v(" "), _c('ul', [_c('li', {
	    staticClass: "ti-flickr",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "ti-flickr"
	    }
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-flickr-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-instagram "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-google "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-github "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-facebook "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-dropbox "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-dropbox-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-dribbble "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-apple "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-android "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-yahoo "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-trello "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-stack-overflow "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-soundcloud "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-sharethis "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-sharethis-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-reddit "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-microsoft "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-microsoft-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-linux "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-jsfiddle "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-joomla "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-html5 "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-css3 "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-drupal "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-wordpress "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-tumblr "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-tumblr-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-skype "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-youtube "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-vimeo "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-vimeo-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-twitter "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-twitter-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-linkedin "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-pinterest "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-pinterest-alt "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-themify-logo "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-themify-favicon "
	  }), _vm._v(" "), _c('li', {
	    staticClass: "ti-themify-favicon-alt "
	  })])])]), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": "Material Icons",
	      "name": "second"
	    }
	  }, [_c('div', {
	    staticClass: "entypo-tooltip"
	  }, [_c('p', [_vm._v("A")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("3d_rotation")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("ac_unit")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("access_alarm")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("access_alarms")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("access_time")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("accessibility")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("accessible")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("account_balance")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("account_balance_wallet")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("account_box")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("account_circle")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("adb")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("add")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("add_a_photo")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("add_alarm")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("add_alert")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("add_box")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("add_circle")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("add_circle_outline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("add_location")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("add_shopping_cart")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("add_to_photos")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("add_to_queue")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("adjust")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("airline_seat_flat")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("airline_seat_flat_angled")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("airline_seat_individual_suite")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("airline_seat_legroom_extra")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("airline_seat_legroom_normal")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("airline_seat_legroom_reduced")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("airline_seat_recline_extra")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("airline_seat_recline_normal")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("airplanemode_active")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("airplanemode_inactive")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("airplay")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("airport_shuttle")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("alarm")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("alarm_add")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("alarm_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("alarm_on")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("album")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("all_inclusive")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("all_out")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("android")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("announcement")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("apps")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("archive")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("arrow_back")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("arrow_downward")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("arrow_drop_down")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("arrow_drop_down_circle")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("arrow_drop_up")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("arrow_forward")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("arrow_upward")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("art_track")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("aspect_ratio")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("assessment")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("assignment")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("assignment_ind")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("assignment_late")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("assignment_return")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("assignment_returned")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("assignment_turned_in")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("assistant")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("assistant_photo")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("attach_file")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("attach_money")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("attachment")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("audiotrack")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("autorenew")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("av_timer")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("B")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("backspace")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("backup")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("battery_alert")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("battery_charging_full")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("battery_full")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("battery_std")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("battery_unknown")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("beach_access")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("beenhere")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("block")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("bluetooth")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("bluetooth_audio")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("bluetooth_connected")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("bluetooth_disabled")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("bluetooth_searching")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("blur_circular")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("blur_linear")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("blur_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("blur_on")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("book")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("bookmark")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("bookmark_border")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("border_all")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("border_bottom")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("border_clear")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("border_color")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("border_horizontal")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("border_inner")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("border_left")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("border_outer")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("border_right")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("border_style")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("border_top")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("border_vertical")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("branding_watermark")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("brightness_1")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("brightness_2")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("brightness_3")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("brightness_4")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("brightness_5")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("brightness_6")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("brightness_7")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("brightness_auto")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("brightness_high")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("brightness_low")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("brightness_medium")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("broken_image")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("brush")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("bubble_chart")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("bug_report")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("build")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("burst_mode")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("business")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("business_center")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("C")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("cached")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("cake")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("call")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("call_end")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("call_made")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("call_merge")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("call_missed")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("call_missed_outgoing")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("call_received")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("call_split")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("call_to_action")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("camera")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("camera_alt")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("camera_enhance")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("camera_front")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("camera_rear")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("camera_roll")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("cancel")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("card_giftcard")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("card_membership")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("card_travel")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("casino")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("cast")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("cast_connected")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("center_focus_strong")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("center_focus_weak")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("change_history")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("chat")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("chat_bubble")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("chat_bubble_outline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("check")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("check_box")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("check_box_outline_blank")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("check_circle")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("chevron_left")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("chevron_right")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("child_care")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("child_friendly")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("chrome_reader_mode")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("class")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("clear")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("clear_all")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("close")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("closed_caption")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("cloud")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("cloud_circle")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("cloud_done")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("cloud_download")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("cloud_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("cloud_queue")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("cloud_upload")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("code")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("collections")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("collections_bookmark")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("color_lens")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("colorize")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("comment")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("compare")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("compare_arrows")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("computer")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("confirmation_number")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("contact_mail")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("contact_phone")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("contacts")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("content_copy")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("content_cut")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("content_paste")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("control_point")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("control_point_duplicate")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("copyright")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("create")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("create_new_folder")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("credit_card")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("crop")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("crop_16_9")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("crop_3_2")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("crop_5_4")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("crop_7_5")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("crop_din")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("crop_free")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("crop_landscape")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("crop_original")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("crop_portrait")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("crop_rotate")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("crop_square")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("D")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("dashboard")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("data_usage")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("date_range")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("dehaze")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("delete")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("delete_forever")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("delete_sweep")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("description")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("desktop_mac")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("desktop_windows")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("details")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("developer_board")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("developer_mode")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("device_hub")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("devices")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("devices_other")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("dialer_sip")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("dialpad")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("directions")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("directions_bike")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("directions_boat")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("directions_bus")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("directions_car")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("directions_railway")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("directions_run")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("directions_subway")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("directions_transit")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("directions_walk")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("disc_full")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("dns")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("do_not_disturb")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("do_not_disturb_alt")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("do_not_disturb_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("do_not_disturb_on")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("dock")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("domain")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("done")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("done_all")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("donut_large")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("donut_small")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("drafts")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("drag_handle")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("drive_eta")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("dvr")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("E")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("edit")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("edit_location")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("eject")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("email")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("enhanced_encryption")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("equalizer")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("error")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("error_outline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("euro_symbol")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("ev_station")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("event")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("event_available")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("event_busy")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("event_note")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("event_seat")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("exit_to_app")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("expand_less")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("expand_more")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("explicit")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("explore")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("exposure")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("exposure_neg_1")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("exposure_neg_2")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("exposure_plus_1")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("exposure_plus_2")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("exposure_zero")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("extension")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("F")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("face")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("fast_forward")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("fast_rewind")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("favorite")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("favorite_border")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("featured_play_list")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("featured_video")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("feedback")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("fiber_dvr")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("fiber_manual_record")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("fiber_new")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("fiber_pin")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("fiber_smart_record")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("file_download")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("file_upload")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_1")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_2")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_3")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_4")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_5")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_6")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_7")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_8")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_9")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_9_plus")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_b_and_w")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_center_focus")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_drama")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_frames")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_hdr")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_list")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_none")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_tilt_shift")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("filter_vintage")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("find_in_page")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("find_replace")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("fingerprint")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("first_page")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("fitness_center")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("flag")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("flare")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("flash_auto")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("flash_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("flash_on")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("flight")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("flight_land")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("flight_takeoff")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("flip")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("flip_to_back")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("flip_to_front")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("folder")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("folder_open")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("folder_shared")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("folder_special")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("font_download")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_align_center")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_align_justify")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_align_left")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_align_right")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_bold")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_clear")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_color_fill")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_color_reset")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_color_text")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_indent_decrease")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_indent_increase")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_italic")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_line_spacing")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_list_bulleted")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_list_numbered")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_paint")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_quote")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_shapes")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_size")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_strikethrough")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_textdirection_l_to_r")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_textdirection_r_to_l")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("format_underlined")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("forum")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("forward")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("forward_10")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("forward_30")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("forward_5")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("free_breakfast")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("fullscreen")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("fullscreen_exit")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("functions")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("G")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("g_translate")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("gamepad")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("games")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("gavel")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("gesture")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("get_app")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("gif")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("golf_course")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("gps_fixed")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("gps_not_fixed")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("gps_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("grade")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("gradient")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("grain")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("graphic_eq")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("grid_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("grid_on")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("group")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("group_add")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("group_work")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("H")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("hd")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("hdr_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("hdr_on")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("hdr_strong")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("hdr_weak")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("headset")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("headset_mic")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("healing")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("hearing")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("help")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("high_quality")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("highlight")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("highlight_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("history")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("home")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("hot_tub")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("hotel")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("hourglass_empty")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("hourglass_full")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("http")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("https")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("I")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("image")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("image_aspect_ratio")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("import_contacts")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("import_export")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("important_devices")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("inbox")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("indeterminate_check_box")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("info")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("info_outline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("input")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("insert_chart")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("insert_comment")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("insert_drive_file")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("insert_emoticon")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("insert_invitation")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("insert_link")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("insert_photo")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("invert_colors")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("invert_colors_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("iso")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("K")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("keyboard")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("keyboard_arrow_down")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("keyboard_arrow_left")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("keyboard_arrow_right")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("keyboard_arrow_up")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("keyboard_backspace")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("keyboard_capslock")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("keyboard_hide")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("keyboard_return")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("keyboard_tab")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("keyboard_voice")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("kitchen")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("L")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("label")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("label_outline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("landscape")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("language")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("laptop")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("laptop_chromebook")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("laptop_mac")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("laptop_windows")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("last_page")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("launch")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("layers")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("layers_clear")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("leak_add")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("leak_remove")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("lens")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("library_add")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("library_books")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("library_music")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("lightbulb_outline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("line_style")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("line_weight")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("linear_scale")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("link")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("linked_camera")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("list")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("live_help")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("live_tv")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_activity")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_airport")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_atm")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_bar")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_cafe")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_car_wash")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_convenience_store")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_dining")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_drink")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_florist")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_gas_station")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_grocery_store")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_hospital")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_hotel")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_laundry_service")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_library")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_mall")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_movies")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_offer")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_parking")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_pharmacy")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_phone")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_pizza")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_play")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_post_office")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_printshop")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_see")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_shipping")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("local_taxi")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("location_city")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("location_disabled")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("location_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("location_on")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("location_searching")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("lock")])]), _vm._v(" >\n                                        "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("lock_open")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("lock_outline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("looks")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("looks_3")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("looks_4")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("looks_5")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("looks_6")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("looks_one")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("looks_two")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("loop")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("loupe")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("low_priority")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("loyalty")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("M")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("mail")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("mail_outline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("map")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("markunread")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("markunread_mailbox")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("memory")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("menu")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("merge_type")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("message")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("mic")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("mic_none")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("mic_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("mms")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("mode_comment")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("mode_edit")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("monetization_on")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("money_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("monochrome_photos")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("mood")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("mood_bad")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("more")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("more_horiz")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("more_vert")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("motorcycle")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("mouse")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("move_to_inbox")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("movie")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("movie_creation")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("movie_filter")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("multiline_chart")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("music_note")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("music_video")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("my_location")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("N")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("nature")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("nature_people")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("navigate_before")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("navigate_next")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("navigation")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("near_me")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("network_cell")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("network_check")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("network_locked")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("network_wifi")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("new_releases")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("next_week")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("nfc")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("no_encryption")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("no_sim")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("not_interested")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("note")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("note_add")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("notifications")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("notifications_active")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("notifications_none")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("notifications_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("notifications_paused")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("o")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("offline_pin")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("ondemand_video")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("opacity")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("open_in_browser")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("open_in_new")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("open_with")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("P")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("pages")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("pageview")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("palette")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("pan_tool")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("panorama")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("panorama_fish_eye")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("panorama_horizontal")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("panorama_vertical")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("panorama_wide_angle")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("party_mode")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("pause")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("pause_circle_filled")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("pause_circle_outline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("payment")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("people")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("people_outline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("perm_camera_mic")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("perm_contact_calendar")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("perm_data_setting")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("perm_device_information")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("perm_identity")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("perm_media")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("perm_phone_msg")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("perm_scan_wifi")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("person")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("person_add")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("person_outline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("person_pin")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("person_pin_circle")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("personal_video")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("pets")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("phone")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("phone_android")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("phone_bluetooth_speaker")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("phone_forwarded")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("phone_in_talk")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("phone_iphone")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("phone_locked")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("phone_missed")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("phone_paused")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("phonelink")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("phonelink_erase")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("phonelink_lock")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("phonelink_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("phonelink_ring")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("phonelink_setup")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("photo")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("photo_album")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("photo_camera")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("photo_filter")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("photo_library")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("photo_size_select_actual")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("photo_size_select_large")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("photo_size_select_small")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("picture_as_pdf")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("picture_in_picture")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("picture_in_picture_alt")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("pie_chart")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("pie_chart_outlined")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("pin_drop")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("place")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("play_arrow")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("play_circle_filled")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("play_circle_outline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("play_for_work")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("playlist_add")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("playlist_add_check")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("playlist_play")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("plus_one")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("poll")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("polymer")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("pool")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("portable_wifi_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("portrait")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("power")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("power_input")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("power_settings_new")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("pregnant_woman")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("present_to_all")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("print")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("priority_high")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("public")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("publish")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Q -R")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("query_builder")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("question_answer")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("queue")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("queue_music")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("queue_play_next")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("radio")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("radio_button_checked")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("radio_button_unchecked")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("rate_review")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("receipt")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("recent_actors")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("record_voice_over")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("redeem")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("redo")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("refresh")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("remove")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("remove_circle")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("remove_circle_outline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("remove_from_queue")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("remove_red_eye")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("remove_shopping_cart")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("reorder")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("repeat")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("repeat_one")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("replay")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("replay_10")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("replay_30")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("replay_5")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("reply")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("reply_all")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("report")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("report_problem")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("restaurant")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("restaurant_menu")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("restore")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("restore_page")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("ring_volume")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("room")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("room_service")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("rotate_90_degrees_ccw")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("rotate_left")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("rotate_right")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("rounded_corner")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("router")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("rowing")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("rss_feed")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("rv_hookup")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("S ")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("satellite")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("save")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("scanner")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("schedule")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("school")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("screen_lock_landscape")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("screen_lock_portrait")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("screen_lock_rotation")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("screen_rotation")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("screen_share")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sd_card")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sd_storage")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("search")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("security")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("select_all")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("send")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sentiment_dissatisfied")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sentiment_neutral")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sentiment_satisfied")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sentiment_very_dissatisfied")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sentiment_very_satisfied")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_applications")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_backup_restore")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_bluetooth")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_brightness")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_cell")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_ethernet")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_input_antenna")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_input_component")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_input_composite")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_input_hdmi")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_input_svideo")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_overscan")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_phone")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_power")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_remote")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_system_daydream")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("settings_voice")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("share")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("shop")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("shop_two")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("shopping_basket")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("shopping_cart")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("short_text")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("show_chart")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("shuffle")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("signal_cellular_4_bar")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("signal_cellular_connected_no_internet_4_bar")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("signal_cellular_no_sim")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("signal_cellular_null")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("signal_cellular_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("signal_wifi_4_bar")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("signal_wifi_4_bar_lock")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("signal_wifi_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sim_card")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sim_card_alert")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("skip_next")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("skip_previous")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("slideshow")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("slow_motion_video")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("smartphone")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("smoke_free")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("smoking_rooms")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sms")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sms_failed")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("snooze")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sort")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sort_by_alpha")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("spa")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("space_bar")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("speaker")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("speaker_group")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("speaker_notes")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("speaker_notes_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("speaker_phone")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("spellcheck")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("star")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("star_border")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("star_half")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("stars")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("stay_current_landscape")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("stay_current_portrait")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("stay_primary_landscape")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("stay_primary_portrait")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("stop")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("stop_screen_share")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("storage")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("store")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("store_mall_directory")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("straighten")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("streetview")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("strikethrough_s")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("style")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("subdirectory_arrow_left")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("subdirectory_arrow_right")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("subject")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("subscriptions")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("subtitles")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("subway")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("supervisor_account")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("surround_sound")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("swap_calls")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("swap_horiz")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("swap_vert")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("swap_vertical_circle")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("switch_camera")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("switch_video")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sync")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sync_disabled")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("sync_problem")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("system_update")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("system_update_alt")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("T - Z")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("tab")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("tab_unselected")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("tablet")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("tablet_android")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("tablet_mac")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("tag_faces")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("tap_and_play")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("terrain")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("text_fields")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("text_format")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("textsms")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("texture")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("theaters")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("thumb_down")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("thumb_up")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("thumbs_up_down")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("time_to_leave")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("timelapse")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("timeline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("timer")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("timer_10")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("timer_3")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("timer_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("title")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("toc")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("today")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("toll")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("tonality")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("touch_app")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("toys")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("track_changes")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("traffic")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("train")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("tram")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("transfer_within_a_station")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("transform")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("translate")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("trending_down")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("trending_flat")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("trending_up")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("tune")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("turned_in")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("turned_in_not")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("tv")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("unarchive")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("undo")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("unfold_less")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("unfold_more")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("update")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("usb")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("verified_user")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("vertical_align_bottom")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("vertical_align_center")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("vertical_align_top")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("vibration")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("video_call")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("video_label")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("video_library")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("videocam")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("videocam_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("videogame_asset")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("view_agenda")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("view_array")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("view_carousel")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("view_column")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("view_comfy")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("view_compact")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("view_day")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("view_headline")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("view_list")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("view_module")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("view_quilt")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("view_stream")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("view_week")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("vignette")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("visibility")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("visibility_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("voice_chat")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("voicemail")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("volume_down")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("volume_mute")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("volume_off")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("volume_up")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("vpn_key")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("vpn_lock")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("wallpaper")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("warning")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("watch")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("watch_later")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("wb_auto")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("wb_cloudy")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("wb_incandescent")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("wb_iridescent")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("wb_sunny")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("wc")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("web")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("web_asset")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("weekend")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("whatshot")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("widgets")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("wifi")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("wifi_lock")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("wifi_tethering")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("work")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("wrap_text")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("youtube_searched_for")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("zoom_in")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("zoom_out")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("zoom_out_map")])])])])]), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "label": "Drip Icons 2.0",
	      "name": "third"
	    }
	  }, [_c('div', {
	    staticClass: "entypo-tooltip"
	  }, [_c('p', [_vm._v("WEB APP ICONS")]), _vm._v(" "), _c('ul', [_c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('alarm'),
	      expression: "'alarm'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-alarm"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('align-center'),
	      expression: "'align-center'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-align-center"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('align-justify'),
	      expression: "'align-justify'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-align-justify"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('align-left'),
	      expression: "'align-left'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-align-left"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('align-right'),
	      expression: "'align-right'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-align-right"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('anchor'),
	      expression: "'anchor'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-anchor"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('archive'),
	      expression: "'archive'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-archive"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('arrow-down'),
	      expression: "'arrow-down'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-arrow-down"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('arrow-left'),
	      expression: "'arrow-left'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-arrow-left"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('arrow-right'),
	      expression: "'arrow-right'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-arrow-right"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('arrow-thin-down'),
	      expression: "'arrow-thin-down'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-arrow-thin-down"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('arrow-thin-left'),
	      expression: "'arrow-thin-left'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-arrow-thin-left"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('arrow-thin-right'),
	      expression: "'arrow-thin-right'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-arrow-thin-right"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('arrow-thin-up'),
	      expression: "'arrow-thin-up'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-arrow-thin-up"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('arrow-up'),
	      expression: "'arrow-up'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-arrow-up"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('article'),
	      expression: "'article'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-article"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('backspace'),
	      expression: "'backspace'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-backspace"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('basket'),
	      expression: "'basket'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-basket"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('basketball'),
	      expression: "'basketball'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-basketball"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('battery-empty'),
	      expression: "'battery-empty'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-battery-empty"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('battery-full'),
	      expression: "'battery-full'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-battery-full"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('battery-low'),
	      expression: "'battery-low'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-battery-low"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('battery-medium'),
	      expression: "'battery-medium'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-battery-medium"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('bell'),
	      expression: "'bell'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-bell"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('blog'),
	      expression: "'blog'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-blog"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('bluetooth'),
	      expression: "'bluetooth'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-bluetooth"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('bold'),
	      expression: "'bold'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-bold"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('bookmark'),
	      expression: "'bookmark'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-bookmark"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('bookmarks'),
	      expression: "'bookmarks'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-bookmarks"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('box'),
	      expression: "'box'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-box"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('briefcase'),
	      expression: "'briefcase'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-briefcase"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('brightness-low'),
	      expression: "'brightness-low'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-brightness-low"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('brightness-max'),
	      expression: "'brightness-max'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-brightness-max"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('brightness-medium'),
	      expression: "'brightness-medium'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-brightness-medium"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('broadcast'),
	      expression: "'broadcast'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-broadcast"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('browser'),
	      expression: "'browser'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-browser"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('browser-upload'),
	      expression: "'browser-upload'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-browser-upload"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('brush'),
	      expression: "'brush'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-brush"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('calendar'),
	      expression: "'calendar'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-calendar"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('camcorder'),
	      expression: "'camcorder'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-camcorder"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('camera'),
	      expression: "'camera'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-camera"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('card'),
	      expression: "'card'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-card"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('cart'),
	      expression: "'cart'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-cart"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('checklist'),
	      expression: "'checklist'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-checklist"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('checkmark'),
	      expression: "'checkmark'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-checkmark"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('chevron-down'),
	      expression: "'chevron-down'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-chevron-down"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('chevron-left'),
	      expression: "'chevron-left'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-chevron-left"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('chevron-right'),
	      expression: "'chevron-right'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-chevron-right"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('chevron-up'),
	      expression: "'chevron-up'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-chevron-up"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('clipboard'),
	      expression: "'clipboard'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-clipboard"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('clock'),
	      expression: "'clock'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-clock"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('clockwise'),
	      expression: "'clockwise'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-clockwise"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('cloud'),
	      expression: "'cloud'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-cloud"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('cloud-download'),
	      expression: "'cloud-download'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-cloud-download"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('cloud-upload'),
	      expression: "'cloud-upload'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-cloud-upload"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('code'),
	      expression: "'code'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-code"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('contract'),
	      expression: "'contract'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-contract"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('contract-2'),
	      expression: "'contract-2'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-contract-2"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('conversation'),
	      expression: "'conversation'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-conversation"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('copy'),
	      expression: "'copy'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-copy"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('crop'),
	      expression: "'crop'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-crop"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('cross'),
	      expression: "'cross'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-cross"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('crosshair'),
	      expression: "'crosshair'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-crosshair"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('cutlery'),
	      expression: "'cutlery'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-cutlery"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('device-desktop'),
	      expression: "'device-desktop'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-device-desktop"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('device-mobile'),
	      expression: "'device-mobile'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-device-mobile"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('device-tablet'),
	      expression: "'device-tablet'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-device-tablet"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('direction'),
	      expression: "'direction'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-direction"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('disc'),
	      expression: "'disc'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-disc"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('document'),
	      expression: "'document'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-document"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('document-delete'),
	      expression: "'document-delete'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-document-delete"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('document-edit'),
	      expression: "'document-edit'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-document-edit"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('document-new'),
	      expression: "'document-new'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-document-new"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('document-remove'),
	      expression: "'document-remove'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-document-remove"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('dot'),
	      expression: "'dot'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-dot"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('dots-2'),
	      expression: "'dots-2'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-dots-2"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('dots-3'),
	      expression: "'dots-3'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-dots-3"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('download'),
	      expression: "'download'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-download"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('duplicate'),
	      expression: "'duplicate'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-duplicate"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('enter'),
	      expression: "'enter'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-enter"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('exit'),
	      expression: "'exit'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-exit"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('expand'),
	      expression: "'expand'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-expand"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('expand-2'),
	      expression: "'expand-2'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-expand-2"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('experiment'),
	      expression: "'experiment'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-experiment"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('export'),
	      expression: "'export'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-export"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('feed'),
	      expression: "'feed'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-feed"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('flag'),
	      expression: "'flag'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-flag"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('flashlight'),
	      expression: "'flashlight'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-flashlight"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('folder'),
	      expression: "'folder'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-folder"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('folder-open'),
	      expression: "'folder-open'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-folder-open"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('forward'),
	      expression: "'forward'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-forward"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('gaming'),
	      expression: "'gaming'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-gaming"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('gear'),
	      expression: "'gear'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-gear"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('graduation'),
	      expression: "'graduation'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-graduation"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('graph-bar'),
	      expression: "'graph-bar'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-graph-bar"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('graph-line'),
	      expression: "'graph-line'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-graph-line"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('graph-pie'),
	      expression: "'graph-pie'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-graph-pie"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('headset'),
	      expression: "'headset'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-headset"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('heart'),
	      expression: "'heart'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-heart"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('help'),
	      expression: "'help'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-help"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('home'),
	      expression: "'home'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-home"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('hourglass'),
	      expression: "'hourglass'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-hourglass"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('inbox'),
	      expression: "'inbox'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-inbox"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('information'),
	      expression: "'information'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-information"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('italic'),
	      expression: "'italic'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-italic"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('jewel'),
	      expression: "'jewel'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-jewel"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('lifting'),
	      expression: "'lifting'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-lifting"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('lightbulb'),
	      expression: "'lightbulb'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-lightbulb"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('link'),
	      expression: "'link'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-link"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('link-broken'),
	      expression: "'link-broken'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-link-broken"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('list'),
	      expression: "'list'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-list"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('loading'),
	      expression: "'loading'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-loading"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('location'),
	      expression: "'location'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-location"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('lock'),
	      expression: "'lock'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-lock"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('lock-open'),
	      expression: "'lock-open'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-lock-open"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('mail'),
	      expression: "'mail'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-mail"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('map'),
	      expression: "'map'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-map"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('media-loop'),
	      expression: "'media-loop'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-media-loop"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('media-next'),
	      expression: "'media-next'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-media-next"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('media-pause'),
	      expression: "'media-pause'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-media-pause"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('media-play'),
	      expression: "'media-play'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-media-play"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('media-previous'),
	      expression: "'media-previous'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-media-previous"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('media-record'),
	      expression: "'media-record'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-media-record"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('media-shuffle'),
	      expression: "'media-shuffle'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-media-shuffle"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('media-stop'),
	      expression: "'media-stop'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-media-stop"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('medical'),
	      expression: "'medical'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-medical"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('menu'),
	      expression: "'menu'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-menu"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('message'),
	      expression: "'message'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-message"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('meter'),
	      expression: "'meter'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-meter"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('microphone'),
	      expression: "'microphone'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-microphone"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('minus'),
	      expression: "'minus'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-minus"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('monitor'),
	      expression: "'monitor'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-monitor"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('move'),
	      expression: "'move'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-move"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('music'),
	      expression: "'music'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-music"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('network-1'),
	      expression: "'network-1'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-network-1"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('network-2'),
	      expression: "'network-2'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-network-2"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('network-3'),
	      expression: "'network-3'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-network-3"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('network-4'),
	      expression: "'network-4'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-network-4"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('network-5'),
	      expression: "'network-5'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-network-5"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('pamphlet'),
	      expression: "'pamphlet'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-pamphlet"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('paperclip'),
	      expression: "'paperclip'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-paperclip"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('pencil'),
	      expression: "'pencil'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-pencil"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('phone'),
	      expression: "'phone'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-phone"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('photo'),
	      expression: "'photo'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-photo"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('photo-group'),
	      expression: "'photo-group'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-photo-group"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('pill'),
	      expression: "'pill'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-pill"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('pin'),
	      expression: "'pin'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-pin"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('plus'),
	      expression: "'plus'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-plus"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('power'),
	      expression: "'power'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-power"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('preview'),
	      expression: "'preview'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-preview"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('print'),
	      expression: "'print'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-print"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('pulse'),
	      expression: "'pulse'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-pulse"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('question'),
	      expression: "'question'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-question"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('reply'),
	      expression: "'reply'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-reply"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('reply-all'),
	      expression: "'reply-all'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-reply-all"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('return'),
	      expression: "'return'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-return"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('retweet'),
	      expression: "'retweet'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-retweet"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('rocket'),
	      expression: "'rocket'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-rocket"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('scale'),
	      expression: "'scale'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-scale"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('search'),
	      expression: "'search'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-search"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('shopping-bag'),
	      expression: "'shopping-bag'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-shopping-bag"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('skip'),
	      expression: "'skip'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-skip"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('stack'),
	      expression: "'stack'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-stack"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('star'),
	      expression: "'star'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-star"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('stopwatch'),
	      expression: "'stopwatch'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-stopwatch"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('store'),
	      expression: "'store'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-store"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('suitcase'),
	      expression: "'suitcase'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-suitcase"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('swap'),
	      expression: "'swap'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-swap"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('tag'),
	      expression: "'tag'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-tag"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('tag-delete'),
	      expression: "'tag-delete'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-tag-delete"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('tags'),
	      expression: "'tags'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-tags"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('thumbs-down'),
	      expression: "'thumbs-down'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-thumbs-down"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('thumbs-up'),
	      expression: "'thumbs-up'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-thumbs-up"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('ticket'),
	      expression: "'ticket'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-ticket"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('time-reverse'),
	      expression: "'time-reverse'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-time-reverse"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('to-do'),
	      expression: "'to-do'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-to-do"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('toggles'),
	      expression: "'toggles'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-toggles"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('trash'),
	      expression: "'trash'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-trash"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('trophy'),
	      expression: "'trophy'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-trophy"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('upload'),
	      expression: "'upload'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-upload"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('user'),
	      expression: "'user'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-user"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('user-group'),
	      expression: "'user-group'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-user-group"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('user-id'),
	      expression: "'user-id'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-user-id"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('vibrate'),
	      expression: "'vibrate'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-vibrate"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('view-apps'),
	      expression: "'view-apps'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-view-apps"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('view-list'),
	      expression: "'view-list'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-view-list"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('view-list-large'),
	      expression: "'view-list-large'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-view-list-large"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('view-thumb'),
	      expression: "'view-thumb'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-view-thumb"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('volume-full'),
	      expression: "'volume-full'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-volume-full"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('volume-low'),
	      expression: "'volume-low'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-volume-low"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('volume-medium'),
	      expression: "'volume-medium'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-volume-medium"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('volume-off'),
	      expression: "'volume-off'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-volume-off"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('wallet'),
	      expression: "'wallet'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-wallet"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('warning'),
	      expression: "'warning'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-warning"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('web'),
	      expression: "'web'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-web"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('weight'),
	      expression: "'weight'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-weight"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('wifi'),
	      expression: "'wifi'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-wifi"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('wrong'),
	      expression: "'wrong'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-wrong"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('zoom-in'),
	      expression: "'zoom-in'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-zoom-in"
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "tooltip",
	      rawName: "v-tooltip.top",
	      value: ('zoom-out'),
	      expression: "'zoom-out'",
	      modifiers: {
	        "top": true
	      }
	    }],
	    staticClass: "dripicons-zoom-out"
	  })])])])], 1)], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 998:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper dashboard-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-xl-4"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body no-pad padding-fifthin",
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_c('div', {
	    staticClass: "events-nest "
	  }, [_c('div', {
	    staticClass: "wrap-no-pad padding-fifthin"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 bor-right bor-bottom"
	  }, [_c('div', {
	    staticClass: "devin-table-dash centered pad-box"
	  }, [_c('i', {
	    staticClass: "palette-Pink-500 bg ti-shopping-cart-full"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "palette-Pink-500 text value"
	  }, [_vm._v("648")]), _vm._v(" "), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Items Sold")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 bor-bottom"
	  }, [_c('div', {
	    staticClass: "devin-table-dash centered pad-box"
	  }, [_c('i', {
	    staticClass: "palette-Purple-500 bg ti-link"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "palette-Purple-500 text value"
	  }, [_vm._v("47.5"), _c('strong', [_vm._v("K")])]), _vm._v(" "), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Followers")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 bor-right"
	  }, [_c('div', {
	    staticClass: "devin-table-dash centered pad-box"
	  }, [_c('i', {
	    staticClass: "palette-Deep-Purple-500 bg ti-wallet"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "value palette-Deep-Purple-500 text"
	  }, [_c('strong', [_vm._v("$")]), _vm._v("764")]), _vm._v(" "), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Daily Earnings")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "devin-table-dash centered pad-box"
	  }, [_c('i', {
	    staticClass: "ti-bag palette-Light-Blue-500 bg"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "value palette-Light-Blue-500 text"
	  }, [_vm._v("256")]), _vm._v(" "), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Products")])])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-xl-4"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body no-pad padding-fifthin",
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_c('div', {
	    staticClass: "events-nest "
	  }, [_c('div', {
	    staticClass: "wrap-no-pad padding-fifthin"
	  }, [_c('div', {
	    staticClass: "pad-box"
	  }, [_c('div', {
	    staticClass: "devin-table-dash bigger"
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v("3059")]), _vm._v(" "), _c('div', {
	    staticClass: "trending trending-up palette-Amber-500 bg"
	  }, [_c('span', [_vm._v("15%")])]), _vm._v(" "), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Products Sold")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "el-chart-w"
	  }, [_c('bars', {
	    attrs: {
	      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 10, 0],
	      "gradient": ['#3bd6c6', '#3b5998']
	    }
	  })], 1), _vm._v(" "), _c('br')])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-xl-4"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body no-pad padding-fifthin",
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_c('div', {
	    staticClass: "events-nest "
	  }, [_c('div', {
	    staticClass: "wrap-no-pad padding-fifthin"
	  }, [_c('div', {
	    staticClass: "pad-box"
	  }, [_c('div', {
	    staticClass: "element-info-with-icon smaller"
	  }, [_c('div', {
	    staticClass: "element-info-text"
	  }, [_c('h5', [_vm._v("Monthly Revenue")]), _vm._v(" "), _c('div', [_vm._v("Calculated every month")])])]), _vm._v(" "), _c('div', {
	    staticClass: "devin-progress-bar"
	  }, [_c('el-progress', {
	    staticClass: "circle-one",
	    attrs: {
	      "type": "circle",
	      "percentage": 63,
	      "width": 50,
	      "stroke-width": 2,
	      "status": "success"
	    }
	  }), _vm._v(" "), _c('el-progress', {
	    staticClass: "bor-left bor-right",
	    staticStyle: {
	      "padding": "0 10px"
	    },
	    attrs: {
	      "type": "circle",
	      "percentage": 75,
	      "width": 125,
	      "stroke-width": 6
	    }
	  }), _vm._v(" "), _c('el-progress', {
	    staticClass: "circle-two",
	    attrs: {
	      "type": "circle",
	      "percentage": 89,
	      "width": 50,
	      "stroke-width": 2,
	      "status": "exception"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "os-progress-bar primary"
	  })])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-xl-6"
	  }, [_c('div', {
	    staticClass: "food"
	  }, [_c('div', {
	    staticClass: "cover",
	    staticStyle: {
	      "background-image": "url(https://source.unsplash.com/category/food/800x600)"
	    }
	  }, [_c('label', [_c('i', {
	    staticClass: "ti-medall-alt"
	  }), _vm._v(" "), _c('font', [_vm._v("CULINARY")])], 1), _vm._v(" "), _c('a', {
	    staticClass: "download",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-truck"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "info"
	  }, [_c('a', {
	    staticClass: "recipe",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-pencil-alt"
	  }), _vm._v(" "), _c('font', [_c('h3', [_vm._v("76.5%")])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "content-food"
	  }, [_c('ul', [_c('li', [_c('strong', [_vm._v("Sweetness")]), _vm._v(" "), _c('el-progress', {
	    attrs: {
	      "text-inside": true,
	      "stroke-width": 15,
	      "percentage": 85
	    }
	  })], 1), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Acidity")]), _vm._v(" "), _c('el-progress', {
	    attrs: {
	      "text-inside": true,
	      "stroke-width": 15,
	      "percentage": 60
	    }
	  })], 1)])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-xl-6"
	  }, [_c('div', {
	    staticClass: "container-widget-two"
	  }, [_c('div', {
	    staticClass: "widget-two"
	  }, [_c('div', {
	    staticClass: "section section-graph"
	  }, [_c('div', {
	    staticClass: "graph-info"
	  }, [_c('i', {
	    staticClass: "ti-home"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "graph-info-big"
	  }, [_vm._v("454.757")]), _vm._v(" "), _c('span', {
	    staticClass: "graph-info-small"
	  }, [_vm._v("+5.78 (5.71%)")])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "graph"
	    }
	  }, [_c('bars', {
	    attrs: {
	      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 10, 8, 9, 5, 9],
	      "gradient": ['#ffffff', '#ffffff']
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "section section-info"
	  }, [_c('span', {
	    staticClass: "info-time"
	  }, [_vm._v("Today 2:25 PM")]), _vm._v(" "), _c('h3', {
	    staticClass: "info-title"
	  }, [_vm._v("Salt Lake City, Utah")]), _vm._v(" "), _c('div', {
	    staticClass: "info-block"
	  }, [_c('dl', [_c('dt', [_c('i', {
	    staticClass: "ti-stats-up"
	  })]), _vm._v(" "), _c('dt', [_vm._v("13.5 M")]), _vm._v(" "), _c('dd', [_vm._v("Shares Traded")])])]), _vm._v(" "), _c('div', {
	    staticClass: "info-block last"
	  }, [_c('dl', [_c('dt', [_c('i', {
	    staticClass: "ti-stats-down"
	  })]), _vm._v(" "), _c('dt', [_vm._v("28.44")]), _vm._v(" "), _c('dd', [_vm._v("Market Cap")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "section"
	  })])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-7 col-xl-7 col-sm-12"
	  }, [_c('div', {
	    attrs: {
	      "id": "weather"
	    }
	  }, [_c('div', {
	    staticClass: "panelLeft"
	  }, [_c('div', {
	    staticClass: "top-cal-devin"
	  }, [_c('p', [_vm._v("JUNY 21, 2017")])]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "https://source.unsplash.com/collection/431862/800x600",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bottom"
	  }, [_c('div', {
	    staticClass: "temp"
	  }, [_c('p', [_vm._v("10°")]), _vm._v(" "), _c('p', [_vm._v("New York City")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "panelRight"
	  }, [_c('div', {
	    staticClass: "customHeight"
	  }, [_c('p', [_vm._v("Statistics")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "wi wi-thermometer"
	  }), _vm._v(" "), _c('p', [_vm._v("35%")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "wi wi-day-rain-mix"
	  }), _vm._v(" "), _c('p', [_vm._v("Easterly")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "wi wi-cloudy-gusts"
	  }), _vm._v(" "), _c('p', [_vm._v("7 mph")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "remainingHeight"
	  }, [_c('ul', {
	    staticClass: "inline"
	  }, [_c('li', {
	    staticClass: "active"
	  }, [_vm._v("Today")]), _vm._v(" "), _c('li', [_vm._v("Week")])]), _vm._v(" "), _c('ul', {
	    staticClass: "forecast"
	  }, [_c('li', [_c('span', {
	    staticClass: "time"
	  }, [_vm._v("Now")]), _vm._v(" "), _c('span', {
	    staticClass: "temp"
	  }, [_vm._v("24°C")]), _vm._v(" "), _c('span', {
	    staticClass: "conditions"
	  }, [_vm._v("Cloudy")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "time"
	  }, [_vm._v("6 AM")]), _vm._v(" "), _c('span', {
	    staticClass: "temp"
	  }, [_vm._v("23°C")]), _vm._v(" "), _c('span', {
	    staticClass: "conditions"
	  }, [_vm._v("Cloudy")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "time"
	  }, [_vm._v("6:59 AM")]), _vm._v(" "), _c('span', {
	    staticClass: "temp"
	  }, [_vm._v("Sunrise")]), _vm._v(" "), _c('span', {
	    staticClass: "conditions"
	  }, [_vm._v("Cloudy")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "time"
	  }, [_vm._v("7 AM")]), _vm._v(" "), _c('span', {
	    staticClass: "temp"
	  }, [_vm._v("24°C")]), _vm._v(" "), _c('span', {
	    staticClass: "conditions"
	  }, [_vm._v("Partly Cloudy")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 col-xl-5 col-sm-12"
	  }, [_c('div', {
	    staticClass: "widget"
	  }, [_c('div', {
	    staticClass: "widget__header"
	  }, [_c('h2', {
	    staticClass: "widget__header-title"
	  }, [_vm._v("\n                                  DNTM\n                                  "), _c('span', {
	    staticClass: "widget__header-author"
	  }, [_vm._v("\n                                    by Abine\n                                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "nav"
	  }, [_c('a', {
	    staticClass: "nav__item",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cubes"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "nav__item",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "nav__item",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gear"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "widget__body"
	  }, [_c('div', {
	    staticClass: "flash"
	  }, [_c('strong', [_vm._v("All 6")]), _vm._v(" companies blocked now ")]), _vm._v(" "), _c('div', {
	    staticClass: "accordion"
	  }, [_c('div', {
	    staticClass: "accordion__item "
	  }, [_c('div', {
	    staticClass: "accordion__header"
	  }, [_c('i', {
	    staticClass: "fa fa-minus accordion__state-icon"
	  }), _vm._v(" "), _c('h2', [_vm._v("Social Networks")])]), _vm._v(" "), _c('div', {
	    staticClass: "accordion__body"
	  }, [_c('div', {
	    staticClass: "accordion__body-item"
	  }, [_c('i', {
	    staticClass: " fa ti-facebook"
	  }), _vm._v(" Facebook ")]), _vm._v(" "), _c('div', {
	    staticClass: "accordion__body-item"
	  }, [_c('i', {
	    staticClass: " fa ti-twitter"
	  }), _vm._v(" Twitter ")]), _vm._v(" "), _c('div', {
	    staticClass: "accordion__body-item"
	  }, [_c('i', {
	    staticClass: " fa ti-instagram"
	  }), _vm._v(" Instagram ")])])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])])
	},staticRenderFns: []}

/***/ }),

/***/ 999:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Blank Page"), _c('small', [_vm._v("It's all start from here "), _c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Blank Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Basic")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "min-height": "400px"
	    }
	  }, [_c('vl-map', {
	    attrs: {
	      "load-tiles-while-animating": true,
	      "load-tiles-while-interacting": true
	    }
	  }, [_c('vl-view', {
	    attrs: {
	      "zoom": 12,
	      "center": [110.3712312, -7.8007611],
	      "rotation": 0
	    }
	  }), _vm._v(" "), _c('vl-geoloc', {
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(ctx) {
	        return [(ctx.position) ? _c('vl-feature', {
	          attrs: {
	            "id": "geoloc-feature"
	          }
	        }, [_c('vl-geom-point', {
	          attrs: {
	            "coordinates": ctx.position
	          }
	        })], 1) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('vl-layer-tile', {
	    attrs: {
	      "id": "osm"
	    }
	  }, [_c('vl-source-osm')], 1)], 1)], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1000:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Tinymce Editor"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("UI Element")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Tinymce Editor")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('vue-editor', {
	    model: {
	      value: (_vm.content),
	      callback: function($$v) {
	        _vm.content = $$v
	      },
	      expression: "content"
	    }
	  })], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1001:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_vm._m(0, false, false), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("EChart Pie")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('ve-pie', {
	    attrs: {
	      "data": _vm.chartData,
	      "settings": _vm.chartSettings
	    }
	  })], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_vm._v("EChart Pie "), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Charts")])])
	}]}

/***/ }),

/***/ 1002:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }]
	  }, [_c('app-header'), _vm._v(" "), _c('app-sidebar'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('control-sidebar')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1003:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-center"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Forms Slider"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Forms ")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Slider")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "block"
	  }, [_c('span', {
	    staticClass: "demonstration"
	  }, [_vm._v("Default value")]), _vm._v(" "), _c('el-slider', {
	    model: {
	      value: (_vm.value1),
	      callback: function($$v) {
	        _vm.value1 = $$v
	      },
	      expression: "value1"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "block"
	  }, [_c('span', {
	    staticClass: "demonstration"
	  }, [_vm._v("Customized initial value")]), _vm._v(" "), _c('el-slider', {
	    model: {
	      value: (_vm.value2),
	      callback: function($$v) {
	        _vm.value2 = $$v
	      },
	      expression: "value2"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "block"
	  }, [_c('span', {
	    staticClass: "demonstration"
	  }, [_vm._v("Hide Tooltip")]), _vm._v(" "), _c('el-slider', {
	    attrs: {
	      "show-tooltip": false
	    },
	    model: {
	      value: (_vm.value3),
	      callback: function($$v) {
	        _vm.value3 = $$v
	      },
	      expression: "value3"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "block"
	  }, [_c('span', {
	    staticClass: "demonstration"
	  }, [_vm._v("Format Tooltip")]), _vm._v(" "), _c('el-slider', {
	    attrs: {
	      "format-tooltip": _vm.formatTooltip
	    },
	    model: {
	      value: (_vm.value4),
	      callback: function($$v) {
	        _vm.value4 = $$v
	      },
	      expression: "value4"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "block"
	  }, [_c('span', {
	    staticClass: "demonstration"
	  }, [_vm._v("Disabled")]), _vm._v(" "), _c('el-slider', {
	    attrs: {
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.value5),
	      callback: function($$v) {
	        _vm.value5 = $$v
	      },
	      expression: "value5"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "block"
	  }, [_c('span', {
	    staticClass: "demonstration"
	  }, [_vm._v("Breakpoints not displayed")]), _vm._v(" "), _c('el-slider', {
	    attrs: {
	      "step": 10
	    },
	    model: {
	      value: (_vm.value6),
	      callback: function($$v) {
	        _vm.value6 = $$v
	      },
	      expression: "value6"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "block"
	  }, [_c('span', {
	    staticClass: "demonstration"
	  }, [_vm._v("Breakpoints displayed")]), _vm._v(" "), _c('el-slider', {
	    attrs: {
	      "step": 10,
	      "show-stops": ""
	    },
	    model: {
	      value: (_vm.value7),
	      callback: function($$v) {
	        _vm.value7 = $$v
	      },
	      expression: "value7"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "block"
	  }, [_c('el-slider', {
	    attrs: {
	      "show-input": ""
	    },
	    model: {
	      value: (_vm.value8),
	      callback: function($$v) {
	        _vm.value8 = $$v
	      },
	      expression: "value8"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "block"
	  }, [_c('el-slider', {
	    attrs: {
	      "range": "",
	      "show-stops": "",
	      "max": 10
	    },
	    model: {
	      value: (_vm.value9),
	      callback: function($$v) {
	        _vm.value9 = $$v
	      },
	      expression: "value9"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "block"
	  }, [_c('el-slider', {
	    attrs: {
	      "vertical": "",
	      "height": "200px"
	    },
	    model: {
	      value: (_vm.value10),
	      callback: function($$v) {
	        _vm.value10 = $$v
	      },
	      expression: "value10"
	    }
	  })], 1)])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1004:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Blank Page"), _c('small', [_vm._v("It's all start from here "), _c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Blank Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Basic")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "min-height": "400px"
	    }
	  }, [_c('h5', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.vm.searchPlace),
	      expression: "vm.searchPlace"
	    }, {
	      name: "gmaps-searchbox",
	      rawName: "v-gmaps-searchbox:location",
	      value: (_vm.vm),
	      expression: "vm",
	      arg: "location"
	    }],
	    staticStyle: {
	      "padding": "5px 10px",
	      "border-radius": "4px",
	      "border": "1px solid #ddd"
	    },
	    attrs: {
	      "placeholder": "Manchester"
	    },
	    domProps: {
	      "value": (_vm.vm.searchPlace)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.vm, "searchPlace", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm._f("json")(_vm.vm)))])])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1005:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Buttons"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Buttons")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Basic")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h4', [_vm._v("Basic usage")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-button', [_vm._v("Default Button")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    }
	  }, [_vm._v("Primary Button")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "text"
	    }
	  }, [_vm._v("Text Button")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Disabled Button")]), _vm._v(" "), _c('p', [_vm._v("The disableds attribute determines if the button is disabled.")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "plain": true,
	      "disabled": true
	    }
	  }, [_vm._v("Default Button")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "disabled": ""
	    }
	  }, [_vm._v("Primary Button")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "text",
	      "disabled": ""
	    }
	  }, [_vm._v("Text Button")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Color Indication")]), _vm._v(" "), _c('p', [_vm._v("Different colors represent different meanings.")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "success"
	    }
	  }, [_vm._v("Success")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "warning"
	    }
	  }, [_vm._v("Warning")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "danger"
	    }
	  }, [_vm._v("Danger")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "info"
	    }
	  }, [_vm._v("Info")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "plain": true,
	      "type": "success"
	    }
	  }, [_vm._v("Success")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "plain": true,
	      "type": "warning"
	    }
	  }, [_vm._v("Warning")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "plain": true,
	      "type": "danger"
	    }
	  }, [_vm._v("Danger")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "plain": true,
	      "type": "info"
	    }
	  }, [_vm._v("Info")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Icon Button")]), _vm._v(" "), _c('p', [_vm._v("Use icons to add more meaning to Button. You can use icon alone to save some space, or with text together.")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "icon": "edit"
	    }
	  }), _vm._v(" "), _c('el-button', {
	    staticClass: "btn-rounded",
	    attrs: {
	      "type": "primary",
	      "icon": "share"
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "icon": "delete"
	    }
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "icon": "search"
	    }
	  }, [_vm._v("Search")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    }
	  }, [_vm._v("Upload "), _c('i', {
	    staticClass: "el-icon-upload el-icon-right"
	  })])], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1006:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Mail Page"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Mail Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "compose"
	  }, [_c('ul', [_c('li', [_c('i', {
	    staticClass: "ti-pencil-alt"
	  }), _c('span', [_vm._v("Compose")])]), _c('li', [_c('i', {
	    staticClass: "ti-import"
	  }), _vm._v("Inbox "), _c('span', [_vm._v("(2,343)")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "ti-new-window"
	  }), _vm._v("Sent Mail")]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "ti-pin-alt"
	  }), _vm._v("Important")]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "ti-zip"
	  }), _vm._v("Draft")]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "ti-trash"
	  }), _vm._v("Trash")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_c('li', {
	    staticClass: "text-orange"
	  }, [_c('i', {
	    staticClass: "ti-control-record"
	  }), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Family")])]), _vm._v(" "), _c('li', {
	    staticClass: "text-red"
	  }, [_c('i', {
	    staticClass: "ti-control-record"
	  }), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Friend")])]), _vm._v(" "), _c('li', {
	    staticClass: "text-blue"
	  }, [_c('i', {
	    staticClass: "ti-control-record"
	  }), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Office")])]), _vm._v(" "), _c('li', {
	    staticClass: "text-aqua"
	  }, [_c('i', {
	    staticClass: "ti-control-record"
	  }), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Social")])]), _vm._v(" "), _c('li', {
	    staticClass: "text-dark-blue"
	  }, [_c('i', {
	    staticClass: "ti-control-record"
	  }), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Unknown")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('div', {
	    staticClass: "inbox-nest"
	  }, [_c('ul', [_c('li', [_c('div', {
	    staticClass: "inbox-header"
	  }, [_c('ul', [_c('li', [_c('span', {
	    staticClass: "ti-reload"
	  }), _vm._v(" Refresh ")]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "ti-export"
	  }), _vm._v(" Reply ")]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "ti-share"
	  }), _vm._v(" Reply All ")]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "ti-trash"
	  }), _vm._v(" Trash ")]), _vm._v(" "), _c('li', {
	    staticClass: "right"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("1-50 of 10,976")])])])])]), _vm._v(" "), _c('li', [_c('img', {
	    staticClass: "img-circle star",
	    attrs: {
	      "alt": "",
	      "src": "http://api.randomuser.me/portraits/thumb/men/22.jpg"
	    }
	  }), _vm._v(" "), _c('b', [_vm._v("David L. Moore")]), _c('i', {
	    staticClass: "icon-attachment"
	  }), _c('i', {
	    staticClass: "text-orange fontello-record"
	  }), _c('small', [_vm._v("Today, 09:21 PM")]), _vm._v(" "), _c('h5', [_vm._v("Will You Be Our Valentine?")]), _vm._v(" "), _c('p', [_vm._v("Hi, John i just want to know about my email that i,ve sending yesterday. Dou you read it? ... ")])]), _vm._v(" "), _c('li', [_c('img', {
	    staticClass: "img-circle star",
	    attrs: {
	      "alt": "",
	      "src": "http://api.randomuser.me/portraits/thumb/women/23.jpg"
	    }
	  }), _vm._v(" "), _c('b', [_vm._v("Helen D. Murray")]), _c('i', {
	    staticClass: "text-blue fontello-record"
	  }), _c('small', [_vm._v("20 Minute ago")]), _vm._v(" "), _c('h5', [_vm._v("World Recod")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam erat nunc, vestibulum eu venenatis ut, feugiat sit amet elit. Donec convallis ornare odio. Donec ac est eget lacus molestie imperdiet vitae ac nunc. Suspendisse odio justo ... ")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "star bg-red",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "fa  fa-google-plus"
	  })]), _vm._v(" "), _c('b', [_vm._v("Google+ (DesignByHuman)")]), _c('i', {
	    staticClass: "text-aqua fontello-record"
	  }), _c('small', [_vm._v("1 Hour Ago")]), _vm._v(" "), _c('h5', [_vm._v("Berbagi pos - \"This #DOTD by Viviana González makes us ..")]), _vm._v(" "), _c('p', [_vm._v("Donec sed mi sem. Maecenas posuere justo dapibus fermentum porttitor. Phasellus ornare lectus a neque molestie sodales. Pellentesque consectetur sed nisl vitae tempor. Duis et odio ut ligula accumsan interdum. ... ")])]), _vm._v(" "), _c('li', [_c('img', {
	    staticClass: "img-circle star",
	    attrs: {
	      "alt": "",
	      "src": "http://api.randomuser.me/portraits/thumb/women/25.jpg"
	    }
	  }), _vm._v(" "), _c('b', [_vm._v("Deanna G. Rumph")]), _c('i', {
	    staticClass: " icon-attachment"
	  }), _c('i', {
	    staticClass: "text-red fontello-record"
	  }), _c('small', [_vm._v("Yesterday, 09:21 PM")]), _vm._v(" "), _c('h5', [_vm._v("A new rating has been received for Aurelo Resume")]), _vm._v(" "), _c('p', [_vm._v("Etiam cursus feugiat nibh eu efficitur. Praesent lobortis imperdiet neque in tempor. Praesent eu molestie urna, nec dapibus mi. Etiam blandit convallis ligula, sodales sodales nulla scelerisque ac ... ")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "star bg-blue",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "fa  fa-twitter"
	  })]), _vm._v(" "), _c('b', [_vm._v("Twitter (@Themesmile)")]), _c('i', {
	    staticClass: "text-aqua fontello-record"
	  }), _c('small', [_vm._v("11 November")]), _vm._v(" "), _c('h5', [_vm._v("Latest tweet from Beyonce")]), _vm._v(" "), _c('p', [_vm._v("Suspendisse cursus purus eget magna molestie, a finibus odio malesuada. Maecenas sodales quam a egestas maximus. Donec ultricies nibh eros, non sagittis odio convallis posuere. Nam dolor velit, tincidunt in libero vel ... ")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "star bg-dark-blue",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "fa  fa-facebook"
	  })]), _vm._v(" "), _c('b', [_vm._v("Facebook ( Gifta Kamilia Putri)")]), _c('i', {
	    staticClass: "text-aqua fontello-record"
	  }), _c('small', [_vm._v("10 November")]), _vm._v(" "), _c('h5', [_vm._v("People that may you know!")]), _vm._v(" "), _c('p', [_vm._v("Fusce eros lectus, hendrerit sit amet nibh et, accumsan sollicitudin urna. Maecenas ac ex id velit imperdiet tincidunt consectetur vel neque. Morbi ornare nibh sapien, sit amet tempus risus dapibus vitae. Donec volutpat, libero sit amet faucibus placerat ... ")])]), _vm._v(" "), _c('li', [_c('img', {
	    staticClass: "img-circle star",
	    attrs: {
	      "alt": "",
	      "src": "http://api.randomuser.me/portraits/thumb/men/40.jpg"
	    }
	  }), _vm._v(" "), _c('b', [_vm._v("James B. Miller")]), _c('i', {
	    staticClass: "icon-attachment"
	  }), _c('i', {
	    staticClass: "text-orange fontello-record"
	  }), _c('small', [_vm._v("10 November")]), _vm._v(" "), _c('h5', [_vm._v("Will You Be Our Valentine?")]), _vm._v(" "), _c('p', [_vm._v("Hi, John i just want to know about my email that i,ve sending yesterday. Dou you read it? ... ")])]), _vm._v(" "), _c('li', [_c('img', {
	    staticClass: "img-circle star",
	    attrs: {
	      "alt": "",
	      "src": "http://api.randomuser.me/portraits/thumb/men/41.jpg"
	    }
	  }), _vm._v(" "), _c('b', [_vm._v("John P. McCarthy")]), _c('i', {
	    staticClass: "text-blue fontello-record"
	  }), _c('small', [_vm._v("09 November")]), _vm._v(" "), _c('h5', [_vm._v("World Recod")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam erat nunc, vestibulum eu venenatis ut, feugiat sit amet elit. Donec convallis ornare odio. Donec ac est eget lacus molestie imperdiet vitae ac nunc. Suspendisse odio justo ... ")])]), _vm._v(" "), _c('li', [_c('a', {
	    staticClass: "star bg-yellow",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "fa  fa-dribbble"
	  })]), _vm._v(" "), _c('b', [_vm._v("Dribbble (Matt Wulleang)")]), _c('i', {
	    staticClass: "text-aqua fontello-record"
	  }), _c('small', [_vm._v("09 November")]), _vm._v(" "), _c('h5', [_vm._v("Berbagi pos - \"This #DOTD by Viviana González makes us ..")]), _vm._v(" "), _c('p', [_vm._v("Donec sed mi sem. Maecenas posuere justo dapibus fermentum porttitor. Phasellus ornare lectus a neque molestie sodales. Pellentesque consectetur sed nisl vitae tempor. Duis et odio ut ligula accumsan interdum. ... ")])]), _vm._v(" "), _c('li', [_c('div', {
	    staticClass: "inbox-header"
	  }, [_c('ul', [_c('li', [_c('span', {
	    staticClass: "ti-reload"
	  }), _vm._v(" Refresh ")]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "ti-export"
	  }), _vm._v(" Reply ")]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "ti-share"
	  }), _vm._v(" Reply All ")]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "ti-trash"
	  }), _vm._v(" Trash ")]), _vm._v(" "), _c('li', {
	    staticClass: "right"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("1-50 of 10,976")])])])])])])])])])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1007:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Blank Page"), _c('small', [_vm._v("It's all start from here "), _c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Blank Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Basic")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "min-height": "400px"
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "plain": true
	    },
	    on: {
	      "click": function($event) {
	        _vm.dialogTableVisible = true
	      }
	    }
	  }, [_vm._v("opens a Table nested Dialog")]), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": "Shipping address",
	      "visible": _vm.dialogTableVisible
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.dialogTableVisible = $event
	      }
	    }
	  }, [_c('el-table', {
	    attrs: {
	      "data": _vm.gridData
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "property": "date",
	      "label": "Date",
	      "width": "150"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "name",
	      "label": "Name",
	      "width": "200"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "address",
	      "label": "Address"
	    }
	  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "plain": true
	    },
	    on: {
	      "click": function($event) {
	        _vm.dialogFormVisible = true
	      }
	    }
	  }, [_vm._v("open a Form nested Dialog")]), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": "Shipping address",
	      "visible": _vm.dialogFormVisible
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.dialogFormVisible = $event
	      }
	    }
	  }, [_c('el-form', {
	    attrs: {
	      "model": _vm.form
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Promotion name",
	      "label-width": _vm.formLabelWidth
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "auto-complete": "off"
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Zones",
	      "label-width": _vm.formLabelWidth
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Please select a zone"
	    },
	    model: {
	      value: (_vm.form.region),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "region", $$v)
	      },
	      expression: "form.region"
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "Zone No.1",
	      "value": "shanghai"
	    }
	  }), _vm._v(" "), _c('el-option', {
	    attrs: {
	      "label": "Zone No.2",
	      "value": "beijing"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.dialogFormVisible = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.dialogFormVisible = false
	      }
	    }
	  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Message")]), _vm._v(" "), _c('p', [_vm._v("Used to show feedback after an activity. The difference with Notification"), _c('br'), _vm._v(" is that the latter is often used to show a system level passive notification.")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "plain": true
	    },
	    on: {
	      "click": _vm.open5
	    }
	  }, [_vm._v("message")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "plain": true
	    },
	    on: {
	      "click": _vm.open6
	    }
	  }, [_vm._v("success")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "plain": true
	    },
	    on: {
	      "click": _vm.open7
	    }
	  }, [_vm._v("warning")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "plain": true
	    },
	    on: {
	      "click": _vm.open8
	    }
	  }, [_vm._v("error")])], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1008:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Blank Page"), _c('small', [_vm._v("It's all start from here "), _c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Blank Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Basic")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "min-height": "400px"
	    }
	  }, [_c('h4', [_vm._v("Basic usage")]), _vm._v(" "), _c('p', [_vm._v("Content Goes Here")])])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1009:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Invoice Page"), _c('small', [_vm._v("This enhanced for printing "), _c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Invoice")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "min-height": "400px"
	    }
	  }, [_c('section', {
	    staticClass: "content invoice"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-sm-12 col-xs-12 invoice-header"
	  }, [_c('h2', {
	    staticClass: "page-header"
	  }, [_c('i', {
	    staticClass: "fa fa-globe"
	  }), _vm._v(" Devin, Inc.\n                                "), _c('small', {
	    staticClass: "pull-right"
	  }, [_vm._v("Date: 8/03/2017")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row invoice-info"
	  }, [_c('div', {
	    staticClass: "col-sm-4 col-sm-12 col-xs-12 invoice-col"
	  }, [_vm._v(" From "), _c('address', [_c('strong', [_vm._v("Admin, Inc.")]), _vm._v(" "), _c('br'), _vm._v("795 Folsom Ave, Suite 600\n                                "), _c('br'), _vm._v("San Francisco, CA 94107\n                                "), _c('br'), _vm._v("Phone: (804) 123-5432\n                                "), _c('br'), _vm._v("Email: info@almasaeedstudio.com\n                            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 col-sm-12 col-xs-12 invoice-col"
	  }, [_vm._v(" To "), _c('address', [_c('strong', [_vm._v("John Doe")]), _vm._v(" "), _c('br'), _vm._v("795 Folsom Ave, Suite 600\n                                "), _c('br'), _vm._v("San Francisco, CA 94107\n                                "), _c('br'), _vm._v("Phone: (555) 539-1037\n                                "), _c('br'), _vm._v("Email: john.doe@example.com\n                            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 col-sm-12 col-xs-12 invoice-col"
	  }, [_c('b', [_vm._v("Invoice #007612")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Order ID:")]), _vm._v(" 4F3S8J\n                                "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Payment Due:")]), _vm._v(" 2/22/2017\n                                "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account:")]), _vm._v(" 968-34567 ")])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-striped"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Qty")]), _vm._v(" "), _c('th', [_vm._v("Product")]), _vm._v(" "), _c('th', [_vm._v("Serial #")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Subtotal")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("Call of Duty")]), _vm._v(" "), _c('td', [_vm._v("455-981-221")]), _vm._v(" "), _c('td', [_vm._v("El snort testosterone trophy driving gloves handsome")]), _vm._v(" "), _c('td', [_vm._v("$64.50")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("Need for Speed IV")]), _vm._v(" "), _c('td', [_vm._v("247-925-726")]), _vm._v(" "), _c('td', [_vm._v("Wes Anderson umami biodiesel")]), _vm._v(" "), _c('td', [_vm._v("$50.00")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("Monsters DVD")]), _vm._v(" "), _c('td', [_vm._v("735-845-642")]), _vm._v(" "), _c('td', [_vm._v("Terry Richardson helvetica tousled street art master")]), _vm._v(" "), _c('td', [_vm._v("$10.70")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("Grown Ups Blue Ray")]), _vm._v(" "), _c('td', [_vm._v("422-568-642")]), _vm._v(" "), _c('td', [_vm._v("Tousled lomo letterpress")]), _vm._v(" "), _c('td', [_vm._v("$25.99")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-sm-12 col-xs-12 "
	  }, [_c('p', {
	    staticClass: "lead"
	  }, [_vm._v("Payment Methods:")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "static/img/credit/visa.png",
	      "alt": "Visa"
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "static/img/credit/mastercard.png",
	      "alt": "Mastercard"
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "static/img/credit/american-express.png",
	      "alt": "American Express"
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "static/img/credit/paypal2.png",
	      "alt": "Paypal"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "text-muted well well-sm no-shadow",
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_vm._v(" Etsy doostang zoodles disqus groupon greplin oooj voxy zoodles, weebly ning heekya handango imeem plugg dopplr jibjab, movity jajah plickers sifteo edmodo ifttt zimbra. ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-sm-12 col-xs-12 "
	  }, [_c('p', {
	    staticClass: "lead"
	  }, [_vm._v("Amount Due 2/22/2017")]), _vm._v(" "), _c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_c('tbody', [_c('tr', [_c('th', {
	    staticStyle: {
	      "width": "50%"
	    }
	  }, [_vm._v("Subtotal:")]), _vm._v(" "), _c('td', [_vm._v("$250.30")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Tax (9.3%)")]), _vm._v(" "), _c('td', [_vm._v("$10.34")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Shipping:")]), _vm._v(" "), _c('td', [_vm._v("$5.80")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Total:")]), _vm._v(" "), _c('td', [_vm._v("$265.24")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row no-print"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "onclick": "window.print();"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-print"
	  }), _vm._v(" Print")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success pull-right"
	  }, [_c('i', {
	    staticClass: "fa fa-credit-card"
	  }), _vm._v(" Submit Payment")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary pull-right",
	    staticStyle: {
	      "margin-right": "5px"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-download"
	  }), _vm._v(" Generate PDF")])])])])])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1010:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_vm._m(0, false, false), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Vue Chart Line")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('ve-line', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.chartData,
	      "settings": _vm.chartSettings
	    }
	  })], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_vm._v("Vue Chart Js"), _c('small', [_vm._v("Input data using mouse or keyboard. "), _c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Charts")])])
	}]}

/***/ }),

/***/ 1011:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-center"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Forms Cascader"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Forms ")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Cascader")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h4', [_vm._v("Basic usage")]), _vm._v(" "), _c('p', [_vm._v("If the options have a clear hierarchical structure, Cascader can be used to view and select them.")]), _vm._v(" "), _c('p', [_vm._v("There are two ways to expand child option items")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-3"
	  }, [_c('div', {
	    staticClass: "block"
	  }, [_c('span', {
	    staticClass: "demonstration"
	  }, [_vm._v("Child options expand when clicked")]), _vm._v(" "), _c('el-cascader', {
	    attrs: {
	      "placeholder": "Select",
	      "options": _vm.options
	    },
	    on: {
	      "change": _vm.handleChange
	    },
	    model: {
	      value: (_vm.selectedOptions),
	      callback: function($$v) {
	        _vm.selectedOptions = $$v
	      },
	      expression: "selectedOptions"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3"
	  }, [_c('div', {
	    staticClass: "block"
	  }, [_c('span', {
	    staticClass: "demonstration"
	  }, [_vm._v("Child options expand when hovered")]), _vm._v(" "), _c('el-cascader', {
	    attrs: {
	      "placeholder": "Select",
	      "expand-trigger": "hover",
	      "options": _vm.options
	    },
	    on: {
	      "change": _vm.handleChange
	    },
	    model: {
	      value: (_vm.selectedOptions2),
	      callback: function($$v) {
	        _vm.selectedOptions2 = $$v
	      },
	      expression: "selectedOptions2"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-6"
	  }, [_c('p', [_vm._v("Assigning the "), _c('code', [_vm._v("options")]), _vm._v(" attribute to an array of options renders a Cascader. The "), _c('code', [_vm._v("expand-trigger")]), _vm._v(" attribute defines how child options are expanded. This example also demonstrates the "), _c('code', [_vm._v("change")]), _vm._v(" event, whose parameter is the value of Cascader, an array made up of the values of each selected level.")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h5', [_vm._v("With default value")]), _vm._v(" "), _c('p', [_vm._v("If the options have a clear hierarchical structure, Cascader can be used to view and select them.")]), _vm._v(" "), _c('p', [_vm._v("There are two ways to expand child option items")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-8"
	  }, [_c('el-cascader', {
	    attrs: {
	      "options": _vm.options
	    },
	    model: {
	      value: (_vm.selectedOptions3),
	      callback: function($$v) {
	        _vm.selectedOptions3 = $$v
	      },
	      expression: "selectedOptions3"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-4"
	  }, [_c('p', [_vm._v("Assigning the "), _c('code', [_vm._v("options")]), _vm._v(" attribute to an array of options renders a Cascader. The "), _c('code', [_vm._v("expand-trigger")]), _vm._v(" attribute defines how child options are expanded. This example also demonstrates the "), _c('code', [_vm._v("change")]), _vm._v(" event, whose parameter is the value of Cascader, an array made up of the values of each selected level.")])])])])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1012:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Expandable Table"), _c('small', [_vm._v("It's all start from here "), _c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Table")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Expandable Table")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Expandable Table")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.tableData3
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "expand"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('p', [_vm._v("State: " + _vm._s(props.row.state))]), _vm._v(" "), _c('p', [_vm._v("City: " + _vm._s(props.row.city))]), _vm._v(" "), _c('p', [_vm._v("Address: " + _vm._s(props.row.address))]), _vm._v(" "), _c('p', [_vm._v("Zip: " + _vm._s(props.row.zip))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Date",
	      "prop": "date"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Name",
	      "prop": "name"
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Sorting Table")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.tableData,
	      "border": "",
	      "default-sort": {
	        prop: 'date',
	        order: 'descending'
	      }
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "date",
	      "label": "Date",
	      "sortable": "",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": "Name",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "address",
	      "label": "Address",
	      "formatter": _vm.formatter
	    }
	  })], 1)], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1013:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Forms Checkbox"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Forms ")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Checkbox")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h5', [_vm._v("Basic usage")]), _vm._v(" "), _c('p', [_vm._v("Checkbox can be used alone to switch between two states. Disabled state for checkbox")]), _vm._v(" "), _c('el-checkbox', {
	    model: {
	      value: (_vm.checked),
	      callback: function($$v) {
	        _vm.checked = $$v
	      },
	      expression: "checked"
	    }
	  }, [_vm._v("Option")]), _vm._v(" "), _c('el-checkbox', {
	    attrs: {
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.checked1),
	      callback: function($$v) {
	        _vm.checked1 = $$v
	      },
	      expression: "checked1"
	    }
	  }, [_vm._v("Option")]), _vm._v(" "), _c('el-checkbox', {
	    attrs: {
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.checked2),
	      callback: function($$v) {
	        _vm.checked2 = $$v
	      },
	      expression: "checked2"
	    }
	  }, [_vm._v("Option")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Checkbox group")]), _vm._v(" "), _c('p', [_vm._v("It is used for multiple checkboxes which are bound in one group, and indicates whether one option is selected by checking if it is checked.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox-group', {
	    model: {
	      value: (_vm.checkList),
	      callback: function($$v) {
	        _vm.checkList = $$v
	      },
	      expression: "checkList"
	    }
	  }, [_c('el-checkbox', {
	    attrs: {
	      "label": "Option A"
	    }
	  }), _vm._v(" "), _c('el-checkbox', {
	    attrs: {
	      "label": "Option B"
	    }
	  }), _vm._v(" "), _c('el-checkbox', {
	    attrs: {
	      "label": "Option C"
	    }
	  }), _vm._v(" "), _c('el-checkbox', {
	    attrs: {
	      "label": "disabled",
	      "disabled": ""
	    }
	  }), _vm._v(" "), _c('el-checkbox', {
	    attrs: {
	      "label": "selected and disabled",
	      "disabled": ""
	    }
	  })], 1)], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1014:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper",
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Shop Page"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Shop Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box",
	    staticStyle: {
	      "padding": "30px"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('ul', {
	    staticClass: "nav nav-tabs nav-tabs-shop-devin",
	    attrs: {
	      "role": "tablist"
	    }
	  }, [_c('li', {
	    attrs: {
	      "data-wow-delay": "0.6s"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#featured",
	      "data-toggle": "tab",
	      "aria-expanded": "false"
	    }
	  }, [_vm._v("featured")])]), _vm._v(" "), _c('li', {
	    staticClass: "active",
	    attrs: {
	      "data-wow-delay": "0.4s"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#best",
	      "data-toggle": "tab",
	      "aria-expanded": "true"
	    }
	  }, [_vm._v("bestsellers")])]), _vm._v(" "), _c('li', {
	    attrs: {
	      "data-wow-delay": "0.2s"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#new",
	      "data-toggle": "tab",
	      "aria-expanded": "false"
	    }
	  }, [_vm._v("new")])])]), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane fade",
	    attrs: {
	      "role": "tabpanel",
	      "id": "featured"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "product-item-thumbnail-label"
	  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "product-item-thumbnail-label"
	  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "product-item-thumbnail-label"
	  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "product-item-thumbnail-label"
	  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane fade active in",
	    attrs: {
	      "role": "tabpanel",
	      "id": "best"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "product-item-thumbnail-label"
	  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-02.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "product-item-thumbnail-label"
	  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-02.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "product-item-thumbnail-label"
	  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-02.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "product-item-thumbnail-label"
	  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-02.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane fade",
	    attrs: {
	      "role": "tabpanel",
	      "id": "new"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "product-item-thumbnail-label"
	  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "product-item-thumbnail-label"
	  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "product-item-thumbnail-label"
	  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "product-item-thumbnail-label"
	  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "product-item-thumbnail-label"
	  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "product-item-thumbnail-label"
	  }, [_vm._v("new")]), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('div', {
	    staticClass: "product-item"
	  }, [_c('div', {
	    staticClass: "product-item-thumbnail text-center mb-15"
	  }, [_c('a', {
	    staticClass: "product-item-thumbnail-link",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg",
	      "alt": "product image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "product-item-thumbnail-overlay"
	  }, [_c('a', {
	    staticClass: "btn btn-default pulse",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-heart mr-0"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("add to cart")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 text-right"
	  }, [_c('del', {
	    staticClass: "h5 text-muted product-item-price-old"
	  }, [_vm._v("$99.00")]), _vm._v(" "), _c('span', {
	    staticClass: "h5 product-item-price"
	  }, [_vm._v("$49.00")])])])])])])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1016:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Forms Radio"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Forms")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Radio")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h5', [_vm._v("Basic usage")]), _vm._v(" "), _c('p', [_vm._v("Radio should not have too many options. Otherwise, use the Select component instead.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-radio', {
	    staticClass: "radio",
	    attrs: {
	      "label": "1"
	    },
	    model: {
	      value: (_vm.radio),
	      callback: function($$v) {
	        _vm.radio = $$v
	      },
	      expression: "radio"
	    }
	  }, [_vm._v("optionA")]), _vm._v(" "), _c('el-radio', {
	    staticClass: "radio",
	    attrs: {
	      "label": "2"
	    },
	    model: {
	      value: (_vm.radio),
	      callback: function($$v) {
	        _vm.radio = $$v
	      },
	      expression: "radio"
	    }
	  }, [_vm._v("optionB")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-radio-group', {
	    model: {
	      value: (_vm.radio3),
	      callback: function($$v) {
	        _vm.radio3 = $$v
	      },
	      expression: "radio3"
	    }
	  }, [_c('el-radio-button', {
	    attrs: {
	      "label": "New York"
	    }
	  }), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "Washington"
	    }
	  }), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "Los Angeles"
	    }
	  }), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "Chicago"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin": "15px 0"
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-radio-group', {
	    model: {
	      value: (_vm.radio4),
	      callback: function($$v) {
	        _vm.radio4 = $$v
	      },
	      expression: "radio4"
	    }
	  }, [_c('el-radio-button', {
	    attrs: {
	      "label": "New York"
	    }
	  }), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "Washington",
	      "disabled": true
	    }
	  }), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "Los Angeles"
	    }
	  }), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "Chicago"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin": "15px 0"
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-radio-group', {
	    attrs: {
	      "disabled": true
	    },
	    model: {
	      value: (_vm.radio5),
	      callback: function($$v) {
	        _vm.radio5 = $$v
	      },
	      expression: "radio5"
	    }
	  }, [_c('el-radio-button', {
	    attrs: {
	      "label": "New York"
	    }
	  }), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "Washington"
	    }
	  }), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "Los Angeles"
	    }
	  }), _vm._v(" "), _c('el-radio-button', {
	    attrs: {
	      "label": "Chicago"
	    }
	  })], 1)], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1017:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "create-todo"
	  }, [_c('el-button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isCreating),
	      expression: "!isCreating"
	    }],
	    attrs: {
	      "type": "info"
	    },
	    on: {
	      "click": _vm.openForm
	    }
	  }, [_c('i', {
	    staticClass: "ti-pencil-alt"
	  }), _vm._v("  Add New Task")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isCreating),
	      expression: "isCreating"
	    }]
	  }, [_c('div', {
	    staticClass: "content-todo-devin"
	  }, [_c('div', [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('p', [_c('el-input', {
	    attrs: {
	      "placeholder": "Please input",
	      "type": "text"
	    },
	    model: {
	      value: (_vm.titleText),
	      callback: function($$v) {
	        _vm.titleText = $$v
	      },
	      expression: "titleText"
	    }
	  })], 1)]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Project")]), _vm._v(" "), _c('p', [_c('el-input', {
	    attrs: {
	      "type": "textarea",
	      "rows": 4,
	      "placeholder": "Please input"
	    },
	    model: {
	      value: (_vm.projectText),
	      callback: function($$v) {
	        _vm.projectText = $$v
	      },
	      expression: "projectText"
	    }
	  })], 1)]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "info"
	    },
	    on: {
	      "click": function($event) {
	        _vm.sendForm()
	      }
	    }
	  }, [_vm._v("Create")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "info"
	    },
	    on: {
	      "click": _vm.closeForm
	    }
	  }, [_vm._v("Cancel")])], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1018:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0, false, false), _vm._v(" "), _c('main', {
	    staticClass: "wrapper-404"
	  }, [_c('div', {
	    staticClass: "error-404"
	  }, [_vm._m(1, false, false), _vm._v(" "), _c('h1', [_c('vue-typer', {
	    attrs: {
	      "text": ["Oops! Page not found", "We could not find the page you were looking for", "Meanwhile", "you may return to dashboard", "or try using the search form."],
	      "repeat": Infinity,
	      "shuffle": false,
	      "initial-action": "typing",
	      "pre-type-delay": 70,
	      "type-delay": 70,
	      "pre-erase-delay": 2000,
	      "erase-delay": 250,
	      "erase-style": "clear",
	      "erase-on-complete": false,
	      "caret-animation": "solid"
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "moon"
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n                500 Error Page\n            ")]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Examples")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("500 error")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "error-number"
	  }, [_c('span', [_vm._v("5")]), _c('span', [_c('img', {
	    staticClass: "icon has-animation",
	    attrs: {
	      "src": "https://image.flaticon.com/icons/svg/179/179595.svg",
	      "alt": ""
	    }
	  })]), _c('span', [_c('img', {
	    staticClass: "icon has-animation",
	    attrs: {
	      "src": "https://image.flaticon.com/icons/svg/179/179595.svg",
	      "alt": ""
	    }
	  })])])
	}]}

/***/ }),

/***/ 1019:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Blog List"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Blog List Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box",
	    staticStyle: {
	      "padding": "30px"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('div', {
	    staticClass: "blog-list-nest"
	  }, [_c('div', {
	    staticClass: "vendor"
	  }, [_c('img', {
	    staticClass: "img-responsive-media",
	    attrs: {
	      "src": "https://source.unsplash.com/collection/190727/1600x900",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "blog-list-content"
	  }, [_c('h2', [_vm._v("Article Heading")]), _vm._v(" "), _c('ul', {
	    staticClass: "list-inline blog-devin-tag"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-pencil"
	  }), _vm._v(" 2 Days Ago")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-comment-alt"
	  }), _vm._v(" 2 Comments")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-rss-alt"
	  }), _vm._v(" 14 Shares")])])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis pharetra varius quam sit amet vulputate. Quisque mauris augue, molestie tincidunt condimentum vitae, gravida a libero. Aenean sit amet felis dolor, in sagittis nisi. Sed ac orci quis tortor imperdiet venenatis. Duis elementum auctor accumsan. Aliquam in felis sit amet augue.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
	    staticClass: "pull-left"
	  }, [_c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Music")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Video")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Typhography")])], 1), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info pull-right"
	  }, [_vm._v("Read More")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "clear": "both"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "blog-list-nest"
	  }, [_c('div', {
	    staticClass: "vendor"
	  }, [_c('img', {
	    staticClass: "img-responsive-media",
	    attrs: {
	      "src": "https://source.unsplash.com/category/buildings/1024x764",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "blog-list-content"
	  }, [_c('h2', [_vm._v("Godzilla")]), _vm._v(" "), _c('ul', {
	    staticClass: "list-inline blog-devin-tag"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-pencil"
	  }), _vm._v(" 2 Days Ago")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-comment-alt"
	  }), _vm._v(" 2 Comments")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-rss-alt"
	  }), _vm._v(" 14 Shares")])])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis pharetra varius quam sit amet vulputate. Quisque mauris augue, molestie tincidunt condimentum vitae, gravida a libero. Aenean sit amet felis dolor, in sagittis nisi. Sed ac orci quis tortor imperdiet venenatis. Duis elementum auctor accumsan. Aliquam in felis sit amet augue.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
	    staticClass: "pull-left"
	  }, [_c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Music")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Video")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Typhography")])], 1), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info pull-right"
	  }, [_vm._v("Read More")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "clear": "both"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "blog-list-nest"
	  }, [_c('div', {
	    staticClass: "vendor"
	  }, [_c('blockquote', [_c('p', [_vm._v("\"How can we win when fools can be king\"")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("Mattew Bellamy")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "blog-list-content"
	  }, [_c('h2', [_vm._v("Muse")]), _vm._v(" "), _c('ul', {
	    staticClass: "list-inline blog-devin-tag"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-pencil"
	  }), _vm._v(" 2 Days Ago")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-comment-alt"
	  }), _vm._v(" 2 Comments")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-rss-alt"
	  }), _vm._v(" 14 Shares")])])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis pharetra varius quam sit amet vulputate. Quisque mauris augue, molestie tincidunt condimentum vitae, gravida a libero. Aenean sit amet felis dolor, in sagittis nisi. Sed ac orci quis tortor imperdiet venenatis. Duis elementum auctor accumsan. Aliquam in felis sit amet augue.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
	    staticClass: "pull-left"
	  }, [_c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Music")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Video")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Typhography")])], 1), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info pull-right"
	  }, [_vm._v("Read More")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "clear": "both"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "blog-list-nest"
	  }, [_c('div', {
	    staticClass: "vendor"
	  }, [_c('img', {
	    staticClass: "img-responsive-media",
	    attrs: {
	      "src": "https://source.unsplash.com/category/people/1024x764",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "blog-list-content"
	  }, [_c('h2', [_vm._v("Favright")]), _vm._v(" "), _c('ul', {
	    staticClass: "list-inline blog-devin-tag"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-pencil"
	  }), _vm._v(" 2 Days Ago")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-comment-alt"
	  }), _vm._v(" 2 Comments")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-rss-alt"
	  }), _vm._v(" 14 Shares")])])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis pharetra varius quam sit amet vulputate. Quisque mauris augue, molestie tincidunt condimentum vitae, gravida a libero. Aenean sit amet felis dolor, in sagittis nisi. Sed ac orci quis tortor imperdiet venenatis. Duis elementum auctor accumsan. Aliquam in felis sit amet augue.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
	    staticClass: "pull-left"
	  }, [_c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Music")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Video")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Typhography")])], 1), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info pull-right"
	  }, [_vm._v("Read More")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "clear": "both"
	    }
	  })])]), _vm._v(" "), _c('ul', {
	    staticClass: "pager success"
	  }, [_c('li', {
	    staticClass: "previous"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("← Older")])]), _vm._v(" "), _c('li', {
	    staticClass: "next disabled"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Newer →")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('div', {
	    staticClass: "panel panel-default"
	  }, [_c('img', {
	    staticClass: "media-object img-circle blog-profile",
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/thumb/men/10.jpg"
	    }
	  }), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin": "0"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "panel-body"
	  }, [_c('p', {
	    staticClass: "lead text-center"
	  }, [_vm._v("Dave Mattew")]), _vm._v(" "), _c('p', {
	    staticClass: "tex-center social-blog-profile"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "entypo-facebook-circled"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "tweet-link",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "entypo-twitter-circled"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "gplus-textcolor",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "entypo-instagrem"
	  })])]), _vm._v(" "), _c('p', {
	    staticClass: "social-follower text-center"
	  }, [_vm._v("A graphics designer, a web developer, a boyfriend, a friend, a son")])])]), _vm._v(" "), _c('div', {
	    staticClass: "blog-side-nest"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("JOIN NEWSLETTER")]), _vm._v(" "), _c('p', {
	    staticClass: "text-center"
	  }, [_vm._v("Sign up for our daily Newslatter")]), _vm._v(" "), _c('form', {
	    attrs: {
	      "role": "form"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-8"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "placeholder": "Enter email"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-4 col-full-width-left"
	  }, [_c('button', {
	    staticClass: "btn btn-info btn-block",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Sign up")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "blog-side-nest"
	  }, [_c('h4', {
	    staticClass: "text-left"
	  }, [_vm._v("POPULAR POST")]), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin": "0"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    staticClass: "pull-left",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-responsive-media",
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/men/17.jpg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h5', {
	    staticClass: "media-heading"
	  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
	    staticClass: "link-comment recentpost-link",
	    staticStyle: {
	      "margin": "-10px 0 10px"
	    },
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("88 Views")])])]), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    staticClass: "pull-left",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-responsive-media",
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/men/21.jpg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h5', {
	    staticClass: "media-heading"
	  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
	    staticClass: "link-comment recentpost-link",
	    staticStyle: {
	      "margin": "-10px 0 10px"
	    },
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("90 Views")])])]), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    staticClass: "pull-left",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-responsive-media",
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/men/20.jpg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h5', {
	    staticClass: "media-heading"
	  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
	    staticClass: "link-comment recentpost-link",
	    staticStyle: {
	      "margin": "-10px 0 10px"
	    },
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("42 Views")])])]), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    staticClass: "pull-left",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-responsive-media",
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/men/19.jpg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h5', {
	    staticClass: "media-heading"
	  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
	    staticClass: "link-comment recentpost-link",
	    staticStyle: {
	      "margin": "-10px 0 10px"
	    },
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("111 Views")])])]), _vm._v(" "), _c('div', {
	    staticClass: "media"
	  }, [_c('a', {
	    staticClass: "pull-left",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-responsive-media",
	    attrs: {
	      "data-src": "holder.js/64x64",
	      "alt": "64x64",
	      "src": "http://api.randomuser.me/portraits/men/18.jpg"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h5', {
	    staticClass: "media-heading"
	  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
	    staticClass: "link-comment recentpost-link",
	    staticStyle: {
	      "margin": "-10px 0 10px"
	    },
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("123 Views")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "blog-side-nest"
	  }, [_c('h4', {
	    staticClass: "text-left"
	  }, [_vm._v("TAG")]), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin": "0"
	    }
	  }), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Admin")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Fleet")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Music")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Video")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Typhography")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Computer")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Web Design")]), _vm._v(" "), _c('el-tag', {
	    attrs: {
	      "type": "gray"
	    }
	  }, [_vm._v("Movie")])], 1)])])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1020:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Shop Item Page"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Shop Item")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box",
	    staticStyle: {
	      "padding": "30px"
	    }
	  }, [_c('div', {
	    staticClass: "heading-cart cf"
	  }, [_c('h1', [_vm._v("My Cart")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Continue Shopping")])]), _vm._v(" "), _c('ul', {
	    staticClass: "cart-items width-100 pull-left pl-60 pr-30 pb-0 pt-0 container-fluid"
	  }, [_c('li', {
	    staticClass: "cart-items-labels visible-lg-block visible-md-block row"
	  }, [_c('span', {
	    staticClass: "col-md-6 text-muted small"
	  }, [_vm._v("product")]), _vm._v(" "), _c('span', {
	    staticClass: "col-md-2 text-muted small text-center"
	  }, [_vm._v("quantity")]), _vm._v(" "), _c('span', {
	    staticClass: "col-md-4 text-muted small text-right"
	  }, [_vm._v("price")])]), _vm._v(" "), _c('li', {
	    staticClass: "row"
	  }, [_c('span', {
	    staticClass: "cart-image col-xs-12 col-sm-12 col-md-2"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    attrs: {
	      "alt": "product description",
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "cart-item-right col-md-10 col-xs-12 col-sm-12"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('span', {
	    staticClass: "cart-description col-xs-12 col-md-5"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")]), _vm._v(" "), _c('span', {
	    staticClass: "cart-item-price h5 text-muted"
	  }, [_vm._v("$ 33.00")])]), _vm._v(" "), _c('span', {
	    staticClass: "col-md-2 col-sm-12"
	  }, [_c('input', {
	    staticClass: "text-center form-control",
	    attrs: {
	      "type": "text",
	      "value": "10"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "col-md-5 col-sm-12 text-right"
	  }, [_c('span', {
	    staticClass: "cart-price pull-right"
	  }, [_vm._v("$330.00 "), _c('a', {
	    staticClass: "cart-remove",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-trash icon pull-right mt-5 ml-10"
	  })])])])])])]), _vm._v(" "), _c('li', {
	    staticClass: "row"
	  }, [_c('span', {
	    staticClass: "cart-image col-xs-12 col-sm-12 col-md-2"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    attrs: {
	      "alt": "product description",
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "cart-item-right col-md-10 col-xs-12 col-sm-12"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('span', {
	    staticClass: "cart-description col-xs-12 col-md-5"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")]), _vm._v(" "), _c('span', {
	    staticClass: "cart-item-price h5 text-muted"
	  }, [_vm._v("$ 33.00")])]), _vm._v(" "), _c('span', {
	    staticClass: "col-md-2 col-sm-12"
	  }, [_c('input', {
	    staticClass: "text-center form-control",
	    attrs: {
	      "type": "text",
	      "value": "10"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "col-md-5 col-sm-12 text-right"
	  }, [_c('span', {
	    staticClass: "cart-price pull-right"
	  }, [_vm._v("$330.00 "), _c('a', {
	    staticClass: "cart-remove",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-trash icon pull-right mt-5 ml-10"
	  })])])])])])]), _vm._v(" "), _c('li', {
	    staticClass: "row"
	  }, [_c('span', {
	    staticClass: "cart-image col-xs-12 col-sm-12 col-md-2"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    attrs: {
	      "alt": "product description",
	      "src": "http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "cart-item-right col-md-10 col-xs-12 col-sm-12"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('span', {
	    staticClass: "cart-description col-xs-12 col-md-5"
	  }, [_c('a', {
	    staticClass: "h5",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Product name")]), _vm._v(" "), _c('span', {
	    staticClass: "cart-item-price h5 text-muted"
	  }, [_vm._v("$ 33.00")])]), _vm._v(" "), _c('span', {
	    staticClass: "col-md-2 col-sm-12"
	  }, [_c('input', {
	    staticClass: "text-center form-control",
	    attrs: {
	      "type": "text",
	      "value": "10"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "col-md-5 col-sm-12 text-right"
	  }, [_c('span', {
	    staticClass: "cart-price pull-right"
	  }, [_vm._v("$330.00 "), _c('a', {
	    staticClass: "cart-remove",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-trash icon pull-right mt-5 ml-10"
	  })])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "width-100 pr-45 checkout-devin"
	  }, [_c('ul', [_c('li', {
	    staticClass: "totalRow"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("Subtotal")]), _c('span', {
	    staticClass: "value"
	  }, [_vm._v("$35.00")])]), _vm._v(" "), _c('li', {
	    staticClass: "totalRow"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("Shipping")]), _c('span', {
	    staticClass: "value"
	  }, [_vm._v("$5.00")])]), _vm._v(" "), _c('li', {
	    staticClass: "totalRow"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("Tax")]), _c('span', {
	    staticClass: "value"
	  }, [_vm._v("$4.00")])]), _vm._v(" "), _c('li', {
	    staticClass: "totalRow final"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("Total")]), _c('span', {
	    staticClass: "value"
	  }, [_vm._v("$44.00")])]), _vm._v(" "), _c('li', {
	    staticClass: "totalRow"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Checkout")])])])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "clear": "both"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1021:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("ToDo Apps"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("To Do")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "todo-devin"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "side-todo"
	  }, [_c('ul', [_c('li', {
	    staticClass: "clearfix"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://api.randomuser.me/portraits/men/22.jpg",
	      "alt": "avatar"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "about"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("Vincent Porter")]), _vm._v(" "), _c('div', {
	    staticClass: "status"
	  }, [_c('i', {
	    staticClass: "fa fa-circle online"
	  }), _vm._v(" online ")])])]), _vm._v(" "), _c('li', {
	    staticClass: "completed"
	  }, [_vm._v("Complete task "), _c('b', [_vm._v(_vm._s(_vm.todos.filter(function (todo) {
	    return todo.done === true
	  }).length))])]), _vm._v(" "), _c('li', {
	    staticClass: "pending"
	  }, [_vm._v("Pending task "), _c('b', [_vm._v(_vm._s(_vm.todos.filter(function (todo) {
	    return todo.done === false
	  }).length))])])]), _vm._v(" "), _c('create-todo', {
	    on: {
	      "create-todo": _vm.createTodo
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('todo-list', {
	    attrs: {
	      "todos": _vm.todos
	    }
	  })], 1)])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1022:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Select Table"), _c('small', [_vm._v("It's all start from here "), _c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Table")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Select Table")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Single select")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "min-height": "400px"
	    }
	  }, [_c('el-table', {
	    ref: "singleTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.tableData,
	      "highlight-current-row": ""
	    },
	    on: {
	      "current-change": _vm.handleCurrentChange
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "index",
	      "width": "50"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "date",
	      "label": "Date",
	      "width": "120"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "name",
	      "label": "Name",
	      "width": "120"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "address",
	      "label": "Address"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.setCurrent(_vm.tableData[1])
	      }
	    }
	  }, [_vm._v("Select second row")]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.setCurrent()
	      }
	    }
	  }, [_vm._v("Clear selection")])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Multiple Select")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "min-height": "400px"
	    }
	  }, [_c('el-table', {
	    ref: "multipleTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.tableData3,
	      "border": ""
	    },
	    on: {
	      "selection-change": _vm.handleSelectionChange
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "selection",
	      "width": "55"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Date",
	      "width": "120"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v(_vm._s(scope.row.date))]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "name",
	      "label": "Name",
	      "width": "120"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "address",
	      "label": "Address",
	      "show-overflow-tooltip": ""
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.toggleSelection([_vm.tableData3[1], _vm.tableData3[2]])
	      }
	    }
	  }, [_vm._v("Toggle selection status of second and third rows")]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.toggleSelection()
	      }
	    }
	  }, [_vm._v("Clear selection")])], 1)], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1023:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0, false, false)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Widgets\n      "), _c('small', [_vm._v("Preview page")])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Widgets")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box"
	  }, [_c('span', {
	    staticClass: "info-box-icon bg-aqua"
	  }, [_c('i', {
	    staticClass: "fa fa-envelope-o"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Messages")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("1,410")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box"
	  }, [_c('span', {
	    staticClass: "info-box-icon bg-green"
	  }, [_c('i', {
	    staticClass: "fa fa-flag-o"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Bookmarks")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("410")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box"
	  }, [_c('span', {
	    staticClass: "info-box-icon bg-yellow"
	  }, [_c('i', {
	    staticClass: "fa fa-files-o"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Uploads")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("13,648")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box"
	  }, [_c('span', {
	    staticClass: "info-box-icon bg-red"
	  }, [_c('i', {
	    staticClass: "fa fa-star-o"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Likes")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("93,139")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box bg-aqua"
	  }, [_c('span', {
	    staticClass: "info-box-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-bookmark-o"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Bookmarks")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("41,410")]), _vm._v(" "), _c('div', {
	    staticClass: "progress"
	  }, [_c('div', {
	    staticClass: "progress-bar",
	    staticStyle: {
	      "width": "70%"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "progress-description"
	  }, [_vm._v("\n                  70% Increase in 30 Days\n                ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box bg-green"
	  }, [_c('span', {
	    staticClass: "info-box-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Likes")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("41,410")]), _vm._v(" "), _c('div', {
	    staticClass: "progress"
	  }, [_c('div', {
	    staticClass: "progress-bar",
	    staticStyle: {
	      "width": "70%"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "progress-description"
	  }, [_vm._v("\n                  70% Increase in 30 Days\n                ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box bg-yellow"
	  }, [_c('span', {
	    staticClass: "info-box-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Events")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("41,410")]), _vm._v(" "), _c('div', {
	    staticClass: "progress"
	  }, [_c('div', {
	    staticClass: "progress-bar",
	    staticStyle: {
	      "width": "70%"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "progress-description"
	  }, [_vm._v("\n                  70% Increase in 30 Days\n                ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "info-box bg-red"
	  }, [_c('span', {
	    staticClass: "info-box-icon"
	  }, [_c('i', {
	    staticClass: "fa fa-comments-o"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "info-box-content"
	  }, [_c('span', {
	    staticClass: "info-box-text"
	  }, [_vm._v("Comments")]), _vm._v(" "), _c('span', {
	    staticClass: "info-box-number"
	  }, [_vm._v("41,410")]), _vm._v(" "), _c('div', {
	    staticClass: "progress"
	  }, [_c('div', {
	    staticClass: "progress-bar",
	    staticStyle: {
	      "width": "70%"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "progress-description"
	  }, [_vm._v("\n                  70% Increase in 30 Days\n                ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-3 col-xs-6"
	  }, [_c('div', {
	    staticClass: "small-box bg-aqua"
	  }, [_c('div', {
	    staticClass: "inner"
	  }, [_c('h3', [_vm._v("150")]), _vm._v(" "), _c('p', [_vm._v("New Orders")])]), _vm._v(" "), _c('div', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-shopping-cart"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "small-box-footer",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("\n            More info "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3 col-xs-6"
	  }, [_c('div', {
	    staticClass: "small-box bg-green"
	  }, [_c('div', {
	    staticClass: "inner"
	  }, [_c('h3', [_vm._v("53"), _c('sup', {
	    staticStyle: {
	      "font-size": "20px"
	    }
	  }, [_vm._v("%")])]), _vm._v(" "), _c('p', [_vm._v("Bounce Rate")])]), _vm._v(" "), _c('div', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "ion ion-stats-bars"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "small-box-footer",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("\n            More info "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3 col-xs-6"
	  }, [_c('div', {
	    staticClass: "small-box bg-yellow"
	  }, [_c('div', {
	    staticClass: "inner"
	  }, [_c('h3', [_vm._v("44")]), _vm._v(" "), _c('p', [_vm._v("User Registrations")])]), _vm._v(" "), _c('div', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "ion ion-person-add"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "small-box-footer",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("\n            More info "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3 col-xs-6"
	  }, [_c('div', {
	    staticClass: "small-box bg-red"
	  }, [_c('div', {
	    staticClass: "inner"
	  }, [_c('h3', [_vm._v("65")]), _vm._v(" "), _c('p', [_vm._v("Unique Visitors")])]), _vm._v(" "), _c('div', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "ion ion-pie-graph"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "small-box-footer",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("\n            More info "), _c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-default collapsed-box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Expandable")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-success"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Removable")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-warning"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Collapsable")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-danger"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Loading state")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "overlay"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-default collapsed-box box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Expandable")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-success box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Removable")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-warning box-solid"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Collapsable")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-danger box-solid"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Loading state")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_vm._v("\n            The body of the box\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "overlay"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh fa-spin"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-primary direct-chat direct-chat-primary"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Direct Chat")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('span', {
	    staticClass: "badge bg-light-blue",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "3 New Messages"
	    }
	  }, [_vm._v("3")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "title": "Contacts",
	      "data-widget": "chat-pane-toggle"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-comments"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "direct-chat-messages"
	  }, [_c('div', {
	    staticClass: "direct-chat-msg"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-left"
	  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-right"
	  }, [_vm._v("23 Jan 2:00 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  Is this template really for free? That's unbelievable!\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-msg right"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-right"
	  }, [_vm._v("Sarah Bullock")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-left"
	  }, [_vm._v("23 Jan 2:05 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user3-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  You better believe it!\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-contacts"
	  }, [_c('ul', {
	    staticClass: "contacts-list"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "contacts-list-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "contacts-list-info"
	  }, [_c('span', {
	    staticClass: "contacts-list-name"
	  }, [_vm._v("\n                            Count Dracula\n                            "), _c('small', {
	    staticClass: "contacts-list-date pull-right"
	  }, [_vm._v("2/28/2015")])]), _vm._v(" "), _c('span', {
	    staticClass: "contacts-list-msg"
	  }, [_vm._v("How have you been? I was...")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('form', {
	    attrs: {
	      "action": "#",
	      "method": "post"
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "message",
	      "placeholder": "Type Message ..."
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-flat",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Send")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-success direct-chat direct-chat-success"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Direct Chat")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('span', {
	    staticClass: "badge bg-green",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "3 New Messages"
	    }
	  }, [_vm._v("3")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "title": "Contacts",
	      "data-widget": "chat-pane-toggle"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-comments"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "direct-chat-messages"
	  }, [_c('div', {
	    staticClass: "direct-chat-msg"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-left"
	  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-right"
	  }, [_vm._v("23 Jan 2:00 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  Is this template really for free? That's unbelievable!\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-msg right"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-right"
	  }, [_vm._v("Sarah Bullock")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-left"
	  }, [_vm._v("23 Jan 2:05 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user3-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  You better believe it!\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-contacts"
	  }, [_c('ul', {
	    staticClass: "contacts-list"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "contacts-list-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "contacts-list-info"
	  }, [_c('span', {
	    staticClass: "contacts-list-name"
	  }, [_vm._v("\n                            Count Dracula\n                            "), _c('small', {
	    staticClass: "contacts-list-date pull-right"
	  }, [_vm._v("2/28/2015")])]), _vm._v(" "), _c('span', {
	    staticClass: "contacts-list-msg"
	  }, [_vm._v("How have you been? I was...")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('form', {
	    attrs: {
	      "action": "#",
	      "method": "post"
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "message",
	      "placeholder": "Type Message ..."
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-flat",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Send")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-warning direct-chat direct-chat-warning"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Direct Chat")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('span', {
	    staticClass: "badge bg-yellow",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "3 New Messages"
	    }
	  }, [_vm._v("3")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "title": "Contacts",
	      "data-widget": "chat-pane-toggle"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-comments"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "direct-chat-messages"
	  }, [_c('div', {
	    staticClass: "direct-chat-msg"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-left"
	  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-right"
	  }, [_vm._v("23 Jan 2:00 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  Is this template really for free? That's unbelievable!\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-msg right"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-right"
	  }, [_vm._v("Sarah Bullock")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-left"
	  }, [_vm._v("23 Jan 2:05 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user3-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  You better believe it!\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-contacts"
	  }, [_c('ul', {
	    staticClass: "contacts-list"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "contacts-list-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "contacts-list-info"
	  }, [_c('span', {
	    staticClass: "contacts-list-name"
	  }, [_vm._v("\n                            Count Dracula\n                            "), _c('small', {
	    staticClass: "contacts-list-date pull-right"
	  }, [_vm._v("2/28/2015")])]), _vm._v(" "), _c('span', {
	    staticClass: "contacts-list-msg"
	  }, [_vm._v("How have you been? I was...")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('form', {
	    attrs: {
	      "action": "#",
	      "method": "post"
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "message",
	      "placeholder": "Type Message ..."
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Send")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box box-danger direct-chat direct-chat-danger"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Direct Chat")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('span', {
	    staticClass: "badge bg-red",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "3 New Messages"
	    }
	  }, [_vm._v("3")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "title": "Contacts",
	      "data-widget": "chat-pane-toggle"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-comments"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "direct-chat-messages"
	  }, [_c('div', {
	    staticClass: "direct-chat-msg"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-left"
	  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-right"
	  }, [_vm._v("23 Jan 2:00 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  Is this template really for free? That's unbelievable!\n                ")])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-msg right"
	  }, [_c('div', {
	    staticClass: "direct-chat-info clearfix"
	  }, [_c('span', {
	    staticClass: "direct-chat-name pull-right"
	  }, [_vm._v("Sarah Bullock")]), _vm._v(" "), _c('span', {
	    staticClass: "direct-chat-timestamp pull-left"
	  }, [_vm._v("23 Jan 2:05 pm")])]), _vm._v(" "), _c('img', {
	    staticClass: "direct-chat-img",
	    attrs: {
	      "src": "/static/img/user3-128x128.jpg",
	      "alt": "Message User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-text"
	  }, [_vm._v("\n                  You better believe it!\n                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "direct-chat-contacts"
	  }, [_c('ul', {
	    staticClass: "contacts-list"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "contacts-list-img",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "contacts-list-info"
	  }, [_c('span', {
	    staticClass: "contacts-list-name"
	  }, [_vm._v("\n                            Count Dracula\n                            "), _c('small', {
	    staticClass: "contacts-list-date pull-right"
	  }, [_vm._v("2/28/2015")])]), _vm._v(" "), _c('span', {
	    staticClass: "contacts-list-msg"
	  }, [_vm._v("How have you been? I was...")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('form', {
	    attrs: {
	      "action": "#",
	      "method": "post"
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "message",
	      "placeholder": "Type Message ..."
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-danger btn-flat",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Send")])])])])])])])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Social Widgets")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "box box-widget widget-user-2"
	  }, [_c('div', {
	    staticClass: "widget-user-header bg-yellow"
	  }, [_c('div', {
	    staticClass: "widget-user-image"
	  }, [_c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": "/static/img/user7-128x128.jpg",
	      "alt": "User Avatar"
	    }
	  })]), _vm._v(" "), _c('h3', {
	    staticClass: "widget-user-username"
	  }, [_vm._v("Nadia Carmichael")]), _vm._v(" "), _c('h5', {
	    staticClass: "widget-user-desc"
	  }, [_vm._v("Lead Developer")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer no-padding"
	  }, [_c('ul', {
	    staticClass: "nav nav-stacked"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Projects "), _c('span', {
	    staticClass: "pull-right badge bg-blue"
	  }, [_vm._v("31")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Tasks "), _c('span', {
	    staticClass: "pull-right badge bg-aqua"
	  }, [_vm._v("5")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Completed Projects "), _c('span', {
	    staticClass: "pull-right badge bg-green"
	  }, [_vm._v("12")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Followers "), _c('span', {
	    staticClass: "pull-right badge bg-red"
	  }, [_vm._v("842")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "box box-widget widget-user"
	  }, [_c('div', {
	    staticClass: "widget-user-header bg-aqua-active"
	  }, [_c('h3', {
	    staticClass: "widget-user-username"
	  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('h5', {
	    staticClass: "widget-user-desc"
	  }, [_vm._v("Founder & CEO")])]), _vm._v(" "), _c('div', {
	    staticClass: "widget-user-image"
	  }, [_c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "User Avatar"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4 border-right"
	  }, [_c('div', {
	    staticClass: "description-block"
	  }, [_c('h5', {
	    staticClass: "description-header"
	  }, [_vm._v("3,200")]), _vm._v(" "), _c('span', {
	    staticClass: "description-text"
	  }, [_vm._v("SALES")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 border-right"
	  }, [_c('div', {
	    staticClass: "description-block"
	  }, [_c('h5', {
	    staticClass: "description-header"
	  }, [_vm._v("13,000")]), _vm._v(" "), _c('span', {
	    staticClass: "description-text"
	  }, [_vm._v("FOLLOWERS")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('div', {
	    staticClass: "description-block"
	  }, [_c('h5', {
	    staticClass: "description-header"
	  }, [_vm._v("35")]), _vm._v(" "), _c('span', {
	    staticClass: "description-text"
	  }, [_vm._v("PRODUCTS")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "box box-widget widget-user"
	  }, [_c('div', {
	    staticClass: "widget-user-header bg-black",
	    staticStyle: {
	      "background": "url('/static/img/photo1.png') center center"
	    }
	  }, [_c('h3', {
	    staticClass: "widget-user-username"
	  }, [_vm._v("Elizabeth Pierce")]), _vm._v(" "), _c('h5', {
	    staticClass: "widget-user-desc"
	  }, [_vm._v("Web Designer")])]), _vm._v(" "), _c('div', {
	    staticClass: "widget-user-image"
	  }, [_c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": "/static/img/user3-128x128.jpg",
	      "alt": "User Avatar"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4 border-right"
	  }, [_c('div', {
	    staticClass: "description-block"
	  }, [_c('h5', {
	    staticClass: "description-header"
	  }, [_vm._v("3,200")]), _vm._v(" "), _c('span', {
	    staticClass: "description-text"
	  }, [_vm._v("SALES")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 border-right"
	  }, [_c('div', {
	    staticClass: "description-block"
	  }, [_c('h5', {
	    staticClass: "description-header"
	  }, [_vm._v("13,000")]), _vm._v(" "), _c('span', {
	    staticClass: "description-text"
	  }, [_vm._v("FOLLOWERS")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('div', {
	    staticClass: "description-block"
	  }, [_c('h5', {
	    staticClass: "description-header"
	  }, [_vm._v("35")]), _vm._v(" "), _c('span', {
	    staticClass: "description-text"
	  }, [_vm._v("PRODUCTS")])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('div', {
	    staticClass: "user-block"
	  }, [_c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "username"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Jonathan Burke Jr.")])]), _vm._v(" "), _c('span', {
	    staticClass: "description"
	  }, [_vm._v("Shared publicly - 7:30 PM Today")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "title": "Mark as read"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('img', {
	    staticClass: "img-responsive pad",
	    attrs: {
	      "src": "/static/img/photo2.png",
	      "alt": "Photo"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("I took this photo this morning. What do you guys think?")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-xs",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-share"
	  }), _vm._v(" Share")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-xs",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" Like")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right text-muted"
	  }, [_vm._v("127 likes - 3 comments")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer box-comments"
	  }, [_c('div', {
	    staticClass: "box-comment"
	  }, [_c('img', {
	    staticClass: "img-circle img-sm",
	    attrs: {
	      "src": "/static/img/user3-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "comment-text"
	  }, [_c('span', {
	    staticClass: "username"
	  }, [_vm._v("\n                      Maria Gonzales\n                      "), _c('span', {
	    staticClass: "text-muted pull-right"
	  }, [_vm._v("8:03 PM Today")])]), _vm._v("\n                It is a long established fact that a reader will be distracted\n                by the readable content of a page when looking at its layout.\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-comment"
	  }, [_c('img', {
	    staticClass: "img-circle img-sm",
	    attrs: {
	      "src": "/static/img/user4-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "comment-text"
	  }, [_c('span', {
	    staticClass: "username"
	  }, [_vm._v("\n                      Luna Stark\n                      "), _c('span', {
	    staticClass: "text-muted pull-right"
	  }, [_vm._v("8:03 PM Today")])]), _vm._v("\n                It is a long established fact that a reader will be distracted\n                by the readable content of a page when looking at its layout.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('form', {
	    attrs: {
	      "action": "#",
	      "method": "post"
	    }
	  }, [_c('img', {
	    staticClass: "img-responsive img-circle img-sm",
	    attrs: {
	      "src": "/static/img/user4-128x128.jpg",
	      "alt": "Alt Text"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "img-push"
	  }, [_c('input', {
	    staticClass: "form-control input-sm",
	    attrs: {
	      "type": "text",
	      "placeholder": "Press enter to post comment"
	    }
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-widget"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('div', {
	    staticClass: "user-block"
	  }, [_c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": "/static/img/user1-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "username"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Jonathan Burke Jr.")])]), _vm._v(" "), _c('span', {
	    staticClass: "description"
	  }, [_vm._v("Shared publicly - 7:30 PM Today")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-toggle": "tooltip",
	      "title": "Mark as read"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('p', [_vm._v("Far far away, behind the word mountains, far from the\n              countries Vokalia and Consonantia, there live the blind\n              texts. Separated they live in Bookmarksgrove right at")]), _vm._v(" "), _c('p', [_vm._v("the coast of the Semantics, a large language ocean.\n              A small river named Duden flows by their place and supplies\n              it with the necessary regelialia. It is a paradisematic\n              country, in which roasted parts of sentences fly into\n              your mouth.")]), _vm._v(" "), _c('div', {
	    staticClass: "attachment-block clearfix"
	  }, [_c('img', {
	    staticClass: "attachment-img",
	    attrs: {
	      "src": "/static/img/photo1.png",
	      "alt": "Attachment Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "attachment-pushed"
	  }, [_c('h4', {
	    staticClass: "attachment-heading"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.lipsum.com/"
	    }
	  }, [_vm._v("Lorem ipsum text generator")])]), _vm._v(" "), _c('div', {
	    staticClass: "attachment-text"
	  }, [_vm._v("\n                  Description about the attachment can be placed here.\n                  Lorem Ipsum is simply dummy text of the printing and typesetting industry... "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("more")])])])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-xs",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-share"
	  }), _vm._v(" Share")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-xs",
	    attrs: {
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" Like")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right text-muted"
	  }, [_vm._v("45 likes - 2 comments")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer box-comments"
	  }, [_c('div', {
	    staticClass: "box-comment"
	  }, [_c('img', {
	    staticClass: "img-circle img-sm",
	    attrs: {
	      "src": "/static/img/user3-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "comment-text"
	  }, [_c('span', {
	    staticClass: "username"
	  }, [_vm._v("\n                      Maria Gonzales\n                      "), _c('span', {
	    staticClass: "text-muted pull-right"
	  }, [_vm._v("8:03 PM Today")])]), _vm._v("\n                It is a long established fact that a reader will be distracted\n                by the readable content of a page when looking at its layout.\n              ")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-comment"
	  }, [_c('img', {
	    staticClass: "img-circle img-sm",
	    attrs: {
	      "src": "/static/img/user5-128x128.jpg",
	      "alt": "User Image"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "comment-text"
	  }, [_c('span', {
	    staticClass: "username"
	  }, [_vm._v("\n                      Nora Havisham\n                      "), _c('span', {
	    staticClass: "text-muted pull-right"
	  }, [_vm._v("8:03 PM Today")])]), _vm._v("\n                The point of using Lorem Ipsum is that it has a more-or-less\n                normal distribution of letters, as opposed to using\n                'Content here, content here', making it look like readable English.\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('form', {
	    attrs: {
	      "action": "#",
	      "method": "post"
	    }
	  }, [_c('img', {
	    staticClass: "img-responsive img-circle img-sm",
	    attrs: {
	      "src": "/static/img/user4-128x128.jpg",
	      "alt": "Alt Text"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "img-push"
	  }, [_c('input', {
	    staticClass: "form-control input-sm",
	    attrs: {
	      "type": "text",
	      "placeholder": "Press enter to post comment"
	    }
	  })])])])])])])])])
	}]}

/***/ }),

/***/ 1024:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper dashboard-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box palette-Pink-300 bg"
	  }, [_c('div', {
	    staticClass: "box-header  palette-Pink-300 bg"
	  }, [_c('div', {
	    staticClass: "pull-right text-white box-tools"
	  }, [_c('span', {
	    staticClass: "text-white box-btn"
	  }, [_c('i', {
	    staticClass: "circle-nest-medium ti-user"
	  })]), _vm._v("    ")]), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "text-white"
	  }, [_vm._v("   NEW USER")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body no-pad",
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_c('div', {
	    staticClass: "events-nest "
	  }, [_c('div', {
	    staticClass: "wrap-no-pad text-white"
	  }, [_c('bars', {
	    attrs: {
	      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 0],
	      "gradient": ['#ffffff', '#ffffff']
	    }
	  }), _vm._v(" "), _c('h1', {
	    staticClass: "text-white"
	  }, [_c('strong', [_c('animate-number', {
	    attrs: {
	      "from": "1",
	      "to": "45",
	      "duration": "9000",
	      "easing": "easeOutQuad",
	      "formatter": _vm.formatter
	    }
	  })], 1)]), _vm._v(" "), _c('span', [_vm._v("Active Users")]), _vm._v(" "), _c('p', [_vm._v("65%")]), _vm._v(" "), _c('br')], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box palette-Cyan-400 bg"
	  }, [_c('div', {
	    staticClass: "box-header  palette-Cyan-400 bg"
	  }, [_c('div', {
	    staticClass: "pull-right text-white box-tools"
	  }, [_c('span', {
	    staticClass: "text-white box-btn"
	  }, [_c('i', {
	    staticClass: "circle-nest-medium ti-stats-up"
	  })]), _vm._v("    ")]), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "text-white"
	  }, [_vm._v("   PAGE VIEWS")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body no-pad",
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_c('div', {
	    staticClass: "events-nest "
	  }, [_c('div', {
	    staticClass: "wrap-no-pad text-white"
	  }, [_c('bars', {
	    attrs: {
	      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 0],
	      "gradient": ['#ffffff', '#ffffff']
	    }
	  }), _vm._v(" "), _c('h1', {
	    staticClass: "text-white"
	  }, [_c('strong', [_c('animate-number', {
	    attrs: {
	      "from": "45575",
	      "to": "744",
	      "duration": "9000",
	      "easing": "easeOutQuad",
	      "formatter": _vm.formatter
	    }
	  })], 1)]), _vm._v(" "), _c('span', [_vm._v("PerWeek Views")]), _vm._v(" "), _c('p', [_vm._v("65%")]), _vm._v(" "), _c('br')], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box palette-Deep-Purple-300 bg"
	  }, [_c('div', {
	    staticClass: "box-header  palette-Deep-Purple-300 bg"
	  }, [_c('div', {
	    staticClass: "pull-right text-white box-tools"
	  }, [_c('span', {
	    staticClass: "text-white box-btn"
	  }, [_c('i', {
	    staticClass: "circle-nest-medium dripicons-wallet"
	  })]), _vm._v("    ")]), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "text-white"
	  }, [_vm._v("   DAILY SALES")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body no-pad",
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_c('div', {
	    staticClass: "events-nest "
	  }, [_c('div', {
	    staticClass: "wrap-no-pad text-white"
	  }, [_c('bars', {
	    attrs: {
	      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 0],
	      "gradient": ['#ffffff', '#ffffff']
	    }
	  }), _vm._v(" "), _c('h1', {
	    staticClass: "text-white"
	  }, [_c('strong', [_c('animate-number', {
	    attrs: {
	      "from": "0",
	      "to": "13",
	      "duration": "9000",
	      "easing": "easeOutQuad",
	      "formatter": _vm.formatter
	    }
	  })], 1)]), _vm._v(" "), _c('span', [_vm._v("Sales")]), _vm._v(" "), _c('p', [_vm._v("15%")]), _vm._v(" "), _c('br')], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "box palette-Indigo-900 bg"
	  }, [_c('div', {
	    staticClass: "box-header  palette-Indigo-900 bg"
	  }, [_c('div', {
	    staticClass: "pull-right text-white box-tools"
	  }, [_c('span', {
	    staticClass: "text-white box-btn"
	  }, [_c('i', {
	    staticClass: "circle-nest-medium dripicons-basket"
	  })]), _vm._v("    ")]), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "text-white"
	  }, [_vm._v("   TOTAL EARNINGS")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body no-pad",
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_c('div', {
	    staticClass: "events-nest "
	  }, [_c('div', {
	    staticClass: "wrap-no-pad text-white"
	  }, [_c('bars', {
	    attrs: {
	      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 0],
	      "gradient": ['#ffffff', '#ffffff']
	    }
	  }), _vm._v(" "), _c('h1', {
	    staticClass: "text-white"
	  }, [_c('strong', [_c('animate-number', {
	    attrs: {
	      "from": "1",
	      "to": "3500",
	      "duration": "9000",
	      "easing": "easeOutQuad",
	      "formatter": _vm.formatter
	    }
	  })], 1)]), _vm._v(" "), _c('span', [_vm._v("Dollars")]), _vm._v(" "), _c('p', [_c('animate-number', {
	    attrs: {
	      "from": "1",
	      "to": "65",
	      "duration": "9000",
	      "easing": "easeOutQuad",
	      "formatter": _vm.formatter
	    }
	  }), _vm._v("%")], 1), _vm._v(" "), _c('br')], 1)])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box no-shadow"
	  }, [_c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding": "0"
	    }
	  }, [_c('div', {
	    staticClass: "events-nest"
	  }, [_c('div', {
	    staticClass: "text-white lastest-post-nest palette-Blue-800 bg"
	  }, [_c('div', {
	    staticClass: "wrap"
	  }, [_c('small', {
	    staticClass: "palette-Blue-400 bg"
	  }, [_c('i', {
	    staticClass: "ti-facebook "
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('h1', {
	    staticClass: "text-white"
	  }, [_c('img', {
	    staticClass: "img-circle palette-Grey-900 bg",
	    attrs: {
	      "alt": "profile",
	      "src": "http://api.randomuser.me/portraits/thumb/men/46.jpg"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('h3', [_vm._v("D'Agustino Gavin")]), _vm._v(" "), _c('p', [_vm._v("Pink and Blue: Coloring Inside the Lines of Gender")]), _vm._v(" "), _c('p', [_c('el-rate', {
	    model: {
	      value: (_vm.value1),
	      callback: function($$v) {
	        _vm.value1 = $$v
	      },
	      expression: "value1"
	    }
	  })], 1), _vm._v(" "), _c('b', [_c('i', {
	    staticClass: "ti-eye"
	  }), _vm._v(" 121")]), _vm._v(" "), _c('b', [_c('i', {
	    staticClass: "ti-thumb-up"
	  }), _vm._v("45")]), _vm._v(" "), _c('b', [_c('i', {
	    staticClass: "ti-comment-alt"
	  }), _vm._v(" 8")])])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box no-shadow"
	  }, [_c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "padding": "0"
	    }
	  }, [_c('div', {
	    staticClass: "events-nest"
	  }, [_c('div', {
	    staticClass: "text-white lastest-post-nest-two palette-Deep-Purple-500 bg"
	  }, [_c('div', {
	    staticClass: "wrap"
	  }, [_c('small', {
	    staticClass: "palette-Blue-800 bg"
	  }, [_c('i', {
	    staticClass: "ti-twitter-alt "
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('h1', {
	    staticClass: "text-white"
	  }, [_c('img', {
	    staticClass: "img-circle palette-Grey-900 bg",
	    attrs: {
	      "alt": "profile",
	      "src": "http://api.randomuser.me/portraits/thumb/women/26.jpg"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('h3', [_vm._v("Dewi Saraswati")]), _vm._v(" "), _c('p', [_vm._v("Pink and Blue: Coloring Inside the Lines of Gender")]), _vm._v(" "), _c('p', [_c('el-rate', {
	    model: {
	      value: (_vm.value1),
	      callback: function($$v) {
	        _vm.value1 = $$v
	      },
	      expression: "value1"
	    }
	  })], 1), _vm._v(" "), _c('b', [_c('i', {
	    staticClass: "ti-eye"
	  }), _vm._v(" 121")]), _vm._v(" "), _c('b', [_c('i', {
	    staticClass: "ti-thumb-up"
	  }), _vm._v("45")]), _vm._v(" "), _c('b', [_c('i', {
	    staticClass: "ti-comment-alt"
	  }), _vm._v(" 8")])])])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-no-shadow"
	  }, [_c('div', {
	    staticClass: "box-body ",
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_c('div', {
	    staticClass: "row summary-border-top",
	    staticStyle: {
	      "margin": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "summary-nest"
	  }, [_c('h2', {
	    staticClass: "text-black "
	  }, [_c('span', {
	    staticClass: "counter-up"
	  }, [_vm._v("276.747")]), _c('small', {
	    staticClass: "palette-Orange-700 bg"
	  }, [_vm._v("K")])]), _vm._v(" "), _c('p', [_vm._v("Sales")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 summary-border-left"
	  }, [_c('div', {
	    staticClass: "summary-nest"
	  }, [_c('h2', {
	    staticClass: "text-black"
	  }, [_c('span', {
	    staticClass: "counter-up"
	  }, [_vm._v("3.219")]), _c('small', {
	    staticClass: "palette-Pink-500 bg"
	  }, [_vm._v("K")])]), _vm._v(" "), _c('p', [_vm._v("Man")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "summary-nest summary-pad-nest"
	  }, [_c('bars', {
	    attrs: {
	      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 4],
	      "gradient": ['#3b5998', '#3b5998']
	    }
	  }), _vm._v(" "), _c('h4', {
	    staticClass: "text-center"
	  }, [_c('span', {
	    staticClass: "counter-up"
	  }, [_vm._v("5")]), _vm._v("/"), _c('span', {
	    staticClass: "counter-up"
	  }, [_vm._v("12")]), _vm._v("/"), _c('span', {
	    staticClass: "counter-up"
	  }, [_vm._v("2013")])])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row summary-border-bottom",
	    staticStyle: {
	      "margin": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "summary-nest summary-pad-nest"
	  }, [_c('h2', {
	    staticClass: "text-black "
	  }, [_c('span', {
	    staticClass: "counter-up"
	  }, [_vm._v("82")]), _c('small', {
	    staticClass: "palette-Lime-500 bg "
	  }, [_vm._v("%")])]), _vm._v(" "), _c('p', [_vm._v("Avarage Sales")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 summary-border-left"
	  }, [_c('div', {
	    staticClass: "summary-nest summary-pad-nest"
	  }, [_c('h2', {
	    staticClass: "text-black"
	  }, [_c('span', {
	    staticClass: "counter-up"
	  }, [_vm._v("24")]), _c('small', {
	    staticClass: "palette-Teal-500 bg "
	  }, [_vm._v("th")])]), _vm._v(" "), _c('p', [_vm._v("Overall Rank")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box box-no-shadow bg-widget-random"
	  }, [_c('div', {
	    staticClass: "box-header bg-transparent"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_c('i', {
	    staticClass: "text-white ti-rss-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "text-white "
	  }, [_vm._v("LASTEST REPORT")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "margin": "15px 0 0"
	    }
	  }, [_c('div', {
	    staticClass: "stats-wrap"
	  }, [_c('h2', [_c('b', {
	    staticClass: "counter-up text-white"
	  }, [_vm._v("65,800,587")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "background": "#666"
	    }
	  }, [_vm._v("+"), _c('b', {
	    staticClass: "counter-up"
	  }, [_vm._v("20")]), _vm._v("%")])]), _vm._v(" "), _c('p', {
	    staticClass: "text-grey"
	  }, [_vm._v("Total students"), _c('small', [_vm._v("This Year")])]), _vm._v(" "), _c('h4', [_c('b', {
	    staticClass: "counter-up text-white"
	  }, [_vm._v("1,204")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "background": "#888"
	    }
	  }, [_vm._v("+"), _c('b', {
	    staticClass: "counter-up"
	  }, [_vm._v("5")]), _vm._v("%")])]), _vm._v(" "), _c('p', [_vm._v("Graduate "), _c('small', [_vm._v("This week")])]), _vm._v(" "), _c('h4', {
	    staticClass: "text-white"
	  }, [_c('b', {
	    staticClass: "counter-up"
	  }, [_vm._v("2,690")]), _vm._v(" "), _c('span', [_vm._v("+"), _c('b', {
	    staticClass: "counter-up"
	  }, [_vm._v("125")])])]), _vm._v(" "), _c('p', [_vm._v("New students"), _c('small', [_vm._v("This Month")])]), _vm._v(" "), _c('div', {
	    staticClass: "your-account"
	  }, [_c('h4', [_vm._v("Overall stats of sales and distribution")]), _vm._v(" "), _c('h6', [_vm._v("You must "), _c('strong', [_vm._v("complete")]), _vm._v(" this issues.")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "text-white palette-Orange-700 bg ti-pie-chart"
	  }), _vm._v(" 2.789")]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "text-white palette-Pink-700 bg ti-stats-down"
	  }), _vm._v("4.365")]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "palette-Cyan-700 bg text-white ti-bar-chart"
	  }), _vm._v("9.860 ")])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  })])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1025:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Sliders"), _c('small', [_vm._v("It's all start from here "), _c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Sliders")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Basic")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body",
	    staticStyle: {
	      "min-height": "400px"
	    }
	  }, [_c('h4', [_vm._v("Basic usage")]), _vm._v(" "), _c('p', [_vm._v("Content Goes Here")])])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1026:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Calendar Page"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Calendar Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('vue-event-calendar', {
	    attrs: {
	      "events": _vm.demoEvents
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),

/***/ 1027:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "main-header"
	  }, [_c('router-link', {
	    staticClass: "logo",
	    attrs: {
	      "to": "/dashboard"
	    }
	  }, [_c('span', {
	    staticClass: "logo-mini"
	  }, [_c('b', [_c('img', {
	    attrs: {
	      "src": "static/img/logo.png",
	      "alt": "User Image"
	    }
	  })])]), _vm._v(" "), _c('span', {
	    staticClass: "logo-lg"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/img/logo.png",
	      "alt": "User Image"
	    }
	  }), _c('b', [_vm._v("Devin")]), _vm._v("vue")])]), _vm._v(" "), _c('nav', {
	    staticClass: "navbar navbar-static-top"
	  }, [_vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
	    staticClass: "navbar-custom-menu"
	  }, [_c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [_c('li', [_c('el-dropdown', {
	    staticClass: "header-dropdown-devin",
	    attrs: {
	      "trigger": "click"
	    }
	  }, [_c('span', {
	    staticClass: "el-dropdown-link"
	  }, [_c('el-badge', {
	    staticClass: "item",
	    attrs: {
	      "value": 20,
	      "max": 9
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "type": "text",
	      "size": "small"
	    }
	  }, [_c('i', {
	    staticClass: "ti-email"
	  })])], 1)], 1), _vm._v(" "), _c('el-dropdown-menu', {
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, [_c('ul', {
	    staticClass: "dropdown-menu-devin"
	  }, [_c('li', {
	    staticClass: "header"
	  }, [_vm._v("You have 10+ Message")]), _vm._v(" "), _c('li', [_c('ul', {
	    staticClass: "menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('h3', [_vm._v("Announcements "), _c('span', [_vm._v("Just Now !")])]), _vm._v(" "), _c('p', [_vm._v("Pok ame ame belalang kupu kupu")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('h3', [_vm._v("Complete your profile"), _c('span', [_vm._v("2 Min Ago")])]), _vm._v(" "), _c('p', [_vm._v("Siang makan nasi kalo malam minum susu")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('h3', [_vm._v("New Schedule Realease"), _c('span', [_vm._v("30 Min ago")])]), _vm._v(" "), _c('p', [_vm._v("Bintang kecil dilangit yang tinggi")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('h3', [_vm._v("New Student Data"), _c('span', [_vm._v("1 Hour ago")])]), _vm._v(" "), _c('p', [_vm._v("Amat banyak menghias angkasa")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('h3', [_vm._v("Graduate Student List"), _c('span', [_vm._v("2 Days ago")])]), _vm._v(" "), _c('p', [_vm._v("Aku ingin terbang dan melayang, jauh tinggi ke tempat kau berada")])])])])]), _vm._v(" "), _c('li', {
	    staticClass: "footer"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("View all")])])])])], 1)], 1), _vm._v(" "), _c('li', [_c('el-dropdown', {
	    staticClass: "header-dropdown-devin",
	    attrs: {
	      "trigger": "click"
	    }
	  }, [_c('span', {
	    staticClass: "el-dropdown-link"
	  }, [_c('el-badge', {
	    staticClass: "item ",
	    attrs: {
	      "is-dot": ""
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "type": "text",
	      "size": "small"
	    }
	  }, [_c('i', {
	    staticClass: "ti-bell"
	  })])], 1)], 1), _vm._v(" "), _c('el-dropdown-menu', {
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, [_c('ul', {
	    staticClass: "dropdown-menu-devin"
	  }, [_c('li', {
	    staticClass: "header"
	  }, [_vm._v("You have 10 notifications")]), _vm._v(" "), _c('li', [_c('ul', {
	    staticClass: "menu"
	  }, [_c('li', [_c('i', {
	    staticClass: "ti-announcement"
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('h3', [_vm._v("Announcements "), _c('span', {
	    staticClass: "text-green fontello-record"
	  })]), _vm._v(" "), _c('p', [_vm._v("Just Now !")])])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "ti-user"
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('h3', [_vm._v("Complete your profile"), _c('span', {
	    staticClass: "text-yellow fontello-record"
	  })]), _vm._v(" "), _c('p', [_vm._v("2 Min Ago")])])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "ti-notepad"
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('h3', [_vm._v("New Schedule Realease"), _c('span', {
	    staticClass: "text-yellow fontello-record"
	  })]), _vm._v(" "), _c('p', [_vm._v("30 Min ago")])])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "ti-agenda"
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('h3', [_vm._v("New User Data"), _c('span', {
	    staticClass: "text-orange fontello-record"
	  })]), _vm._v(" "), _c('p', [_vm._v("1 Hour ago")])])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "ti-package"
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('h3', [_vm._v("New User List"), _c('span', {
	    staticClass: "fontello-record"
	  })]), _vm._v(" "), _c('p', [_vm._v("2 Days ago")])])])])]), _vm._v(" "), _c('li', {
	    staticClass: "footer"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("View all")])])])])], 1)], 1), _vm._v(" "), _c('li', [_c('el-dropdown', {
	    staticClass: "header-dropdown-devin",
	    attrs: {
	      "trigger": "click"
	    }
	  }, [_c('span', {
	    staticClass: "el-dropdown-link"
	  }, [_c('el-button', {
	    attrs: {
	      "data-toggle": "control-sidebar",
	      "type": "text",
	      "size": "small"
	    }
	  }, [_c('i', {
	    staticClass: "dripicons-swap"
	  })])], 1)])], 1)])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "sidebar-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "offcanvas",
	      "role": "button"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-left-search"
	  }, [_c('form', {
	    attrs: {
	      "id": "demo-2"
	    }
	  }, [_c('input', {
	    staticClass: "devin-search",
	    attrs: {
	      "type": "search"
	    }
	  })])])
	}]}

/***/ }),

/***/ 1028:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Chat App"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Chat App")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "container-chat clearfix"
	  }, [_c('div', {
	    staticClass: "people-list",
	    attrs: {
	      "id": "people-list"
	    }
	  }, [_c('div', {
	    staticClass: "search"
	  }, [_c('input', {
	    attrs: {
	      "type": "text",
	      "placeholder": "search"
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-search"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "list"
	  }, [_c('li', {
	    staticClass: "clearfix"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://api.randomuser.me/portraits/men/22.jpg",
	      "alt": "avatar"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "about"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("Vincent Porter")]), _vm._v(" "), _c('div', {
	    staticClass: "status"
	  }, [_c('i', {
	    staticClass: "fa fa-circle online"
	  }), _vm._v(" online ")])])]), _vm._v(" "), _c('li', {
	    staticClass: "clearfix"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://api.randomuser.me/portraits/men/23.jpg",
	      "alt": "avatar"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "about"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("Aiden Chavez")]), _vm._v(" "), _c('div', {
	    staticClass: "status"
	  }, [_c('i', {
	    staticClass: "fa fa-circle offline"
	  }), _vm._v(" left 7 mins ago ")])])]), _vm._v(" "), _c('li', {
	    staticClass: "clearfix"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://api.randomuser.me/portraits/men/24.jpg",
	      "alt": "avatar"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "about"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("Mike Thomas")]), _vm._v(" "), _c('div', {
	    staticClass: "status"
	  }, [_c('i', {
	    staticClass: "fa fa-circle online"
	  }), _vm._v(" online ")])])]), _vm._v(" "), _c('li', {
	    staticClass: "clearfix"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://api.randomuser.me/portraits/women/25.jpg",
	      "alt": "avatar"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "about"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("Erica Hughes")]), _vm._v(" "), _c('div', {
	    staticClass: "status"
	  }, [_c('i', {
	    staticClass: "fa fa-circle online"
	  }), _vm._v(" online ")])])]), _vm._v(" "), _c('li', {
	    staticClass: "clearfix"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://api.randomuser.me/portraits/women/26.jpg",
	      "alt": "avatar"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "about"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("Ginger Johnston")]), _vm._v(" "), _c('div', {
	    staticClass: "status"
	  }, [_c('i', {
	    staticClass: "fa fa-circle online"
	  }), _vm._v(" online ")])])]), _vm._v(" "), _c('li', {
	    staticClass: "clearfix"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://api.randomuser.me/portraits/women/27.jpg",
	      "alt": "avatar"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "about"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("Tracy Carpenter")]), _vm._v(" "), _c('div', {
	    staticClass: "status"
	  }, [_c('i', {
	    staticClass: "fa fa-circle offline"
	  }), _vm._v(" left 30 mins ago ")])])]), _vm._v(" "), _c('li', {
	    staticClass: "clearfix"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://api.randomuser.me/portraits/men/28.jpg",
	      "alt": "avatar"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "about"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("Christian Kelly")]), _vm._v(" "), _c('div', {
	    staticClass: "status"
	  }, [_c('i', {
	    staticClass: "fa fa-circle offline"
	  }), _vm._v(" left 10 hours ago ")])])]), _vm._v(" "), _c('li', {
	    staticClass: "clearfix"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://api.randomuser.me/portraits/women/29.jpg",
	      "alt": "avatar"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "about"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("Monica Ward")]), _vm._v(" "), _c('div', {
	    staticClass: "status"
	  }, [_c('i', {
	    staticClass: "fa fa-circle online"
	  }), _vm._v(" online ")])])]), _vm._v(" "), _c('li', {
	    staticClass: "clearfix"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://api.randomuser.me/portraits/men/30.jpg",
	      "alt": "avatar"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "about"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("Dean Henry")]), _vm._v(" "), _c('div', {
	    staticClass: "status"
	  }, [_c('i', {
	    staticClass: "fa fa-circle offline"
	  }), _vm._v(" offline since Oct 28 ")])])]), _vm._v(" "), _c('li', {
	    staticClass: "clearfix"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://api.randomuser.me/portraits/women/31.jpg",
	      "alt": "avatar"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "about"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("Peyton Mckinney")]), _vm._v(" "), _c('div', {
	    staticClass: "status"
	  }, [_c('i', {
	    staticClass: "fa fa-circle online"
	  }), _vm._v(" online ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "chat"
	  }, [_c('div', {
	    staticClass: "chat-header clearfix"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://api.randomuser.me/portraits/men/32.jpg",
	      "alt": "avatar"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "chat-about"
	  }, [_c('div', {
	    staticClass: "chat-with"
	  }, [_vm._v("Chat with Vincent Porter")]), _vm._v(" "), _c('div', {
	    staticClass: "chat-num-messages"
	  }, [_vm._v("already 1 902 messages")])]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-star"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "chat-history"
	  }, [_c('ul', [_c('li', {
	    staticClass: "clearfix"
	  }, [_c('div', {
	    staticClass: "message-data align-right"
	  }, [_c('span', {
	    staticClass: "message-data-time"
	  }, [_vm._v("10:10 AM, Today")]), _vm._v("     "), _c('span', {
	    staticClass: "message-data-name"
	  }, [_vm._v("Olia")]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-circle me"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "message other-message float-right"
	  }, [_vm._v(" Hi Vincent, how are you? How is the project coming along? ")])]), _vm._v(" "), _c('li', [_c('div', {
	    staticClass: "message-data"
	  }, [_c('span', {
	    staticClass: "message-data-name"
	  }, [_c('i', {
	    staticClass: "fa fa-circle online"
	  }), _vm._v(" Vincent")]), _vm._v(" "), _c('span', {
	    staticClass: "message-data-time"
	  }, [_vm._v("10:12 AM, Today")])]), _vm._v(" "), _c('div', {
	    staticClass: "message my-message"
	  }, [_vm._v(" Are we meeting today? Project has been already finished and I have results to show you. ")])]), _vm._v(" "), _c('li', {
	    staticClass: "clearfix"
	  }, [_c('div', {
	    staticClass: "message-data align-right"
	  }, [_c('span', {
	    staticClass: "message-data-time"
	  }, [_vm._v("10:14 AM, Today")]), _vm._v("     "), _c('span', {
	    staticClass: "message-data-name"
	  }, [_vm._v("Olia")]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-circle me"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "message other-message float-right"
	  }, [_vm._v(" Well I am not sure. The rest of the team is not here yet. Maybe in an hour or so? Have you faced any problems at the last phase of the project? ")])]), _vm._v(" "), _c('li', [_c('div', {
	    staticClass: "message-data"
	  }, [_c('span', {
	    staticClass: "message-data-name"
	  }, [_c('i', {
	    staticClass: "fa fa-circle online"
	  }), _vm._v(" Vincent")]), _vm._v(" "), _c('span', {
	    staticClass: "message-data-time"
	  }, [_vm._v("10:20 AM, Today")])]), _vm._v(" "), _c('div', {
	    staticClass: "message my-message"
	  }, [_vm._v(" Actually everything was fine. I'm very excited to show this to our team. ")])]), _vm._v(" "), _c('li', [_c('div', {
	    staticClass: "message-data"
	  }, [_c('span', {
	    staticClass: "message-data-name"
	  }, [_c('i', {
	    staticClass: "fa fa-circle online"
	  }), _vm._v(" Vincent")]), _vm._v(" "), _c('span', {
	    staticClass: "message-data-time"
	  }, [_vm._v("10:31 AM, Today")])]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-circle online"
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-circle online",
	    staticStyle: {
	      "color": "#AED2A6"
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-circle online",
	    staticStyle: {
	      "color": "#DAE9DA"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "chat-message clearfix"
	  }, [_c('textarea', {
	    attrs: {
	      "name": "message-to-send",
	      "id": "message-to-send",
	      "placeholder": "Type your message",
	      "rows": "3"
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-file-o"
	  }), _vm._v("     "), _c('i', {
	    staticClass: "fa fa-file-image-o"
	  }), _vm._v(" "), _c('button', [_vm._v("Send")])])])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1029:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_vm._m(0, false, false), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Vue Bar")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(2, false, false), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('bars', {
	    attrs: {
	      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 0],
	      "gradient": ['#000000', '#000000']
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_vm._m(3, false, false), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('bars', {
	    attrs: {
	      "data": [4, 2, 5, 9, 5, 10, 3, 5, 2, 5, 9, 8, 2, 9, 4, 5, 6, 9, 5, 9, 6, 4, 9, 6, 9, 5, 4, 6, 5, 4],
	      "gradient": ['#6fa8dc', '#42b983']
	    }
	  })], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_vm._v("Vue Bar"), _c('small', [_vm._v("Input data using mouse or keyboard. "), _c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Charts")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("VueBar Option 1")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa ti-close"
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("VueBar Option 2")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "fa ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "fa ti-close"
	  })])])])
	}]}

/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Tinymce Editor"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("UI Element")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Tinymce Editor")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('h5', [_vm._v("Click to upload files")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-upload', {
	    staticClass: "upload-demo",
	    attrs: {
	      "action": "https://jsonplaceholder.typicode.com/posts/",
	      "on-preview": _vm.handlePreview,
	      "on-remove": _vm.handleRemove,
	      "file-list": _vm.fileList
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "size": "small",
	      "type": "primary"
	    }
	  }, [_vm._v("Click to upload")]), _vm._v(" "), _c('div', {
	    staticClass: "el-upload__tip",
	    attrs: {
	      "slot": "tip"
	    },
	    slot: "tip"
	  }, [_vm._v("jpg/png files with a size less than 500kb")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("FileList with thumbnail")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-upload', {
	    staticClass: "upload-demo",
	    attrs: {
	      "action": "https://jsonplaceholder.typicode.com/posts/",
	      "on-preview": _vm.handlePreview,
	      "on-remove": _vm.handleRemove,
	      "file-list": _vm.fileList2,
	      "list-type": "picture"
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "size": "small",
	      "type": "primary"
	    }
	  }, [_vm._v("Click to upload")]), _vm._v(" "), _c('div', {
	    staticClass: "el-upload__tip",
	    attrs: {
	      "slot": "tip"
	    },
	    slot: "tip"
	  }, [_vm._v("jpg/png files with a size less than 500kb")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("FileList with thumbnail")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-upload', {
	    attrs: {
	      "action": "https://jsonplaceholder.typicode.com/posts/",
	      "list-type": "picture-card",
	      "on-preview": _vm.handlePictureCardPreview,
	      "on-remove": _vm.handleRemove
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-plus"
	  })]), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "size": "tiny"
	    },
	    model: {
	      value: (_vm.dialogVisible),
	      callback: function($$v) {
	        _vm.dialogVisible = $$v
	      },
	      expression: "dialogVisible"
	    }
	  }, [_c('img', {
	    attrs: {
	      "width": "100%",
	      "src": _vm.dialogImageUrl,
	      "alt": ""
	    }
	  })])], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1031:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Blog Mansory Page"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Blog Mansory Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row-mansory"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "well-media"
	  }, [_c('div', {
	    staticClass: "vendor"
	  }, [_c('div', {
	    staticClass: "fluid-width-video-wrapper embed-responsive embed-responsive-16by9"
	  }, [_c('iframe', {
	    staticClass: "embed-responsive-item",
	    attrs: {
	      "src": "http://www.youtube.com/embed/BO03CROMVjo",
	      "frameborder": "0",
	      "allowfullscreen": "",
	      "id": "fitvid741674"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "video-text"
	  }, [_c('h2', [_vm._v("Baby Shark Dance | Sing and Dance! | Animal Songs | PINKFONG Songs for Children\n")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus et dui id justo rhoncus consequat. Aliquam porttitor, arcu quis ornare ultricies, augue neque fringilla turpis.")])]), _vm._v(" "), _c('div', {
	    staticClass: "tag-nest"
	  }, [_c('i', [_vm._v("angel")]), _c('i', [_vm._v("dark")]), _c('i', [_vm._v("mistic")])]), _vm._v(" "), _c('div', {
	    staticClass: "video-category-bg"
	  }, [_c('h3', [_vm._v("Video")]), _vm._v(" "), _c('a', {
	    staticClass: "link-media pull-right",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "fontawesome-film"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "triangle-white"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "triangle-video-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "well-media"
	  }, [_c('div', {
	    staticClass: "vendor"
	  }, [_c('a', {
	    staticClass: "fancybox",
	    attrs: {
	      "rel": "group",
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "img-responsive-media",
	    attrs: {
	      "src": "https://source.unsplash.com/collection/190727/1500x900",
	      "alt": ""
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "video-text"
	  }, [_c('h2', [_vm._v("Black Angel")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit.")])]), _vm._v(" "), _c('div', {
	    staticClass: "tag-nest"
	  }, [_c('i', [_vm._v("angel")]), _c('i', [_vm._v("dark")]), _c('i', [_vm._v("mistic")])]), _vm._v(" "), _c('div', {
	    staticClass: "photo-category-bg"
	  }, [_c('h3', [_vm._v("Photo")]), _vm._v(" "), _c('a', {
	    staticClass: "link-media pull-right",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "fontawesome-picture"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "triangle-white"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "triangle-photo-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "well-media"
	  }, [_c('div', {
	    staticClass: "vendor embed-responsive embed-responsive-16by9"
	  }, [_c('iframe', {
	    staticClass: "embed-responsive-item",
	    attrs: {
	      "src": "http://www.youtube.com/embed/dqb4o3ycv4k",
	      "frameborder": "0",
	      "allowfullscreen": "",
	      "id": "fitvid741674"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "video-text"
	  }, [_c('h2', [_vm._v("Coldplay ft The Chainsmokers - Look What You Made Me Do")]), _vm._v(" "), _c('p', [_vm._v("I do not own the music and the background.\n\nCopyright Disclaimer Under Section 107 of the Copyright Act 1976")])]), _vm._v(" "), _c('div', {
	    staticClass: "tag-nest"
	  }, [_c('i', [_vm._v("patah ")]), _c('i', [_vm._v("hati")]), _c('i', [_vm._v("music")])]), _vm._v(" "), _c('div', {
	    staticClass: "audio-category-bg"
	  }, [_c('h3', [_vm._v("audio")]), _vm._v(" "), _c('a', {
	    staticClass: "link-media pull-right",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "entypo-note-beamed"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "triangle-white"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "triangle-audio-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "well-media"
	  }, [_c('div', {
	    staticClass: "vendor"
	  }, [_c('div', {
	    staticClass: "carousel slide",
	    attrs: {
	      "data-ride": "carousel",
	      "id": "carousel-example-generic"
	    }
	  }, [_c('ol', {
	    staticClass: "carousel-indicators"
	  }, [_c('li', {
	    attrs: {
	      "data-slide-to": "0",
	      "data-target": "#carousel-example-generic"
	    }
	  }), _vm._v(" "), _c('li', {
	    staticClass: "active",
	    attrs: {
	      "data-slide-to": "1",
	      "data-target": "#carousel-example-generic"
	    }
	  }), _vm._v(" "), _c('li', {
	    attrs: {
	      "data-slide-to": "2",
	      "data-target": "#carousel-example-generic"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "carousel-inner"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('img', {
	    staticClass: "img-responsive-media",
	    attrs: {
	      "alt": "First slide",
	      "src": "https://source.unsplash.com/collection/431862/800x600"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "item active"
	  }, [_c('img', {
	    staticClass: "img-responsive-media",
	    attrs: {
	      "alt": "Second slide",
	      "src": "https://source.unsplash.com/collection/474045/800x600"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('img', {
	    staticClass: "img-responsive-media",
	    attrs: {
	      "alt": "Third slide",
	      "src": "https://source.unsplash.com/collection/981639/800x600"
	    }
	  })])]), _vm._v(" "), _c('a', {
	    staticClass: "left carousel-control",
	    attrs: {
	      "data-slide": "prev",
	      "href": "#carousel-example-generic"
	    }
	  }, [_c('span', {
	    staticClass: "devin-panel-car ti-arrow-circle-left"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "right carousel-control",
	    attrs: {
	      "data-slide": "next",
	      "href": "#carousel-example-generic"
	    }
	  }, [_c('span', {
	    staticClass: "devin-panel-car ti-arrow-circle-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "video-text"
	  }, [_c('h2', [_vm._v("Holyday")]), _vm._v(" "), _c('p', [_vm._v("It ws may last summer holyday")])]), _vm._v(" "), _c('div', {
	    staticClass: "tag-nest"
	  }, [_c('i', [_vm._v("angel")]), _c('i', [_vm._v("dark")]), _c('i', [_vm._v("mistic")])]), _vm._v(" "), _c('div', {
	    staticClass: "album-category-bg"
	  }, [_c('h3', [_vm._v("Photoset")]), _vm._v(" "), _c('a', {
	    staticClass: "link-media pull-right",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "entypo-picture"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "triangle-white"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "triangle-album-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "well-media"
	  }, [_c('div', {
	    staticClass: "vendor"
	  }, [_c('div', {
	    staticClass: "fluid-width-video-wrapper embed-responsive embed-responsive-16by9"
	  }, [_c('iframe', {
	    staticClass: "embed-responsive-item",
	    attrs: {
	      "src": "//www.youtube.com/embed/ICAisYcDNqw",
	      "frameborder": "0",
	      "allowfullscreen": "",
	      "id": "fitvid892886"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "video-text"
	  }, [_c('h2', [_vm._v("Black Angel")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus et dui id justo rhoncus consequat. Aliquam porttitor, arcu quis ornare ultricies, augue neque fringilla turpis.")])]), _vm._v(" "), _c('div', {
	    staticClass: "tag-nest"
	  }, [_c('i', [_vm._v("angel")]), _c('i', [_vm._v("dark")]), _c('i', [_vm._v("mistic")])]), _vm._v(" "), _c('div', {
	    staticClass: "video-category-bg"
	  }, [_c('h3', [_vm._v("Video")]), _vm._v(" "), _c('a', {
	    staticClass: "link-media pull-right",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "fontawesome-film"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "triangle-white"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "triangle-video-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "well-media"
	  }, [_c('div', {
	    staticClass: "vendor"
	  }, [_c('a', {
	    attrs: {
	      "rel": "group",
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "img-responsive-media",
	    attrs: {
	      "src": "http://lorempixel.com/output/food-h-c-350-450-8.jpg",
	      "alt": ""
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "video-text"
	  }, [_c('h2', [_vm._v("Black Angel")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit.")])]), _vm._v(" "), _c('div', {
	    staticClass: "tag-nest"
	  }, [_c('i', [_vm._v("angel")]), _c('i', [_vm._v("dark")]), _c('i', [_vm._v("mistic")])]), _vm._v(" "), _c('div', {
	    staticClass: "photo-category-bg"
	  }, [_c('h3', [_vm._v("Photo")]), _vm._v(" "), _c('a', {
	    staticClass: "link-media pull-right",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "fontawesome-picture"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "triangle-white"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "triangle-photo-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "well-media"
	  }, [_c('div', {
	    staticClass: "vendor"
	  }, [_c('iframe', {
	    attrs: {
	      "width": "100%",
	      "height": "166",
	      "scrolling": "no",
	      "frameborder": "no",
	      "src": "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/88278446&color=ff5500&auto_play=false&hide_related=false&show_artwork=true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "video-text"
	  }, [_c('h2', [_vm._v("Favright")]), _vm._v(" "), _c('p', [_vm._v("Favright - Taking Over (feat. Cassandra Kay)")])]), _vm._v(" "), _c('div', {
	    staticClass: "tag-nest"
	  }, [_c('i', [_vm._v("patah ")]), _c('i', [_vm._v("hati")]), _c('i', [_vm._v("music")])]), _vm._v(" "), _c('div', {
	    staticClass: "audio-category-bg"
	  }, [_c('h3', [_vm._v("audio")]), _vm._v(" "), _c('a', {
	    staticClass: "link-media pull-right",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "entypo-note-beamed"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "triangle-white"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "triangle-audio-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "well-media"
	  }, [_c('div', {
	    staticClass: "vendor"
	  }, [_c('div', {
	    staticClass: "carousel slide",
	    attrs: {
	      "data-ride": "carousel",
	      "id": "carousel-dua"
	    }
	  }, [_c('ol', {
	    staticClass: "carousel-indicators"
	  }, [_c('li', {
	    attrs: {
	      "data-slide-to": "0",
	      "data-target": "#carousel-dua"
	    }
	  }), _vm._v(" "), _c('li', {
	    attrs: {
	      "data-slide-to": "1",
	      "data-target": "#carousel-dua"
	    }
	  }), _vm._v(" "), _c('li', {
	    staticClass: "active",
	    attrs: {
	      "data-slide-to": "2",
	      "data-target": "#carousel-dua"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "carousel-inner"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('img', {
	    staticClass: "img-responsive-media",
	    attrs: {
	      "alt": "First slide",
	      "data-src": "holder.js/900x500/auto/#777:#555/text:First slide",
	      "src": "http://placehold.it/350x250"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('img', {
	    staticClass: "img-responsive-media",
	    attrs: {
	      "alt": "Second slide",
	      "data-src": "holder.js/900x500/auto/#666:#444/text:Second slide",
	      "src": "http://placehold.it/350x250"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "item active"
	  }, [_c('img', {
	    staticClass: "img-responsive-media",
	    attrs: {
	      "alt": "Third slide",
	      "data-src": "holder.js/900x500/auto/#555:#333/text:Third slide",
	      "src": "http://placehold.it/350x250"
	    }
	  })])]), _vm._v(" "), _c('a', {
	    staticClass: "left carousel-control",
	    attrs: {
	      "data-slide": "prev",
	      "href": "#carousel-dua"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-chevron-left"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "right carousel-control",
	    attrs: {
	      "data-slide": "next",
	      "href": "#carousel-dua"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-chevron-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "video-text"
	  }, [_c('h2', [_vm._v("Holyday")]), _vm._v(" "), _c('p', [_vm._v("It ws may last summer holyday")])]), _vm._v(" "), _c('div', {
	    staticClass: "tag-nest"
	  }, [_c('i', [_vm._v("angel")]), _c('i', [_vm._v("dark")]), _c('i', [_vm._v("mistic")])]), _vm._v(" "), _c('div', {
	    staticClass: "album-category-bg"
	  }, [_c('h3', [_vm._v("Photoset")]), _vm._v(" "), _c('a', {
	    staticClass: "link-media pull-right",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "entypo-picture"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "triangle-white"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "triangle-album-right"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "well-media"
	  }, [_c('div', {
	    staticClass: "vendor"
	  }, [_c('iframe', {
	    attrs: {
	      "width": "100%",
	      "height": "166",
	      "scrolling": "no",
	      "frameborder": "no",
	      "src": "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/149950304&color=ff5500&auto_play=false&hide_related=false&show_artwork=true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "video-text"
	  }, [_c('h2', [_vm._v("Terlatih Patah Hati")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit.")])]), _vm._v(" "), _c('div', {
	    staticClass: "tag-nest"
	  }, [_c('i', [_vm._v("patah ")]), _c('i', [_vm._v("hati")]), _c('i', [_vm._v("music")])]), _vm._v(" "), _c('div', {
	    staticClass: "audio-category-bg"
	  }, [_c('h3', [_vm._v("audio")]), _vm._v(" "), _c('a', {
	    staticClass: "link-media pull-right",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "entypo-note-beamed"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "triangle-white"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "triangle-audio-right"
	  })])])])])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1032:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Blank Page"), _c('small', [_vm._v("It's all start from here "), _c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Common Page")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Login Page")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('el-dialog', {
	    attrs: {
	      "title": "Login",
	      "visible": _vm.dialogVisible,
	      "size": "tiny",
	      "visible": "false",
	      "before-close": _vm.handleClose
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.dialogVisible = $event
	      }
	    }
	  }, [_c('div', {
	    staticClass: "account-box"
	  }, [_c('form', {
	    attrs: {
	      "role": "form"
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('a', {
	    staticClass: "pull-right label-forgot",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Forgot email?")]), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "inputUsernameEmail"
	    }
	  }, [_vm._v("Username or email")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "inputUsernameEmail"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('a', {
	    staticClass: "pull-right label-forgot",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Forgot password?")]), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "inputPassword"
	    }
	  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "id": "inputPassword"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox pull-left"
	  }, [_c('label', [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    }
	  }), _vm._v("Remember me")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn btn-primary pull-right",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_c('router-link', {
	    staticStyle: {
	      "color": "#fff"
	    },
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v(" Log In ")])], 1)]), _vm._v(" "), _c('a', {
	    staticClass: "forgotLnk",
	    attrs: {
	      "href": "#"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "or-box"
	  }, [_c('center', [_c('span', {
	    staticClass: "text-center login-with"
	  }, [_vm._v("Login or "), _c('b', [_vm._v("Sign Up")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 row-block"
	  }, [_c('a', {
	    staticClass: "btn btn-facebook btn-block",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-facebook space-icon"
	  }), _vm._v("Facebook")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 row-block"
	  }, [_c('a', {
	    staticClass: "btn btn-twitter btn-block",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-twitter space-icon"
	  }), _vm._v("Twitter")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-top": "25px"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-6 row-block"
	  }, [_c('a', {
	    staticClass: "btn btn-google btn-block",
	    attrs: {
	      "href": "#/profile"
	    }
	  }, [_c('span', {
	    staticClass: "ti-google space-icon"
	  }), _vm._v("Google +")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 row-block"
	  }, [_c('a', {
	    staticClass: "btn btn-instagram btn-block",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "ti-instagram space-icon"
	  }), _vm._v("Instagram")])])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row-block"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 row-block"
	  }, [_c('a', {
	    staticClass: "btn btn-primary btn-block",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Create New Account")])])])])])])], 1)])])
	},staticRenderFns: []}

/***/ }),

/***/ 1033:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0, false, false)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "main-footer"
	  }, [_c('div', {
	    staticClass: "pull-right hidden-xs"
	  }, [_c('b', [_vm._v("Version")]), _vm._v(" 1.1\n  ")]), _vm._v("\n  Devin Vue Admin © 2017 "), _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('strong', [_vm._v("Matirasa")])]), _vm._v(". Made with love\n")])
	}]}

/***/ }),

/***/ 1034:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0, false, false)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('aside', {
	    staticClass: "control-sidebar control-sidebar-light"
	  }, [_c('ul', {
	    staticClass: "nav navbar-stacked "
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Black-100 bg ti-menu-alt"
	  }), _vm._v("Notifications")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Deep-Purple-100 bg ti-menu-alt"
	  }), _c('i', {
	    staticClass: "ti-more-alt"
	  }), _c('span', {
	    staticClass: "palette-Deep-Purple-200 bg ti-shopping-cart-full"
	  }), _c('i', {
	    staticClass: "ti-more-alt"
	  }), _c('span', {
	    staticClass: "palette-Deep-Purple-400 bg ti-gift"
	  }), _c('i', {
	    staticClass: "ti-more-alt"
	  }), _c('span', {
	    staticClass: "palette-Deep-Purple-600 bg ti-truck"
	  }), _c('i', {
	    staticClass: "ti-more-alt"
	  }), _c('span', {
	    staticClass: "palette-Deep-Purple-800 bg ti-home"
	  }), _vm._v("Shipping proses of "), _c('strong', [_vm._v("Robert Langdon")]), _vm._v(" is completed!"), _c('small', [_vm._v("1m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Blue-A100 bg ti-user"
	  }), _vm._v("Meet new user "), _c('strong', [_vm._v("Lilian Meirs")]), _c('small', [_vm._v("23m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Red-A400 bg ti-cloud-down"
	  }), _c('strong', [_vm._v("Robert")]), _vm._v(" added new request for ne item for refund"), _c('small', [_vm._v("34m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Orange-200 bg ti-menu-alt"
	  }), _c('i', {
	    staticClass: "ti-more-alt"
	  }), _c('span', {
	    staticClass: "palette-Orange-400 bg ti-shopping-cart-full"
	  }), _c('i', {
	    staticClass: "ti-more-alt"
	  }), _c('span', {
	    staticClass: "palette-Orange-600 bg ti-gift"
	  }), _c('br'), _vm._v("Shipping proses of "), _c('strong', [_vm._v("Robert Langdon")]), _vm._v(" is completed!"), _c('small', [_vm._v("40m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Amber-500 bg ti-comment-alt"
	  }), _vm._v("Mike Nilson commented Post"), _c('br'), _vm._v("\nLike this one! Keep going!"), _c('small', [_vm._v("50m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Cyan-300 bg ti-shopping-cart-full"
	  }), _vm._v("Amazing! "), _c('strong', [_vm._v("Mike Nilson")]), _vm._v(" just purchased Your item "), _c('small', [_vm._v("1h")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Light-Green-500 bg ti-image"
	  }), _c('strong', [_vm._v("Lilian Meirs")]), _vm._v(" Posting new image cover, and just got 2.000 likes"), _c('br'), _c('img', {
	    attrs: {
	      "alt": "",
	      "src": "https://source.unsplash.com/category/technology/500x200"
	    }
	  }), _c('small', [_vm._v("1h 12m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Amber-500 bg ti-comment-alt"
	  }), _vm._v("Mike Nilson commented Post"), _c('br'), _vm._v("\nLike this one! Keep going!"), _c('small', [_vm._v("1h 39")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Cyan-300 bg ti-shopping-cart-full"
	  }), _vm._v("Amazing! "), _c('strong', [_vm._v("Mike Nilson")]), _vm._v(" just purchased Your item"), _c('br'), _c('img', {
	    attrs: {
	      "alt": "",
	      "src": "https://source.unsplash.com/category/food/500x200"
	    }
	  }), _vm._v(" "), _c('small', [_vm._v("1h 45m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Cyan-300 bg ti-shopping-cart-full"
	  }), _vm._v("Amazing! "), _c('strong', [_vm._v("Mike Nilson")]), _vm._v(" just purchased Your item "), _c('small', [_vm._v("23m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Amber-500 bg ti-comment-alt"
	  }), _vm._v("Mike Nilson commented Post"), _c('br'), _vm._v("\nLike this one! Keep going!"), _c('small', [_vm._v("2h")])])])])])])
	}]}

/***/ }),

/***/ 1035:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-center"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("Forms Switch"), _c('small', [_c('i', {
	    staticClass: "ti-heart"
	  }), _c('i', {
	    staticClass: "ti-export"
	  }), _c('i', {
	    staticClass: "ti-printer"
	  })])]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Forms ")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Switch")])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header "
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Basic usage "), _c('small', [_vm._v("Switch is used for switching between two opposing states.")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-switch', {
	    attrs: {
	      "on-text": "",
	      "off-text": ""
	    },
	    model: {
	      value: (_vm.value1),
	      callback: function($$v) {
	        _vm.value1 = $$v
	      },
	      expression: "value1"
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-switch', {
	    attrs: {
	      "on-color": "#13ce66",
	      "off-color": "#ff4949"
	    },
	    model: {
	      value: (_vm.value2),
	      callback: function($$v) {
	        _vm.value2 = $$v
	      },
	      expression: "value2"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header "
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Extended value types")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('p', [_vm._v("You can set "), _c('code', [_vm._v("on-value")]), _vm._v(" and "), _c('code', [_vm._v("off-value")]), _vm._v(" attributes. They both receive a "), _c('code', [_vm._v("Boolean")]), _vm._v(", "), _c('code', [_vm._v("String")]), _vm._v(" or "), _c('code', [_vm._v("Number")]), _vm._v(" typed value.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-tooltip', {
	    attrs: {
	      "content": 'Switch value: ' + _vm.value5,
	      "placement": "right"
	    }
	  }, [_c('el-switch', {
	    attrs: {
	      "on-color": "#13ce66",
	      "off-color": "#ff4949",
	      "on-value": "100",
	      "off-value": "0"
	    },
	    model: {
	      value: (_vm.value5),
	      callback: function($$v) {
	        _vm.value5 = $$v
	      },
	      expression: "value5"
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-header "
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Disabled")]), _vm._v(" "), _c('div', {
	    staticClass: "box-tools pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "collapse",
	      "data-toggle": "tooltip",
	      "title": "Collapse"
	    }
	  }, [_c('i', {
	    staticClass: "ti-minus"
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-box-tool",
	    attrs: {
	      "type": "button",
	      "data-widget": "remove",
	      "data-toggle": "tooltip",
	      "title": "Remove"
	    }
	  }, [_c('i', {
	    staticClass: "ti-close"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-switch', {
	    attrs: {
	      "on-text": "",
	      "off-text": "",
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.value4),
	      callback: function($$v) {
	        _vm.value4 = $$v
	      },
	      expression: "value4"
	    }
	  }), _vm._v(" "), _c('el-switch', {
	    attrs: {
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.value4),
	      callback: function($$v) {
	        _vm.value4 = $$v
	      },
	      expression: "value4"
	    }
	  })], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1264:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.e0d0efb459478aa1399c.js